const translations = {
	validation: {
		required: "This field is required",
		invalidEmail: "Please enter a valid email address",
		formErrors: "Please correct the following errors:",
		minLength: "Must be at least {{min}} characters",
		maxLength: "Must be at most {{max}} characters",
		invalidFormat: "Invalid format",
		invalidDate: "Please enter a valid date",
		invalidNumber: "Please enter a valid number",
		invalidPhone: "Please enter a valid phone number",
		invalidPostalCode: "Please enter a valid postal code",
		invalidBrazilianPostalCode:
			"Please enter a valid Brazilian postal code (CEP)",
		passwordMismatch: "Passwords do not match",
		invalidIdNumber: "Please enter a valid ID number",
		invalidCPF: "Please enter a valid CPF",
		futureDateOfBirth: "Date of birth cannot be in the future",
		idNumberRequired: "ID number is required when ID type is selected",
	},
	common: {
		appName: "Pilates Time",
		loading: "Loading...",
		viewAll: "View All",
		error: "An error occurred",
		save: "Save",
		status: "Status",
		important: "Important",
		createdAt: "Created At",
		saving: "Saving...",
		saveChanges: "Save Changes",
		cancel: "Cancel",
		delete: "Delete",
		deleteSuccess: "Deleted successfully!",
		deleteError: "Failed to delete. Please try again.",
		edit: "Edit",
		create: "Create",
		switch: "Switch",
		createSuccess: "Created successfully!",
		createError: "Failed to create. Please try again.",
		creating: "Creating...",
		update: "Update",
		updateSuccess: "Updated successfully!",
		updateError: "Failed to update. Please try again.",
		updating: "Updating...",
		adding: "Adding...",
		assigning: "Assigning...",
		search: "Search",
		details: "Details",
		noEnrollments: "No enrollments",
		language: "Language",
		minutes: "minutes",
		month: "month",
		actions: "Actions",
		view_enrollment: "View Enrollment",
		open: "Open",
		closed: "Closed",
		close: "Close",
		on: "ON",
		off: "OFF",
		view: "View",
		plan: "Plan",
		editEnrollment: "Edit Enrollment",
		payEnrollment: "Pay Enrollment",
		statusFiltersApplied: "Status Filters Applied",
		upcomingBirthdays: "Upcoming Birthdays",
		clear: "Clear",
		previous: "Previous",
		next: "Next",
		showing: "Showing",
		of: "of",
		entries: "entries",
		page: "Page",
		noSearchResults: "No search results found",
		deleting: "Deleting...",
		back: "Back",
		typeToConfirm: "Type '{{word}}' to confirm:",
		typeWord: "Type '{{word}}'",
		filter: "Filter",
		filters: "Filters",
		apply: "Apply",
		reset: "Reset",
		signIn: "Sign In",
		signUp: "Sign Up",
		dontHaveAccount: "Don't have an account?",
		total: "Total",
		signInRequired: "You must be signed in to view this page",
		signInRequiredDescription: "Please sign in to continue",
		learnMore: "Learn More",
		comingSoon: "Coming soon",
		underDevelopment: "Under Development",
		underDevelopmentDescription:
			"This feature is currently being built. Please check back soon!",
		name: "Name",
		description: "Description",
		quantity: "Qty",
		address: "Address",
		phone: "Phone",
		email: "Email",
		removing: "Removing...",
		sending: "Sending...",
		leaving: "Leaving...",
		revoking: "Revoking...",
		pleaseSpecify: "Please specify...",
		profileInformation: "Profile Information",
		accountInformation: "Account Information",
		viewYourAccountDetails: "View your account details",
		updateYourPersonalInformation: "Update your personal information",
		userId: "User ID",
		memberSince: "Member Since",
		lastSignIn: "Last Sign In",
		never: "Never",
		select: "Select",
		optional: "Optional",
		show: "Show",
		add: "Add",
		hide: "Hide",
		yes: "Yes",
		no: "No",
		continue: "Continue",
		retry: "Retry",
		goHome: "Go Home",
		emailCannotBeChanged: "Email cannot be changed",
		all: "All",
		selectAll: "Select All",
		deselectAll: "Deselect All",
		sortByName: "Sort by Name",
		sortByPrice: "Sort by Price",
		sortBySessions: "Sort by Sessions",
		showingResults: "Showing {{count}} of {{total}} results",
		showMore: "Show More",
		remaining: "remaining",
		remove: "Remove",
		createSchedule: "Create Schedule",
		selectSchedules: "Select Schedules",
		selectSchedulesEnrollmentDescription: "Select one or more schedules",
		existingSchedules: "Existing Schedules",
		noSchedules: "No schedules found",
		noSchedulesDescription: "No schedules found. Create a new one?",
		establishment: "Establishment",
		customer: "Customer",
		group: "Group",
		current: "Current",
		individual: "Individual",
		time: "Schedule",
		renewals: "Renewals",
		enrollments: "Enrollments",
		schedule: "Schedule",
		schedules: "Schedules",
		weeklySessionsLimit: "Weekly Sessions Limit",
		price: "Price",
		monthlyAverage: "Monthly Average",
		billingCycle: "Billing Cycle",
		features: "Features",
		type: "Type",
		period: "Period",
		to: "to",
		monday: "Monday",
		tuesday: "Tuesday",
		wednesday: "Wednesday",
		thursday: "Thursday",
		friday: "Friday",
		saturday: "Saturday",
		sunday: "Sunday",
		daysOfWeekShort: {
			monday: "Mon",
			tuesday: "Tue",
			wednesday: "Wed",
			thursday: "Thu",
			friday: "Fri",
			saturday: "Sat",
			sunday: "Sun",
		},
		starter: "Starter",
		professional: "Professional",
		enterprise: "Enterprise",
		planLimitExceeded:
			"You have reached the limit of your current plan. Please upgrade your plan to continue.",
		template: "Template",
		variables: "Variables",
		noData: "No data available",
		dismiss: "Dismiss",
		selected: "Selected",
		filled: "Filled",

		// Toast messages
		toasts: {
			creating: "Creating...",
			createSuccess: "Created successfully!",
			createError: "Failed to create. Please try again.",
			updating: "Updating...",
			updateSuccess: "Updated successfully!",
			updateError: "Failed to update. Please try again.",
			deleting: "Deleting...",
			deleteSuccess: "Deleted successfully!",
			deleteError: "Failed to delete. Please try again.",
			inviting: "Sending invitation...",
			inviteSuccess: "Invitation sent successfully!",
			inviteError: "Failed to send invitation. Please try again.",
			accepting: "Accepting invitation...",
			acceptSuccess: "Invitation accepted successfully!",
			acceptError: "Failed to accept invitation. Please try again.",
			revoking: "Revoking invitation...",
			revokeSuccess: "Invitation revoked successfully!",
			revokeError: "Failed to revoke invitation. Please try again.",
			establishmentDeleting: "Deleting establishment...",
			establishmentDeleted: "Establishment deleted successfully!",
			establishmentDeleteError:
				"Failed to delete establishment. Please try again.",
			establishmentCreating: "Creating establishment...",
			establishmentCreated: "Establishment created successfully!",
			establishmentCreateError:
				"Failed to create establishment. Please try again.",
			establishmentUpdating: "Updating establishment...",
			establishmentUpdated: "Establishment updated successfully!",
			establishmentUpdateError:
				"Failed to update establishment. Please try again.",
		},
		errors: {
			generic: "An unexpected error occurred. Please try again.",
			network: "Network error. Please check your connection.",
			unauthorized: "You are not authorized to perform this action.",
			forbidden: "Access denied.",
			notFound: "The requested resource was not found.",
			validation: "Please check your input and try again.",
			capacityExceededSchedule: "Schedule is full ({{current}}/{{capacity}}).",
			capacityExceededSession: "Session is full ({{current}}/{{capacity}}).",
		},
	},

	errors: {
		generic: {
			title: "Something went wrong",
			message:
				"An unexpected error occurred. Please try again or contact support if the problem persists.",
		},
		network: {
			title: "Connection Problem",
			message:
				"Unable to connect to the server. Please check your internet connection and try again.",
		},
		notFound: {
			title: "Page Not Found",
			message:
				"The page you're looking for doesn't exist or you don't have permission to view it.",
		},
		forbidden: {
			title: "Access Denied",
			message:
				"You don't have permission to access this resource. Please contact your administrator if you believe this is an error.",
		},
		serverError: {
			title: "Server Error",
			message:
				"The server encountered an error while processing your request. Please try again later.",
		},

		// Staff and permissions
		emailRequired: "Email is required",
		nameRequired: "Name is required",
		inviteSent: "Invitation sent successfully!",
		inviteError: "Error sending invitation. Please try again.",
		noStaffMembers: "No staff members found.",
		roleCreated: "Role created successfully!",
		roleDeleted: "Role deleted successfully!",
		createRoleError: "Error creating role. Please try again.",
		deleteRoleError: "Error deleting role. Please try again.",
		send: "Send",
		createdAt: "Created At",
		updatedAt: "Updated At",
		expiresAt: "Expires",

		days: {
			monday: "Monday",
			tuesday: "Tuesday",
			wednesday: "Wednesday",
			thursday: "Thursday",
			friday: "Friday",
			saturday: "Saturday",
			sunday: "Sunday",
		},
	},

	// Pagination
	pagination: {
		noItems: "No items to display",
		showingItems: "Showing {{start}} to {{end}} of {{total}} items",
		itemsPerPage: "Items per page",
		pageOfTotal: "Page {{page}} of {{total}}",
		firstPage: "Go to first page",
		previousPage: "Go to previous page",
		nextPage: "Go to next page",
		lastPage: "Go to last page",
	},

	organization: {
		loading: "Loading organizations...",
		select: "Select Organization",
		selectTitle: "Select an Organization",
		selectDescription: "Choose an organization to continue",
		switchOrganization: "Switch Organization",
		viewDashboard: "View dashboard",
		create: "Create Organization",
		description: "Description",
		descriptionPlaceholder: "Enter a description for your organization",
		noDescription: "No description",
		createNew: "Create organization",
		createDescription:
			"Set up a new studio business in PilatesTime — its own team, records, and plan.",
		createExplainer: {
			title: "Before you continue",
			definition:
				"Think of an organization as your studio business inside PilatesTime.",
			contents:
				"It's where everything about that business lives: schedules, clients, staff, and billing.",
			rule: "It doesn't matter whether you run one location or several. As long as they all belong to the same business, they should live inside the same organization.",
			newOrgWhen:
				"So create a new organization only if you run separate businesses, with distinct teams and books.",
			newOrgWhenNot:
				"If you're just adding another location to a business you already have, keep it inside the current organization.",
		},
		nameHelp: "You can change this later in your studio settings.",
		descriptionHelp: "Optional — a short note about this studio.",
		currency: {
			label: "Default currency",
			placeholder: "Select a currency",
			brl: "Brazilian Real (BRL)",
			usd: "US Dollar (USD)",
			warning:
				"This will be the default currency for billing and financial operations. You can't change it after the studio is created.",
		},
		createSuccess: "Organization created successfully!",
		basicInformation: "Basic Information",
		updateTitle: "Update Organization",
		updateDescription: "Update the name of your organization",
		updateSuccess: "Organization updated successfully!",
		autoCreatedDescription: "Organization created automatically for new user",
		notFound: "Organization Not Found",
		notFoundDescription:
			"The organization you're looking for doesn't exist or you don't have access to it.",
		createdOn: "Created on {{date}}",
		yourRole: "Your Role",
		yourRoleDescription: "Your role in this organization",
		members: "Members",
		membersDescription: "Total organization members",
		totalMembers: "total members",
		establishments: "Establishments",
		establishmentsDescription: "Organization establishments",
		totalEstablishments: "total establishments",
		quickActions: "Quick Actions",
		updateError: "Failed to update organization. Please try again.",
		clickToEdit: "Click to edit organization",
		name: "Organization Name",
		namePlaceholder: "My Organization",
		nameRequired: "Organization name is required",
		createError: "Failed to create organization. Please try again.",
		managementDescription: "Manage your organizations and create new ones.",
		noOrganizations:
			"You don't have any organizations yet. Create one to get started.",
		noOrganizationsDescription:
			"Create your first organization to get started with managing your Pilates studio.",
		createFirst: "Create Your First Organization",
		current: "Current",
		toasts: {
			creating: "Creating organization...",
			createSuccess: "Organization created successfully!",
			createError: "Failed to create organization. Please try again.",
			updating: "Updating organization...",
			updateSuccess: "Organization updated successfully!",
			updateError: "Failed to update organization. Please try again.",
			deleting: "Deleting organization...",
			deleteSuccess: "Organization deleted successfully!",
			deleteError: "Failed to delete organization. Please try again.",
		},
		// Leave organization functionality
		leave: "Leave",
		leaveOrganization: "Leave Organization",
		leaveConfirmation:
			"Are you sure you want to leave {{name}}? This action cannot be undone.",
		ownerLeaveWarning:
			"As an owner, you cannot leave if you are the only owner. Please transfer ownership to another member first.",
		confirmNameToLeave: "Type the organization name to confirm",
		typeOrgNameToConfirm:
			"Type the exact organization name above to confirm leaving",
		inactive: {
			title: "Organization Inactive",
			description:
				"This organization does not have an active subscription. To continue using all features, please activate or renew your subscription.",
			noSubscription: {
				title: "Choose Your Plan",
				description:
					"Choose the plan that best fits your needs and start managing your studio today.",
			},
			pastDue: {
				title: "Payment Past Due",
				description:
					"Your subscription payment is past due. Please update your payment method to continue using the platform.",
			},
			paused: {
				title: "Subscription Paused",
				description:
					"Your subscription is currently paused. Resume your subscription to continue using all features.",
			},
			canceled: {
				title: "Subscription Canceled",
				description:
					"Your subscription has been canceled. Reactivate your subscription to continue using the platform.",
			},
			manageBilling: "Manage Subscription",
			contactSupport: "Contact Support",
			backToOrganizationSelection: "Back to organization selection",
		},
	},
	renewSubscription: {
		title: "Renew Subscription",
		choosePlanDescription: "Choose the plan that best fits your needs.",
	},
	onboarding: {
		stepOf: "Step {{current}} of {{total}}",
		choosePlan: "Choose Plan",
		welcome: {
			title: "Congratulations! 🎉",
			created: "has been created successfully!",
			description:
				"You're just a few steps away from managing your Pilates studio like a pro. Let's get you started!",
		},
		features: {
			title: "Everything You Need",
			description: "Powerful tools to manage every aspect of your studio",
			items: {
				customers: {
					title: "Manage Customers",
					description: "Track profiles, plans, and history",
				},
				schedules: {
					title: "Class Schedules",
					description: "Create and manage class timetables",
				},
				enrollments: {
					title: "Enrollments",
					description: "Enroll students in classes easily",
				},
				attendance: {
					title: "Attendance",
					description: "Track check-ins and class attendance",
				},
				staff: {
					title: "Staff Management",
					description: "Invite and manage your team",
				},
				dashboard: {
					title: "Dashboard",
					description: "Monitor your studio at a glance",
				},
			},
		},
		plan: {
			title: "Almost There!",
			description:
				"We'll now take you to the plan selection page where you can choose the best plan for your studio.",
			trialTitle: "Free Trial Included",
			trialDescription:
				"You can try our free trial. You can cancel anytime during the trial period and you won't be charged.",
		},
	},
	theme: {
		select: "Select Theme",
		title: "Theme",
		light: "Light",
		dark: "Dark",
	},
	auth: {
		signIn: "Sign In",
		signOut: "Sign Out",
		signUp: "Sign Up",
		firstName: "First Name",
		lastName: "Last Name",
		signInRequired: "You must be signed in to view this page",
	},
	navigation: {
		home: "Home",
		about: "About",
		pricing: "Pricing",
		privacyPolicy: "Privacy Policy",
		customers: "Customers",
		schedule: "Schedule",
		schedules: "Schedules",
		enrollment: "Enrollment",
		attendance: "Attendance",
		payments: "Payments",
		medicalRecords: "Medical Records",
		registrations: "Registrations",
		events: "Events",
		birthdayEvents: "Birthday Events",
		enrollmentExpiryEvents: "Enrollment Expiry Events",
		paymentReminderEvents: "Payment Reminder Events",
		dashboard: "Dashboard",
		billing: "Billing",
		orgManagement: "Organization Management",
		settings: "Organization Settings",
		startNow: "Start now",
		accessApp: "Access App",
		help: "Help",
		openMenu: "Open navigation menu",
		closeMenu: "Close navigation menu",
		moreOptions: "More options",
		more: "More",
		account: "Account",
	},
	more: {
		title: "More",
		openProfileSettings: "Open profile settings",
		preferences: "Preferences",
		notifications: "Notifications",
		notificationsHint: "Show alerts on this device",
		accountStudio: "Account & studio",
	},
	home: {
		welcome: "Welcome to {{appName}}",
		version: "Version",
	},
	pricing: {
		badge: "Customized Plans",
		title: "Plans Tailored to Your Studio",
		subtitle:
			"We believe every Pilates studio is unique. That's why we create customized plans that fit your specific needs and budget.",
		benefitsTitle: "What You Get",
		benefits: [
			"Complete studio management",
			"Unlimited students and enrollments",
			"Scheduling and attendance tracking",
			"Financial reports and analytics",
			"Dedicated support team",
			"Regular updates and new features",
		],
		contactTitle: "Talk to Our Team",
		contactDescription:
			"Get a personalized quote for your studio. Our team will understand your needs and propose the best solution.",
		emailSales: "Email Sales",
		whatsappSales: "Chat on WhatsApp",
		responseTime: "We typically respond within 24 hours",
		faqTitle: "Have Questions?",
		faqDescription:
			"Our team is ready to answer any questions about features, pricing, or implementation.",
		contactUs: "Contact us",
		getStarted: "Get Started",
	},
	privacy: {
		title: "Privacy Policy",
		lastUpdated: "Last updated",
		sections: {
			introduction: {
				title: "Introduction",
				content:
					"At Pilates Time, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Pilates studio management platform. By using our services, you consent to the practices described in this policy.",
			},
			legalBasis: {
				title: "Legal Basis for Processing",
				content:
					"We process your personal data based on the following legal grounds:",
				bases: [
					"Contract performance: Managing your studio membership and services",
					"Legitimate interest: Improving our services and platform security",
					"Explicit consent: Processing health and medical information",
					"Legal obligation: Compliance with tax and regulatory requirements",
				],
			},
			dataCollection: {
				title: "Information We Collect",
				content:
					"We collect various types of information to provide and improve our services:",
				personalData: {
					title: "Personal Information",
					items: [
						"Name, email address, and phone number",
						"Billing and payment information",
						"Profile information and preferences",
						"Communication preferences and history",
						"Account credentials and authentication data",
					],
				},
				healthData: {
					title: "Health and Medical Information (Special Category Data)",
					items: [
						"Medical history and health conditions",
						"Physical limitations and injuries",
						"Fitness goals and preferences",
						"Anamnesis forms and health assessments",
						"Progress tracking and session notes",
					],
					specialProtections: {
						title: "Enhanced Protections for Health Data",
						content:
							"Health information receives special protection under data protection laws:",
						protections: [
							"We process health data only with your explicit consent",
							"Health data is used solely for fitness assessment and program customization",
							"You may withdraw consent for health data processing at any time",
							"Health data is subject to enhanced security measures and access controls",
							"We do not use health data for marketing or non-health related purposes",
							"Health data is encrypted both in transit and at rest",
							"Access to health data is limited to authorized personnel only",
						],
					},
				},
				usageData: {
					title: "Usage and Technical Data",
					items: [
						"Device information and IP address",
						"Browser type and operating system",
						"Usage patterns and feature interactions",
						"Session data and attendance records",
						"Performance metrics and analytics",
					],
				},
			},
			dataUse: {
				title: "How We Use Your Information",
				content: "We use the collected information for the following purposes:",
				purposes: [
					"Providing and maintaining our Pilates studio management services",
					"Processing payments and managing billing",
					"Scheduling classes and managing appointments",
					"Tracking attendance and progress",
					"Communicating with you about your account and services",
					"Sending important updates and notifications",
					"Improving our platform and developing new features",
					"Ensuring platform security and preventing fraud",
					"Complying with legal obligations and regulations",
				],
			},
			dataRetention: {
				title: "Data Retention and Deletion",
				content:
					"We retain your personal data only as long as necessary for the purposes outlined in this policy:",
				periods: [
					"Account information: Retained while account is active plus 3 years",
					"Health records: Retained for 7 years after last session (regulatory requirement)",
					"Payment data: Retained for 7 years for tax compliance purposes",
					"Marketing data: Retained until consent is withdrawn",
					"Technical logs: Retained for 12 months for security purposes",
					"Session recordings (if any): Retained for 30 days unless saved by user",
				],
				criteria: {
					title: "Deletion Criteria",
					content: "Data is automatically deleted when:",
					conditions: [
						"Retention period expires and no legal obligation requires further storage",
						"You request deletion and we can legally comply",
						"Your account is terminated and retention period has passed",
						"Consent is withdrawn and no other legal basis applies",
						"Data is no longer necessary for the original purpose",
					],
				},
			},
			dataSharing: {
				title: "Information Sharing and Disclosure",
				content:
					"We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:",
				cases: [
					"With your explicit consent",
					"With payment processors to handle transactions securely",
					"With service providers who assist in platform operations",
					"When required by law or legal process",
					"To protect our rights, property, or safety",
					"In connection with a business transfer or acquisition",
				],
			},
			internationalTransfers: {
				title: "International Data Transfers",
				content:
					"Your data may be processed outside your country of residence:",
				details: [
					"Data may be processed in Brazil, United States, and European Union",
					"We use Standard Contractual Clauses (SCCs) for EU data transfers",
					"Cloud providers comply with applicable data protection frameworks",
					"We ensure adequate level of protection for all international transfers",
					"Transfer impact assessments conducted for high-risk jurisdictions",
				],
				safeguards: {
					title: "Transfer Safeguards",
					measures: [
						"Adequacy decisions where available",
						"Standard Contractual Clauses (SCCs)",
						"Binding Corporate Rules for group companies",
						"Certification schemes and codes of conduct",
						"Additional technical and organizational measures",
					],
				},
			},
			dataSecurity: {
				title: "Data Security",
				content:
					"We implement industry-standard security measures to protect your information:",
				measures: [
					"Encryption of data in transit and at rest",
					"Secure authentication and access controls",
					"Regular security audits and monitoring",
					"Secure data centers and infrastructure",
					"Employee training on data protection",
					"Incident response and breach notification procedures",
				],
			},
			userRights: {
				title: "Your Rights and Choices",
				content:
					"Your rights vary depending on your location and applicable data protection laws:",
				rights: [
					"Access and review your personal data",
					"Request correction of inaccurate information",
					"Request deletion of your data (subject to legal requirements)",
					"Opt-out of marketing communications",
					"Request data portability",
					"Withdraw consent where applicable",
					"File complaints with relevant authorities",
				],
				gdprRights: {
					title: "GDPR Rights (EU Residents)",
					rights: [
						"Right to access your personal data and processing information",
						"Right to rectification of inaccurate or incomplete data",
						"Right to erasure (right to be forgotten) in certain circumstances",
						"Right to restriction of processing in specific situations",
						"Right to data portability in machine-readable format",
						"Right to object to processing based on legitimate interests",
						"Right to withdraw consent at any time",
						"Right not to be subject to automated decision-making",
						"Right to lodge complaints with supervisory authorities",
					],
				},
				lgpdRights: {
					title: "LGPD Rights (Brazil Residents)",
					rights: [
						"Right to confirmation of existence of personal data processing",
						"Right to access your personal data",
						"Right to correction of incomplete, inaccurate, or outdated data",
						"Right to anonymization, blocking, or deletion of data",
						"Right to data portability to another service provider",
						"Right to information about data sharing with third parties",
						"Right to withdraw consent and be informed of consequences",
						"Right to review automated decisions that affect you",
					],
				},
				ccpaRights: {
					title: "CCPA Rights (California Residents)",
					rights: [
						"Right to know what personal information is collected about you",
						"Right to know whether personal information is sold or disclosed",
						"Right to say no to the sale of personal information",
						"Right to access your personal information",
						"Right to equal service and price, even if you exercise privacy rights",
						"Right to delete personal information",
					],
				},
				exercisingRights: {
					title: "How to Exercise Your Rights",
					content: "To exercise any of these rights:",
					steps: [
						"Contact us using the information provided in this policy",
						"Provide sufficient information to verify your identity",
						"Specify which right you wish to exercise",
						"We will respond within the legally required timeframe",
						"You may appeal our decision if you disagree with our response",
					],
				},
			},
			childrensPrivacy: {
				title: "Children's Privacy",
				content: "We are committed to protecting the privacy of children:",
				policies: [
					"Our services are not intended for children under 16 years of age",
					"We do not knowingly collect personal data from children under 16",
					"Parental consent is required for users aged 13-16 in applicable jurisdictions",
					"Parents may request access to or deletion of their child's data",
					"Special protections apply to any minor's health information",
					"We will delete any child's data if we become aware it was collected without proper consent",
				],
				parentalRights: {
					title: "Parental Rights",
					rights: [
						"Review any personal data we have collected from your child",
						"Request deletion of your child's personal data",
						"Refuse to allow further collection of your child's data",
						"Request that we stop using your child's data",
					],
				},
			},
			automatedDecisionMaking: {
				title: "Automated Decision Making and Profiling",
				content: "Information about automated processing in our services:",
				details: [
					"We may use automated systems for scheduling optimization and recommendations",
					"No solely automated decisions are made that significantly affect you",
					"You have the right to human review of any automated decisions",
					"AI features are used only to enhance user experience, not replace human judgment",
					"You can opt-out of automated processing where technically feasible",
				],
				profiling: {
					title: "Profiling Activities",
					activities: [
						"Fitness progress tracking and goal recommendations",
						"Class scheduling optimization based on preferences",
						"Personalized exercise suggestions based on health data",
						"Risk assessment for injury prevention",
					],
				},
			},
			consentManagement: {
				title: "Consent Management",
				content: "How we obtain and manage your consent:",
				principles: [
					"Consent is freely given, specific, informed, and unambiguous",
					"You may withdraw consent at any time through account settings",
					"Withdrawal does not affect lawfulness of prior processing",
					"Some services may be unavailable if consent is withdrawn",
					"Separate consent is required for marketing communications",
					"We maintain records of when and how consent was obtained",
				],
				withdrawal: {
					title: "How to Withdraw Consent",
					methods: [
						"Through your account settings and privacy preferences",
						"By contacting our data protection team directly",
						"Using unsubscribe links in marketing communications",
						"Through our mobile app privacy settings",
					],
				},
			},
			breachNotification: {
				title: "Data Breach Notification",
				content: "Our procedures for handling data security incidents:",
				procedures: [
					"High-risk breaches: Users notified within 72 hours of discovery",
					"Notification includes nature of breach, data involved, and steps taken",
					"Supervisory authorities notified within 72 hours where required by law",
					"Regular security assessments and incident response testing",
					"Immediate containment and investigation of any suspected breach",
				],
				userNotification: {
					title: "What We Tell You",
					information: [
						"Description of what happened and when we discovered it",
						"Types of personal data that were involved",
						"Steps we have taken to address the breach",
						"Recommendations for protecting yourself",
						"How to contact us for more information",
					],
				},
			},
			cookies: {
				title: "Cookies and Tracking Technologies",
				content:
					"We use cookies and similar technologies to enhance your experience, analyze usage patterns, and improve our services. You can control cookie preferences through your browser settings, though some features may not function properly if cookies are disabled.",
			},
			contact: {
				title: "Data Protection Contacts",
				content:
					"For privacy-related questions and requests, please contact: suporte@pilatestime.com.br",
			},
			updates: {
				title: "Policy Updates",
				content:
					"We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. We will notify you of significant changes through the platform or via email. Your continued use of our services after such modifications constitutes acceptance of the updated policy.",
			},
		},
	},
	customers: {
		searchPlaceholder: "Search customer",
		title: "Customers",
		addCustomer: "Add Customer",
		addCustomerDescription: "Enter customer details to create a new record",
		editCustomer: "Edit Customer",
		editCustomerDescription: "Update customer information",
		importCustomers: "Import Customers",
		management: {
			title: "Customers",
			description: "Manage your organization's customers",
			noCustomers: "No Customers",
			noCustomersDescription: "You haven't created any customers yet",
			noCustomersSearchDescription: "No customers found matching your search",
			createFirst: "Create Your First Customer",
		},
		form: {
			subtitle:
				"Only the name and contact are required. The rest can be filled in later.",
			optional: "optional",
			recommended: "recommended",
			counter: "{{current}}/{{max}}",
			ageYears: "{{age}} years",
			internalNotes: "Internal notes",
			internalNotesHint: "Visible to the team only.",
			emailHint: "Used for the access invitation and receipts.",
			emailInvalid: "Incomplete address — the domain is missing.",
			cepEmptyHint: "Fill in the postal code first to speed up the address.",
			cepCompleteHint: "Postal code complete. Check the street below.",
			cepLoading: "Looking up the address…",
			statusActiveHint: "The customer shows up in lists and can be enrolled.",
			statusInactiveHint: "The customer is kept on file but hidden from lists.",
			statusOtherHint: "Currently {{status}}. Turn on to activate.",
			sections: {
				person: "Person",
				address: "Address",
				emergencyContact: "Emergency contact",
				notes: "Notes",
			},
			genders: {
				FEMALE: "Female",
				MALE: "Male",
				OTHER: "Other",
				PREFER_NOT_TO_SAY: "Prefer not to say",
			},
			idTypes: {
				CPF: "CPF",
				RG: "RG",
				PASSPORT: "Passport",
			},
			placeholders: {
				firstName: "Ana",
				lastName: "Ribeiro",
				email: "ana@email.com",
				phone: "(11) 98888-7777",
				profession: "Architect",
				address: "Av. Paulista",
				apartment: "Apt 72",
				city: "São Paulo",
				emergencyName: "Marcos Ribeiro",
				notes:
					"Right knee injury, avoid impact. Prefers to train in the morning.",
			},
		},
		cepLookupError: "Could not find address for this postal code",
		table: {
			customer: "Customer",
			name: "Name",
			idType: "ID Type",
			idNumber: "ID Number",
			email: "Email",
			phone: "Phone",
			createdAt: "Created At",
			actions: "Actions",
		},
		sections: {
			personalInfo: "Personal Information",
			personalInfoDescription: "Basic personal information about the customer",
			identification: "Identification",
			contactDetails: "Contact Details",
			contactInfo: "Contact Information",
			contactInfoDescription: "Contact details and address information",
			address: "Address",
			emergencyContact: "Emergency Contact",
			emergencyContactDescription: "Emergency contact information",
			professionalAndNotes: "Professional & Notes",
			additionalInfo: "Additional Information",
			additionalInfoDescription: "Additional notes and status information",
		},
		fields: {
			fullName: "Full Name",
			firstName: "First Name",
			lastName: "Last Name",
			dateOfBirth: "Date of Birth",
			gender: "Gender",
			country: "Country",
			idType: "ID Type",
			idNumber: "ID Number",
			email: "Email",
			phone: "Phone",
			address: "Street Address",
			number: "Number",
			apartment: "Apartment/Suite",
			neighborhood: "Neighborhood/District",
			city: "City",
			state: "State/Province",
			zipCode: "Postal Code",
			postalCode: "Postal Code",
			profession: "Profession",
			emergencyContactName: "Emergency Contact Name",
			emergencyContactPhone: "Emergency Contact Phone",
			notes: "Notes",
			isWhatsapp: "WhatsApp",
			date: "Date",
			recordType: "Record Type",
			title: "Title",
			description: "Description",
			status: "Status",
		},
		placeholders: {
			selectGender: "Select gender",
			selectCountry: "Select country",
			selectIdType: "Select ID type",
			selectRecordType: "Select record type",
		},
		genders: {
			male: "Male",
			female: "Female",
			other: "Other",
			preferNotToSay: "Prefer not to say",
		},
		idTypes: {
			US: {
				ssn: "Social Security Number",
				driversLicense: "Driver's License",
				passport: "Passport",
				stateId: "State ID",
			},
			BR: {
				cpf: "CPF",
				rg: "RG",
				passport: "Passport",
				cnh: "Driver's License (CNH)",
			},
			IN: {
				aadhaar: "Aadhaar",
				pan: "PAN",
				passport: "Passport",
				voterID: "Voter ID",
				drivingLicense: "Driving License",
			},
			default: {
				nationalID: "National ID",
				passport: "Passport",
				drivingLicense: "Driving License",
			},
		},
		status: "Status",
		noCustomersFound: "No customers found",
		allStatuses: "All Statuses",
		statuses: {
			active: "Active",
			inactive: "Inactive",
			pending: "Pending",
			deleted: "Deleted",
			purged: "Purged",
		},
		createCustomer: "Create Customer",
		createAndEnroll: "Create and Enroll",
		deleteCustomer: "Delete Customer",
		deleteConfirmation: "Are you sure you want to delete this customer?",
		createSuccess: "Customer created successfully!",
		updateSuccess: "Customer updated successfully!",
		deleteSuccess: "Customer deleted successfully!",
		createError: "Failed to create customer. Please try again.",
		updateError: "Failed to update customer. Please try again.",
		deleteError: "Failed to delete customer. Please try again.",
		toasts: {
			creating: "Creating customer...",
			createSuccess: "Customer created successfully!",
			createError: "Failed to create customer. Please try again.",
			updating: "Updating customer...",
			updateSuccess: "Customer updated successfully!",
			updateError: "Failed to update customer. Please try again.",
			deleting: "Deleting customer...",
			deleteSuccess: "Customer deleted successfully!",
			deleteError: "Failed to delete customer. Please try again.",
		},
		addressLookup: {
			lookupSuccess: "Address information found and filled automatically",
			lookupError: "Could not find address information for this postal code",
			lookupInProgress: "Looking up address information...",
			enterValidPostalCode:
				"Enter a valid postal code to look up address information",
		},

		// Customer details page
		profileInformation: "Profile Information",
		customerNotFound: "Customer not found",
		accessDenied: "You don't have permission to access the customers page.",
		noNotes: "No notes available",
		tabs: {
			profile: "Profile",
			registration: "Registration",
			medicalRecords: "Medical Records",
			enrollments: "Enrollments",
			payments: "Payments",
			sessions: "Sessions",
		},
		sessions: {
			title: "Customer Sessions",
			description: "View all upcoming sessions for this customer",
			empty: {
				title: "No Upcoming Sessions",
				description: "This customer has no upcoming sessions scheduled.",
			},
			table: {
				sessionName: "Session Name",
				date: "Date",
				startTime: "Start Time",
				endTime: "End Time",
				staffMember: "Instructor",
				actions: "Actions",
			},
			viewSession: "View Session",
		},
		customerDetails: "Customer Details",

		// Overview
		overview: {
			title: "Overview",
			customerInformation: "Customer Information",
			customerInformationDescription:
				"Basic customer details and contact information",
			basicInformation: "Basic Information",
			contactInformation: "Contact Information",
			statusAndStats: "Status & Statistics",
			totalEnrollments: "Total Enrollments",
			activeEnrollments: "Active Enrollments",
			overdueInvoices: "Overdue Invoices",
			recentMedicalRecords: "Recent Medical Records",
			recentMedicalRecordsDescription:
				"Latest medical records and health information",
			activeEnrollmentsTitle: "Active Enrollments",
			activeEnrollmentsDescription:
				"Current active enrollments and subscriptions",
			noActiveEnrollments: "No active enrollments",
			importantAlerts: "Important Alerts",
			pendingInvoices: "Pending Invoices",
			pendingPayments: "Pending Payments",
			noOutstandingPayments: "No outstanding payments",
			dueDate: "Due",
			pay: "Pay",
			enrollmentsSummary: "Enrollments Summary",
			noEnrollments: "No enrollments yet",
			active: "Active",
			pendingPayment: "Pending Payment",
			other: "Other",
			quickActions: {
				newEnrollment: "Enrollment",
				createInvoice: "Sale",
				scheduleSingleSession: "Session",
			},
		},

		// Single Session Modal (Trial, Reposition, One Time Session)
		singleSession: {
			title: "Schedule Single Session",
			description: "Schedule a single session for {{customerName}}",
			defaultName: "Single Session",
			fields: {
				name: "Session Name",
				establishment: "Establishment",
				staffMember: "Staff Member",
				sessionDate: "Session Date",
				startTime: "Start Time",
				endTime: "End Time",
				sessionType: "Session Type",
				notes: "Notes",
			},
			sessionTypes: {
				trial: "Trial",
				reposition: "Reposition",
				oneTimeSession: "One Time Session",
			},
			selectEstablishment: "Select an establishment",
			selectStaffMember: "Select a staff member",
			selectSessionType: "Select session type",
			notesPlaceholder: "Add any notes about this session...",
			schedule: "Schedule Session",
			scheduling: "Scheduling...",
			toasts: {
				scheduling: "Scheduling session...",
				success: "Session scheduled successfully",
				error: "Failed to schedule session",
			},
		},

		// Navigation
		navigation: {
			title: "Customer Details",
			description: "Manage customer information and records",
			editDescription: "Edit customer profile and personal information",
			medicalRecordsDescription:
				"View and manage medical records and health information",
			enrollmentsDescription:
				"View and manage customer enrollments and subscriptions",
			unknownCustomer: "Unknown Customer",
			customerdata: "Customer Data",
		},

		// Medical records
		medicalRecords: {
			title: "Medical Records",
			description: "View and manage medical records for this customer",
			addRecord: "Add Record",
			noRecords: "No medical records found",
			noRecordsDescription:
				"Start building a comprehensive medical history by adding the first record for this customer.",
		},
		recordTypes: {
			evaluation: "Evaluation",
			progress: "Progress",
			treatment: "Treatment",
			other: "Other",
		},

		// Customer enrollments
		customerEnrollments: "Customer Enrollments",
		noEnrollments: "No enrollments found",
		noEnrollmentsDescription:
			"This customer is not enrolled in any schedules yet.",
		enrollmentDetails: "Enrollment Details",

		// Customer payments
		customerPayments: "Customer Payments",
		noPayments: "No payments found",
		noPaymentsDescription: "This customer doesn't have any payments yet.",
		paymentHistory: "Payment History",
	},
	schedules: {
		navigation: {
			unknownInstructor: "Unknown Instructor",
			scheduleId: "Schedule ID",
			copyId: "Copy schedule ID",
			idCopied: "Schedule ID copied",
		},
		type: {
			group: "Group",
			individual: "Individual",
		},
		noDaysSelected: "No days selected",
		everyDay: "Every day",
		capacity: "Capacity",
		instructor: "Instructor",
		management: {
			title: "Schedule Management",
			description: "Manage your class schedules and sessions",
			createNew: "Create New Schedule",
			createNewShort: "New",
			createFirst: "Create Your First Schedule",
			list: {
				title: "Schedules",
				description: "View and manage all your schedules",
			},
			empty: {
				title: "No schedules yet",
				description:
					"Create your first schedule to get started with managing your classes and sessions.",
			},
			table: {
				label: "Class",
				type: "Type",
				establishment: "Establishment",
				staffMember: "Staff Member",
				time: "Time",
				recurrency: "Recurrency",
				capacity: "Capacity",
				status: "Status",
				actions: "Actions",
				maxCapacity_one: "Max. {{count}} person",
				maxCapacity_other: "Max. {{count}} people",
				individual: "Individual",
				active: "Active",
				inactive: "Inactive",
				archived: "Archived",
				enrolling: "Enrolling",
				noSessions: "No sessions",
				edit: "Edit",
				delete: "Delete",
			},
			deleteConfirmation: {
				title: "Delete Schedule",
				message:
					"Are you sure you want to delete this schedule? This action cannot be undone.",
				confirm: "Delete",
				deleting: "Deleting...",
				cancel: "Cancel",
			},
			deletion: {
				title: "Delete Schedule",
				descriptionNoEnrollments:
					"Are you sure you want to delete this schedule? This action cannot be undone.",
				descriptionWithEnrollments:
					"This schedule has enrolled customers. Please choose how to proceed.",
				scheduleInfo: "Schedule Information",
				enrollmentsWarning: "Enrolled Customers Warning",
				enrollmentsCount:
					"This schedule has {{count}} enrolled customer(s). If you delete this schedule, it will also be removed from the related enrollments. Please update the customer enrollments before deleting this schedule.",
				enrolledCustomers: "Enrolled customers",
				andMore: "and {{count}} more...",
				deleteAnyway: "Delete Anyway",
				deleting: "Deleting schedule...",
				errorLoadingEnrollments:
					"Failed to load enrollment information. Please try again.",
				deleteBlocked:
					"Deletion is blocked: this schedule still has {{count}} active enrollment(s). Archive it instead, or move/cancel these enrollments first.",
				countsBreakdown:
					"{{active}} active · {{pending}} pending · {{paused}} paused",
			},
			archive: {
				title: "Archive or Delete Schedule",
				description:
					"Archiving keeps the schedule and its history but removes it from active use. Deletion is permanent and only available when there are no active enrollments.",
				sectionTitle: "Archive this schedule",
				sectionDescription:
					"The schedule is hidden from active lists but its records are preserved. You can unarchive it later.",
				cancelFutureSessions: "Cancel future sessions",
				archive: "Archive",
				archiving: "Archiving...",
			},
			unarchive: {
				title: "Unarchive or Delete Schedule",
				description:
					"This schedule is archived. Unarchive it to return it to active use, or delete it permanently when there are no active enrollments.",
				sectionTitle: "Unarchive this schedule",
				sectionDescription:
					"The schedule returns to active lists. Future sessions are not regenerated automatically — use the Sessions tab to generate them if needed.",
				unarchive: "Unarchive",
				unarchiving: "Unarchiving...",
			},
			resolution: {
				title: "Resolve enrollments",
				description:
					"Choose what happens to each enrolled customer. The schedule is archived and every change is applied together in a single step.",
				applyToAllLabel: "Apply one action to everyone",
				applyToAllApply: "Apply to all",
				actionPlaceholder: "Select an action",
				actionMove: "Move to another schedule",
				actionCancel: "Cancel enrollment",
				actionPause: "Pause enrollment",
				statusActive: "Active",
				statusPending: "Pending",
				targetLabel: "Target schedule",
				targetPlaceholder: "Select a compatible schedule",
				noTargets:
					"No compatible active schedule available. Create one first or cancel the enrollments instead.",
				errorLoadingTargets:
					"Failed to load target schedules. Please try again.",
				conflict: {
					UNRESOLVED_ENROLLMENT: "This customer still needs an action.",
					UNKNOWN_ENROLLMENT:
						"This customer no longer needs resolving. Refresh and try again.",
					PENDING_CANNOT_PAUSE:
						"Pending enrollments can't be paused. Move or cancel instead.",
					INVALID_TARGET: "Pick a different active schedule of the same type.",
					CAPACITY_EXCEEDED: "The chosen schedule is full. Pick another.",
				},
				errorGeneric: "Could not archive the schedule. Please try again.",
			},
			filters: {
				searchPlaceholder:
					"Search by description, instructor, or establishment...",
				filterByType: "Type",
				filterByStatus: "Status",
				filterByStaff: "Instructor",
				allTypes: "All types",
				allStatuses: "All statuses",
				allStaff: "All instructors",
				group: "Group",
				individual: "Individual",
				active: "Active",
				inactive: "Inactive",
				archived: "Archived",
				enrolling: "Enrolling",
				activeAndInactive: "Active & Inactive",
				selectedCount: "{{count}} selected",
				enrollments: "Enrollments",
				enrollmentsActive: "{{count}} active",
				enrollmentsPending: "{{count}} pending",
			},
		},
		details: {
			title: "Schedule Details",
			description: "View and manage schedule information",
			tabs: {
				edit: "Edit",
				sessions: "Sessions",
				enrollments: "Enrollments",
			},
		},
		form: {
			create: {
				title: "Create New Schedule",
				description: "Set up a new class or session schedule",
			},
			edit: {
				title: "Edit Schedule",
				description: "Update the schedule details and settings",
			},
			details: {
				title: "Schedule Details",
				description: "Configure the basic information for your schedule",
			},
			sections: {
				basicInfo: "Basic Information",
				basicInfoDescription: "Configure the basic details for your schedule",
				locationStaff: "Location & Staff",
				locationStaffDescription:
					"Select the establishment and staff member for this schedule",
				scheduleSettings: "Schedule Settings",
				scheduleSettingsDescription:
					"Configure timing, capacity, and date settings",
				recurrencyConfig: "Recurrency & Configuration",
				recurrencyConfigDescription:
					"Set up recurrence pattern and additional notes",
				classDetails: "Class Details",
				classDetailsDescription: "Type, location, staff, and capacity",
				timeAndRecurrence: "Time & Recurrence",
				timeAndRecurrenceDescription:
					"Schedule timing, recurrence pattern, and dates",
			},
			fields: {
				description: "Description",
				type: "Schedule Type",
				typeEditDisabled:
					"Schedule type cannot be changed after schedule creation",
				establishment: "Establishment",
				establishmentEditDisabled:
					"Establishment cannot be changed after schedule creation",
				staffMember: "Staff Member",
				capacity: "Capacity",
				startTime: "Start Time",
				endTime: "End Time",
				duration: "Duration",
				startDate: "Start Date",
				startDateEditDisabled:
					"Start date cannot be changed after schedule creation",
				endDate: "End Date",
				recurrencyType: "Recurrency Type",
				recurrencyTypeEditDisabled:
					"Recurrency type cannot be changed after schedule creation",
				daysOfWeek: "Days of Week",
				notes: "Notes",
				repeats: "Repeats",
				days: "Days",
				starts: "Starts",
				ends: "Ends",
				firstDate: "First date",
				lastDate: "Last date",
			},
			subtitle: "Set what the class is, then when it repeats.",
			optionalQualifier: "optional",
			capacityHint: "Bookings stop once the class is full.",
			decrementCapacity: "Decrease capacity",
			incrementCapacity: "Increase capacity",
			notesHint: "Shown to staff and to clients who book.",
			notesCounter: "{{current}}/{{max}}",
			durationInvalid: "invalid",
			durationPresetsLabel: "Duration presets",
			durationPresets: {
				"30": "30m",
				"45": "45m",
				"60": "1h",
				"90": "1h 30m",
			},
			blocker: {
				establishment: "Pick an establishment to continue.",
				staff: "Pick a staff member to continue.",
				days: "Pick at least one day of the week.",
				endDate: "Set a last date after the first date.",
				endTime: "The end time must be after the start time.",
			},
			summary: {
				once: "Once on {{date}}",
				every: "Every {{days}}",
				time: "{{start}}–{{end}} ({{duration}})",
				range: "from {{start}} to {{end}}",
				who: "{{staff}} at {{establishment}}",
			},
			placeholders: {
				name: "Enter schedule name",
				description: "Enter schedule description",
				type: "Select schedule type",
				establishment: "Select establishment",
				staffMember: "Select staff member",
				capacity: "Enter maximum capacity",
				recurrencyType: "Select recurrency type",
				notes: "Bring your own mat. Room 2.",
			},
			options: {
				type: {
					group: "Group Session",
					individual: "Individual Session",
				},
				recurrency: {
					single: "Single Session",
					weekly: "Weekly",
					monthly: "Monthly",
				},
				recurrencyType: {
					single: "Single Session",
					recurring: "Recurring",
				},
				days: {
					monday: "Monday",
					tuesday: "Tuesday",
					wednesday: "Wednesday",
					thursday: "Thursday",
					friday: "Friday",
					saturday: "Saturday",
					sunday: "Sunday",
					mondayShort: "Mon",
					tuesdayShort: "Tue",
					wednesdayShort: "Wed",
					thursdayShort: "Thu",
					fridayShort: "Fri",
					saturdayShort: "Sat",
					sundayShort: "Sun",
				},
			},
			validation: {
				establishmentRequired: "Establishment is required",
				staffMemberRequired: "Staff member is required",
				startTimeRequired: "Start time is required",
				endTimeRequired: "End time is required",
				invalidStartTime: "Please enter a valid start time",
				invalidEndTime: "Please enter a valid end time",
				endTimeAfterStart: "End time must be after start time",
				startDateRequired: "Start date is required",
				invalidStartDate: "Please enter a valid start date",
				endDateRequired: "End date is required for recurring schedules",
				endDateAfterStart: "End date must be after start date",
				capacityRequired: "Capacity is required for group schedules",
				daysOfWeekRequired: "Days of week are required for recurring schedules",
				dayCountMustBePreserved:
					"Number of days must remain {{originalCount}} to preserve enrollment limits",
			},
			actions: {
				create: "Create Schedule",
				creating: "Creating...",
				update: "Update Schedule",
				updating: "Updating...",
				cancel: "Cancel",
			},
		},
		toasts: {
			creating: "Creating schedule...",
			createSuccess: "Schedule created successfully!",
			createError: "Failed to create schedule. Please try again.",
			updating: "Updating schedule...",
			updateSuccess: "Schedule updated successfully!",
			updateError: "Failed to update schedule. Please try again.",
			deleting: "Deleting schedule...",
			deleteSuccess: "Schedule deleted successfully!",
			deleteError: "Failed to delete schedule. Please try again.",
			archiving: "Archiving schedule...",
			archiveSuccess: "Schedule archived successfully!",
			archiveError: "Failed to archive schedule. Please try again.",
			unarchiving: "Unarchiving schedule...",
			unarchiveSuccess: "Schedule unarchived successfully!",
			unarchiveError: "Failed to unarchive schedule. Please try again.",
			regenerating: "Generating sessions...",
			regenerateSuccess_one: "Generated {{count}} session.",
			regenerateSuccess_other: "Generated {{count}} sessions.",
			regenerateError: "Failed to generate sessions. Please try again.",
		},
		errors: {
			staffConflict: "Staff member has a conflicting schedule at {{timeRange}}",
		},
		sessions: {
			title: "Schedule Sessions",
			description: "View all sessions for this schedule",
			table: {
				date: "Date & Time",
				name: "Session Name",
				type: "Type",
				status: "Status",
				attendance: "Attendance",
			},
			status: {
				active: "Active",
				inactive: "Inactive",
				canceled: "Canceled",
			},
			actions: {
				attendance: "Attendance",
				viewAttendance: "View session attendance",
			},
			empty: {
				title: "No sessions found",
				description: "This schedule doesn't have any sessions yet.",
				generateSessions: "Generate sessions",
			},
		},
		endDateConfirmation: {
			title: "Confirm End Date Change",
			subtitle: "This action will affect existing schedule sessions",
			scheduleInfo: "Schedule Information",
			scheduleName: "Schedule Name",
			currentEndDate: "Current End Date",
			newEndDate: "New End Date",
			warningTitle: "Important Warning",
			warningMessage:
				"Reducing the end date will permanently delete some schedule sessions:",
			warningPoint1:
				"Sessions scheduled after the new end date will be deleted",
			warningPoint2: "All attendance records for deleted sessions will be lost",
			confirm: "Confirm Changes",
			updating: "Updating...",
		},
		timeChangeConfirmation: {
			title: "Confirm Schedule Change",
			subtitle: "This action may affect enrolled customers",
			scheduleInfo: "Schedule Information",
			scheduleName: "Schedule Name",
			currentTime: "Current Time",
			newTime: "New Time",
			currentDays: "Current Days",
			newDays: "New Days",
			enrolledCustomers: "Enrolled Customers",
			warningTitle: "Customer Impact Warning",
			warningMessage:
				"Changing the schedule time or days may affect customers already enrolled:",
			warningPoint1:
				"The new schedule may overlap with other schedules customers are enrolled in",
			warningPoint2:
				"This could create scheduling conflicts for enrolled customers",
			warningPoint3:
				"Customers may need to be notified of the schedule changes",
			confirm: "Confirm Schedule Change",
			updating: "Updating...",
		},
		changeConfirmation: {
			title: "Confirm Schedule Changes",
			subtitle: "Please review all changes and warnings before proceeding",
			scheduleInfo: "Schedule Information",
			scheduleName: "Schedule Name",
			currentEndDate: "Current End Date",
			newEndDate: "New End Date",
			currentTime: "Current Time",
			newTime: "New Time",
			currentDays: "Current Days",
			newDays: "New Days",
			enrolledCustomers: "Enrolled Customers",
			endDateWarning: {
				title: "End Date Change Warning",
				message:
					"Reducing the end date will permanently delete some schedule sessions:",
				point1: "Sessions scheduled after the new end date will be deleted",
				point2: "All attendance records for deleted sessions will be lost",
			},
			timeWarning: {
				title: "Schedule Time/Days Change Warning",
				message:
					"Changing the schedule time or days may affect customers already enrolled:",
				point1:
					"The new schedule may overlap with other schedules customers are enrolled in",
				point2: "This could create scheduling conflicts for enrolled customers",
				point3: "Customers may need to be notified of the schedule changes",
			},
			confirm: "Confirm All Changes",
			updating: "Updating...",
		},
		enrollments: {
			title: "Schedule Enrollments",
			description: "View all customers enrolled in this schedule",
			empty: {
				title: "No enrollments yet",
				description: "No customers are currently enrolled in this schedule.",
			},
		},
	},
	footer: {
		copyright: "© {{year}} Pilates Time. All rights reserved.",
		subscribe: "Subscribe",
		getUpdates: "Get the latest updates and news.",
		yourEmail: "Your email",
		privacyPolicy: "Privacy Policy",
		termsOfService: "Terms of Service",
	},
	roles: {
		org_owner: "Owner",
		org_administrator: "Administrator",
		org_manager: "Manager",
		org_medicalProfessional: "Instructor",
		org_medical_professional: "Instructor",
		org_accountant: "Accountant",
		org_instructor: "Instructor",
		org_receptionist: "Receptionist",
		org_viewer: "Viewer",
		org_instructor_calendar_only: "Instructor (Calendar Only)",
		org_no_access: "No Access",
	},
	establishmentRoles: {
		manager: "Establishment Manager",
		instructor: "Instructor",
		receptionist: "Receptionist",
		medicalStaff: "Medical Staff",
		assistant: "Assistant",
		viewer: "Viewer",
	},
	invitations: {
		// Invitation management
		inviteStaffMember: "Invite Staff Member",
		inviteStaffDescription: "Send an invitation to join your organization",
		staffInvitations: "Staff Invitations",
		staffInvitationsDescription:
			"Manage pending and completed staff invitations",
		emailAddress: "Email Address",
		emailPlaceholder: "Enter email address",
		emailRequired: "Email address is required",
		invalidEmail: "Please enter a valid email address",
		role: "Role",
		selectRole: "Select a role",
		roleRequired: "Please select a role",
		sendInvitation: "Send Invitation",
		sending: "Sending...",
		resend: "Resend",
		revoke: "Revoke",
		confirmRevoke: "Are you sure you want to revoke this invitation?",

		// Invitation list
		email: "Email",
		invitedBy: "Invited By",
		acceptedBy: "Accepted by {{name}} on {{date}}",
		filterByStatus: "Filter by status",
		noInvitations: "No invitations found",
		noInvitationsWithStatus: "No {{status}} invitations found",
		showingResults: "Showing {{count}} of {{total}} invitations",
		loading: "Loading invitations...",

		// Invitation status
		status: {
			pending: "Pending",
			accepted: "Accepted",
			expired: "Expired",
			revoked: "Revoked",
		},

		// Invitation acceptance page
		signInRequired: "Sign In Required",
		signInToAcceptInvitation: "Please sign in to accept this invitation",
		processingInvitation: "Processing Invitation",
		pleaseWait: "Please wait while we process your invitation...",
		invitationAccepted: "Invitation Accepted!",
		welcomeToOrganization:
			"Welcome to {{organizationName}}! You have been assigned the role of {{role}}.",
		goToDashboard: "Go to Dashboard",
		invitationInvalid: "Invitation Invalid",
		invitationError: "Invitation Error",
		invitationNotFound: "This invitation link was not found.",
		invitationDetails: "Invitation Details:",
		invitationIntro:
			"Congratulations! You've been invited to join this organization. Review the details below and accept the invitation to get started.",
		roleAssignment: "Role: {{role}}",
		validatingInvitation: "Validating invitation...",
		acceptInvitation: "Accept invitation",
		alreadyAccepted: "This invitation has already been accepted.",
		tokenExpired: "This invitation has expired.",
		tokenRevoked: "This invitation has been revoked by an administrator.",
		emailMismatchTitle: "This invitation is for a different email",
		emailMismatchDescription:
			"You are signed in as {{currentEmail}}, but this invitation is for {{expectedEmail}}.",
		emailMismatchInstructions:
			"To accept this invitation, sign out from the current account and sign in with the correct email.",
		switchAccount: "Switch account",
	},
	userSettings: {
		title: "User Settings",
		profile: "Profile",
		profileDescription:
			"Manage your personal information and account settings.",
		organizations: "Organizations",
		organizationsDescription: "Manage your organizations and create new ones.",
		notifications: "Notifications",
		notificationsDescription:
			"Configure how you receive notifications and updates.",
		toasts: {
			updating: "Updating profile...",
			updateSuccess: "Profile updated successfully",
			updateError: "Failed to update profile",
		},
		validation: {
			firstNameRequired: "First name is required",
			lastNameRequired: "Last name is required",
		},
	},
	orgSettings: {
		title: "Organization Settings",
		description: "Manage your organization settings and preferences.",
		general: "General",
		generalDescription: "Basic organization settings and information.",
		import: "Import",
		importDescription: "Import data from CSV files into your organization.",
		export: "Export",
		exportDescription: "Export your organization data to various formats.",
		importCustomers: "Import Customers",
		importCustomersDescription: "Import customer data from a CSV file.",
		importStaff: "Import Staff",
		importStaffDescription: "Import staff members from a CSV file.",
		importSchedules: "Import Schedules",
		importSchedulesDescription: "Import schedule data from a CSV file.",
		exportCustomers: "Export Customers",
		exportCustomersDescription:
			"Download all customers in your organization as a CSV file.",
		exportCustomersButton: "Download CSV",
		exportCustomersDownloading: "Preparing download...",
		exportCustomersDownloadError:
			"Could not download the customers CSV. Please try again.",
		staff: "Staff",
		clientPlans: {
			title: "Customer Plans",
		},
		features: {
			title: "Feature Settings",
			description:
				"Configure organization-wide feature flags and behavior settings.",
			enrollment: {
				title: "Enrollment Settings",
				description:
					"Configure how enrollment creation works in your organization.",
				scheduleSelection: {
					title: "Schedule Selection Mode",
					description:
						"Choose how users can select schedules when creating enrollments.",
					modes: {
						existing_only: "Existing Schedules Only",
						inline_only: "Inline Schedule Creation Only",
						inline_and_existing: "Both Existing and Inline Creation",
					},
					modeDescriptions: {
						existing_only:
							"Users can only select from existing schedules. No inline schedule creation allowed.",
						inline_only:
							"Users can only create new schedules inline during enrollment. No existing schedule selection.",
						inline_and_existing:
							"Users can both select existing schedules and create new ones inline during enrollment.",
					},
				},
			},
			attendance: {
				title: "Attendance Settings",
				description:
					"Configure how the attendance calendar displays session information.",
				calendarSessionTitleViewMode: {
					title: "Calendar Session Title",
					description:
						"Choose what is displayed as the title of sessions in the attendance calendar.",
					modes: {
						instructor_name: "Instructor Name",
						customer_names: "Customer Names",
						schedule_name: "Schedule Name",
					},
					modeDescriptions: {
						instructor_name:
							"Display the instructor name as the session title.",
						customer_names:
							"Display the enrolled customer names as the session title.",
						schedule_name: "Display the schedule name as the session title.",
					},
				},
				colorLegend: {
					title: "Session Color Legend",
					description:
						"Customize the colors used to identify different session statuses in the calendar.",
					statuses: {
						trial: "Trial Session",
						canceled: "Canceled Session",
						empty: "Empty Session (No Participants)",
						confirmed: "Confirmed Session",
						reposition: "Reposition Session",
						expired_enrollment: "Expired Enrollment",
					},
					resetToDefault: "Reset to Defaults",
				},
				enrollmentStatusFilter: {
					title: "Enrollment Status Filter",
					description:
						"Enable filtering sessions by enrollment status in the attendance calendar.",
					enabled: "Enable Filter",
					enabledDescription:
						"When enabled, users can filter sessions based on enrollment status.",
					defaultStatuses: "Default Enrollment Statuses",
					defaultStatusesDescription:
						"Select which enrollment statuses should be shown by default when the filter is enabled.",
					statuses: {
						PENDING: "Pending",
						ACTIVE: "Active",
						PAUSED: "Paused",
						CANCELED: "Canceled",
						COMPLETED: "Completed",
						EXPIRED: "Expired",
					},
				},
			},
			schedule: {
				title: "Schedule Settings",
				description:
					"Configure how schedule management works in your organization.",
				overlapValidation: {
					title: "Staff Schedule Overlap Validation",
					description:
						"Control whether staff members can be assigned to overlapping schedules.",
					modes: {
						block: "Block Overlapping Schedules",
						allow: "Allow Overlapping Schedules",
					},
					modeDescriptions: {
						block:
							"Prevent staff members from being assigned to schedules that overlap in time. This ensures no scheduling conflicts.",
						allow:
							"Allow staff members to be assigned to overlapping schedules. Use this if your organization handles conflicts manually.",
					},
				},
			},
			toasts: {
				updating: "Updating feature settings...",
				updateSuccess: "Feature settings updated successfully",
				updateError: "Failed to update feature settings",
			},
		},
		language: {
			title: "Language Settings",
			description:
				"Set the default language for your organization. This language will be used for email notifications, reminders, and other communications sent to your customers.",
			defaultLanguage: "Default Language",
			selectLanguage: "Select a language",
		},
		currency: {
			title: "Currency Settings",
			description:
				"Set the default currency for your organization. This currency will be used as the default for billing and financial operations.",
			defaultCurrency: "Default Currency",
			selectCurrency: "Select a currency",
		},
		auditEvents: {
			title: "Audit Events",
			description:
				"View the history of changes made to schedules, sessions, attendance, and enrollments.",
			noEvents: "No audit events found",
			noEventsDescription: "There are no audit events matching your filters.",
			filters: {
				entityType: "Entity Type",
				action: "Action",
				allEntityTypes: "All Entity Types",
				allActions: "All Actions",
			},
			entityTypes: {
				SCHEDULE: "Schedule",
				SCHEDULE_SESSION: "Session",
				SCHEDULE_SESSION_ATTENDANCE: "Attendance",
				ENROLLMENT: "Enrollment",
			},
			actions: {
				CREATED: "Created",
				UPDATED: "Updated",
				DELETED: "Deleted",
				STATUS_CHANGED: "Status Changed",
				RESTORED: "Restored",
				CANCELED: "Canceled",
				REACTIVATED: "Reactivated",
				BULK_CREATED: "Bulk Created",
				BULK_DELETED: "Bulk Deleted",
				BULK_UPDATED: "Bulk Updated",
			},
			columns: {
				timestamp: "Timestamp",
				entityType: "Entity Type",
				action: "Action",
				user: "User",
				changes: "Changes",
				details: "Details",
			},
			systemUser: "System",
			viewDetails: "View Details",
			detailsDialog: {
				title: "Event Details",
				entityId: "Entity ID",
				reason: "Reason",
				noReason: "No reason provided",
				beforeState: "Before",
				afterState: "After",
				changesSection: "Changes",
				noChanges: "No changes recorded",
				close: "Close",
				loading: "Loading details...",
			},
		},
	},
	orgManagement: {
		title: "Organization Management",
		back: "Back",
		financialAnalysis: {
			title: "Financial Analysis",
			subtitle: "Payments received over time",
			granularity: {
				week: "Weekly",
				month: "Monthly",
			},
			totalAllPeriods: "Total in period",
			totalCost: "Total cost",
			netResult: "Net result",
			netResultPositive: "Net result (positive)",
			netResultNegative: "Net result (negative)",
			currentPeriod: "Current period",
			empty: "No payments received in the selected window.",
			loading: "Loading financial analysis...",
			error: "Failed to load financial analysis.",
			tooltip: {
				totalInPeriod: "Total in period",
				totalCost: "Total cost:",
				netResult: "Net result:",
				payments: "Payments:",
				avgTicket: "Avg ticket:",
				deltaVsPrev: "Δ vs previous:",
				clickToView: "Click bar to view sales →",
			},
			legend: {
				revenue: "Revenue",
				cost: "Cost",
			},
			filters: {
				fromDate: "From",
				toDate: "To",
				preset: "Quick range",
				preset3m: "Last 3 months",
				preset6m: "Last 6 months",
				preset12m: "Last 12 months",
				presetYtd: "Year to date",
				presetCustom: "Custom",
				invalidRange: "End date must be after start date.",
			},
			salesList: {
				title: "Sales for {{period}}",
				clickHint: "Click a bar in the chart to see its sales.",
				columns: {
					paidAt: "Date",
					customer: "Customer",
					amount: "Amount",
					paymentMethod: "Method",
				},
				walkIn: "Walk-in",
				unknownCustomer: "—",
				empty: "No sales recorded in this period.",
				loading: "Loading sales...",
				error: "Failed to load sales.",
				pagination: {
					page: "Page {{page}} of {{totalPages}}",
					previous: "Previous",
					next: "Next",
				},
				close: "Close",
			},
			costList: {
				title: "Costs for {{period}}",
				columns: {
					incurredAt: "Date",
					category: "Category",
					description: "Description",
					amount: "Amount",
					status: "Status",
				},
				empty: "No expenses recorded in this period.",
				loading: "Loading expenses...",
				error: "Failed to load expenses.",
				pagination: {
					page: "Page {{page}} of {{totalPages}}",
					previous: "Previous",
					next: "Next",
				},
				close: "Close",
			},
		},
		costManagement: {
			title: "Cost Management",
			subtitle: "Track expenses and recurring costs",
			subtitleVariants: {
				analysis: "Costs over time and by category",
				expenses: "Browse and reconcile individual expenses",
				recurring: "Manage scheduled recurring expenses",
				categories: "Organize expenses by category",
			},
			loading: "Loading cost management...",
			error: "Failed to load cost management.",
			empty: "No data yet for this view.",
			nav: {
				analysis: "Analysis",
				expenses: "Expenses",
				recurring: "Recurring",
				categories: "Categories",
			},
			kpis: {
				currentPeriod: "Current period cost",
				totalWindow: "Total in window",
				topCategory: "Top category",
				expensesCount: "Expense count",
				pendingCount: "Pending expenses",
			},
			chart: {
				stackedTitle: "Costs over time",
				donutTitle: "By category",
				donutCenterTotal: "Total",
				clickHint: "Click a bar to drill down.",
				emptyState: "No expenses in the selected window.",
				tooltip: {
					totalInPeriod: "Total in period",
					expenses: "Expenses:",
					avgExpense: "Avg expense:",
					clickToView: "Click bar to drill down →",
				},
			},
			filters: {
				all: "All",
				status: "Status",
				category: "Category",
				fromDate: "From",
				toDate: "To",
			},
			expenses: {
				searchLabel: "Search",
				searchPlaceholder: "Description or vendor...",
				creditTag: "Credit",
				noSearchResults: "No expenses match your search.",
			},
			csv: {
				exportButton: "Export CSV",
				filename: "expenses.csv",
			},
			expense: {
				pageTitle: "Expenses",
				create: "+ Add expense",
				columns: {
					date: "Date",
					category: "Category",
					vendor: "Vendor",
					description: "Description",
					expected: "Expected",
					actual: "Actual",
					status: "Status",
					method: "Method",
					actions: "Actions",
				},
				status: {
					pending: "Pending",
					paid: "Paid",
					cancelled: "Cancelled",
				},
				paymentMethod: {
					cash: "Cash",
					bankTransfer: "Bank transfer",
					card: "Card",
					pix: "PIX",
					other: "Other",
				},
				form: {
					titleCreate: "New expense",
					titleEdit: "Edit expense",
					incurredAt: "Incurred at",
					expectedAmount: "Expected amount",
					actualAmount: "Actual amount",
					category: "Category",
					description: "Description",
					vendor: "Vendor",
					paymentMethod: "Payment method",
					notes: "Notes",
					status: "Status",
					save: "Save",
					cancel: "Cancel",
				},
				markPaid: {
					title: "Mark as paid",
					actualAmountLabel: "Actual amount paid",
					paidAtLabel: "Paid at",
					confirm: "Mark paid",
				},
				delete: {
					confirm: "Cancel this expense?",
					success: "Expense cancelled",
					error: "Failed to cancel expense",
				},
			},
			recurring: {
				pageTitle: "Recurring expenses",
				create: "+ Add recurring",
				archive: "Archive",
				summary30dLabel: "Next 30 days committed",
				actions: {
					menu: "Open actions menu",
					edit: "Edit",
				},
				columns: {
					description: "Description",
					category: "Category",
					vendor: "Vendor",
					amount: "Amount",
					frequency: "Frequency",
					nextOccurrence: "Next occurrence",
					actions: "Actions",
				},
				frequency: {
					weekly: "Weekly",
					monthly: "Monthly",
					yearly: "Yearly",
				},
				form: {
					titleCreate: "New recurring expense",
					titleEdit: "Edit recurring expense",
					description: "Description",
					vendor: "Vendor",
					expectedAmount: "Expected amount",
					frequency: "Frequency",
					dayOfMonth: "Day of month",
					dayOfWeek: "Day of week (0=Sun)",
					monthOfYear: "Month of year",
					startDate: "Start date",
					endDate: "End date",
					paymentMethod: "Payment method",
					category: "Category",
					save: "Save",
					cancel: "Cancel",
				},
			},
			category: {
				pageTitle: "Expense categories",
				create: "+ Add category",
				activeLabel: "Active",
				archivedLabel: "Archived",
				systemReadOnly: "System category name is i18n-managed.",
				systemTooltip:
					"Managed by the system — name and color cannot be edited.",
				systemKey: {
					RENT_UTILITIES: "Rent & Utilities",
					PAYROLL: "Payroll",
					EQUIPMENT: "Equipment",
					MARKETING: "Marketing",
					SOFTWARE: "Software & SaaS",
					TAXES_FEES: "Taxes & Fees",
					SUPPLIES: "Supplies",
					OTHER: "Other",
				},
				columns: {
					name: "Name",
					color: "Color",
					status: "Status",
					actions: "Actions",
				},
				form: {
					titleCreate: "New category",
					titleEdit: "Edit category",
					name: "Name",
					namePlaceholder: "Marketing, Office supplies, ...",
					color: "Color",
					save: "Save",
					cancel: "Cancel",
				},
				archive: {
					action: "Archive",
					confirm: "Archive this category?",
					success: "Category archived",
					error: "Failed to archive category",
				},
			},
			toasts: {
				expense: {
					create: {
						loading: "Creating expense...",
						success: "Expense created",
						error: "Failed to create expense",
					},
					update: {
						loading: "Updating expense...",
						success: "Expense updated",
						error: "Failed to update expense",
					},
					markPaid: {
						loading: "Marking as paid...",
						success: "Expense marked as paid",
						error: "Failed to mark as paid",
					},
					delete: {
						loading: "Cancelling expense...",
						success: "Expense cancelled",
						error: "Failed to cancel expense",
					},
				},
				category: {
					create: {
						loading: "Creating category...",
						success: "Category created",
						error: "Failed to create category",
					},
					update: {
						loading: "Updating category...",
						success: "Category updated",
						error: "Failed to update category",
					},
					archive: {
						loading: "Archiving category...",
						success: "Category archived",
						error: "Failed to archive category",
					},
				},
				recurring: {
					create: {
						loading: "Creating recurring expense...",
						success: "Recurring expense created",
						error: "Failed to create recurring expense",
					},
					update: {
						loading: "Updating recurring expense...",
						success: "Recurring expense updated",
						error: "Failed to update recurring expense",
					},
					archive: {
						loading: "Archiving recurring expense...",
						success: "Recurring expense archived",
						error: "Failed to archive recurring expense",
					},
				},
			},
		},
		customerRiskAnalysis: {
			title: "Customer Risk Analysis",
			subtitle: "Enrolled customers missing classes",
			window: "Window (Days)",
			minCancellations: "Min. cancellations",
			columns: {
				customer: "Customer",
				plan: "Plan",
				absences: "Absences",
				scheduled: "Scheduled",
				attendanceRate: "Attendance rate",
				risk: "Risk",
			},
			riskLevels: {
				veryLow: "Very Low",
				low: "Low",
				medium: "Medium",
				high: "High",
				veryHigh: "Very High",
			},
			empty: "No customers currently flagged as at-risk.",
			loading: "Loading customer risk analysis...",
			error: "Failed to load customer risk analysis.",
		},
	},
	attendance: {
		title: "Attendance",
		description: "Manage session attendance and view schedules",
		viewAttendance: "View Attendance",
		viewSessionDetails: "View Details",
		eventDetails: "Class Details",
		noEventSessions: "No class sessions found",
		noAttendanceRecords: "No attendance records found for this class",
		customers: "Customers",
		views: {
			calendar: "Calendar",
			list: "List",
		},
		loading: {
			title: "Loading Session Details",
			description: "Please wait while we load the session information...",
		},
		calendar: {
			weekView: "Week View",
			monthView: "Month View",
			noSessions: "No Sessions",
			noSessionsDescription:
				"No sessions found for the selected period. Try adjusting your filters or create new sessions.",
		},
		list: {
			tableView: "Table",
			cardsView: "Cards",
			noSessions: "No Sessions",
			noSessionsDescription:
				"No sessions found for the selected period. Try adjusting your filters or create new sessions.",
			headers: {
				date: "Date",
				session: "Session",
				instructor: "Instructor",
				time: "Time",
				location: "Location",
				attendance: "Attendance",
				status: "Status",
			},
			enrolled: "enrolled",
		},
		stats: {
			totalSessions: "Total Sessions",
			activeSessions: "Active Sessions",
			canceledSessions: "Canceled Sessions",
			totalEnrollments: "Total Enrollments",
			capacityUtilization: "Capacity Utilization",
		},
		actions: {
			createSession: "Create Session",
		},
		error: {
			title: "Error Loading Sessions",
			generic: "An error occurred while loading sessions. Please try again.",
			sessionNotFound:
				"Session not found or you don't have permission to view it.",
		},
		sessionDetails: {
			title: "Session Details",
			details: "Session Information",
			instructor: "Instructor",
			location: "Location",
			capacity: "Capacity",
			notes: "Notes",
			attendanceList: "Attendance List",
			noAttendance: "No attendance records found for this session.",
			viewSchedule: "View schedule details",
			cancelSession: {
				button: "Cancel Session",
				title: "Cancel Session",
				description:
					"Are you sure you want to cancel this session? This will mark the session as canceled and customers will be notified.",
				confirm: "Cancel Session",
				canceling: "Canceling...",
				success: "Session canceled successfully",
				error: "Failed to cancel session",
			},
			reactivateSession: {
				button: "Reactivate Session",
				title: "Reactivate Session",
				description:
					"Are you sure you want to reactivate this session? This will restore the session to its normal state.",
				confirm: "Reactivate Session",
				reactivating: "Reactivating...",
				success: "Session reactivated successfully",
				error: "Failed to reactivate session",
			},
			rescheduleSession: {
				button: "Reschedule",
				title: "Reschedule Session",
				description:
					"Select a new date and time for this session. The original session will be canceled and a new one will be created.",
				newDate: "New Date",
				newStartTime: "Start Time",
				newEndTime: "End Time",
				confirm: "Reschedule Session",
				rescheduling: "Rescheduling...",
				success: "Session rescheduled successfully",
				error: "Failed to reschedule session",
				validation: "Please select a new date",
				timeValidation: "Please select start and end times",
				timeOrderValidation: "End time must be after start time",
			},
			sessionCanceled: "This session has been canceled",
			status: {
				upcoming: "Upcoming",
				inProgress: "In progress",
				done: "Finished",
			},
			changeStatusFor: "Change status for {{name}}",
			emptyRoster: {
				title: "No one on the roster yet",
				description: "Add customers to track attendance for this session.",
			},
		},
		filters: {
			button: "Filters",
			title: "Filter Sessions",
			description: "Filter sessions by date, staff, establishment, and more",
			startDate: "Start Date",
			endDate: "End Date",
			staffMember: "Staff Member",
			selectStaffMember: "Select staff member",
			allStaffMembers: "All Staff Members",
			establishment: "Establishment",
			selectEstablishment: "Select establishment",
			allEstablishments: "All Establishments",
			scheduleType: "Schedule Type",
			selectScheduleType: "Select schedule type",
			allScheduleTypes: "All Schedule Types",
			groupSessions: "Group Sessions",
			individualSessions: "Individual Sessions",
			status: "Status",
			activeSessions: "Active Sessions",
			canceledSessions: "Canceled Sessions",
			allSessions: "All Sessions",
			apply: "Apply Filters",
			reset: "Reset Filters",
			// Legacy keys for backward compatibility
			instructor: "Instructor",
			allInstructors: "All Instructors",
		},
		viewMode: {
			calendar: "Calendar",
			list: "List",
		},
		calendarView: {
			week: "Week",
			weekShort: "W",
			month: "Month",
			monthShort: "M",
			today: "Today",
			day: "Day",
			dayShort: "D",
			list: "List",
			previous: "Previous",
			next: "Next",
			viewToggleLabel: "Switch calendar view",
		},
		listView: {
			table: "Table",
			cards: "Cards",
		},
		instructorFilter: {
			title: "Filter by Instructor",
			placeholder: "Select instructors...",
			selectAll: "Select All",
			deselectAll: "Deselect All",
			showingAll: "Showing all instructors",
			showingSelected: "Showing {{count}} of {{total}} instructors",
			selectedCount: "{{count}} selected",
		},
		table: {
			dateTime: "Date & Time",
			schedule: "Schedule",
			instructor: "Instructor",
			location: "Location",
			enrolled: "Enrolled",
			customer: "Customer",
			idType: "ID Type",
			idNumber: "ID Number",
			status: "Status",
		},
		status: {
			confirmed: "Confirmed",
			canceled: "Canceled",
			trial: "Trial",
			reposition: "Reposition",
			full: "Full",
			almostFull: "Almost Full",
			available: "Available",
			inactive: "Inactive",
			paused: "Paused",
			active: "Active",
			noParticipants: "No participants",
		},
		mobile: {
			today: "Today",
			previousWeek: "Previous week",
			nextWeek: "Next week",
			viewToggleLabel: "Switch between week and list view",
			swipeHint: "Swipe to see more days",
			sessionCount_one: "{{count}} session",
			sessionCount_other: "{{count}} sessions",
			status: {
				inProgress: "In progress",
				checkedIn: "{{value}} in",
				booked_one: "{{count}} booked",
				booked_other: "{{count}} booked",
				liveShort: "live",
			},
		},
		statusUpdate: {
			success: "Attendance status updated successfully",
			error: "Failed to update attendance status",
		},
		addCustomer: {
			buttonLabel: "Add Customer",
			buttonLabelShort: "Add",
			title: "Add Customer to Class",
			description: "Add a customer to this class for one-time attendance",
			searchCustomer: "Search Customer",
			searchPlaceholder: "Search by name or document number",
			noCustomersFound: "No customers found with that search term",
			searchToFindCustomers: "Search to find customers",
			selectedCustomers: "Selected Customers",
			status: "Status",
			reason: "Reason for Addition",
			selectReason: "Select a reason",
			notes: "Notes",
			notesPlaceholder: "Add any additional notes about this attendance",
			addButton: "Add to Class",
			noIdProvided: "No ID provided",
			success:
				"Successfully added {{count}} customer(s) to the session: {{customers}}",
			reasons: {
				reposition: "Reposition",
				trialClass: "Trial Class",
				specialEvent: "Special Event",
				other: "Other",
			},
			errors: {
				customerRequired: "Please select a customer",
				reasonRequired: "Please select a reason",
				noCustomersSelected: "Please select at least one customer",
				failed: "Failed to add customers to session: {{error}}",
			},
		},
	},
	enrollment: {
		title: "Enrollments",
		description: "Manage customer enrollments in schedules and plans",
		addEnrollment: "Add Enrollment",
		addEnrollmentDescription: "Enroll a customer in a schedule with a plan",
		createEnrollment: "Create Enrollment",
		createEnrollmentDescription: "Create a new enrollment for a customer",
		editEnrollment: "Edit Enrollment",
		editEnrollmentDescription: "Update enrollment details",
		deleteEnrollment: "Delete Enrollment",
		deleteEnrollmentDescription:
			"Are you sure you want to delete this enrollment?",
		deleteConfirmation:
			"This will permanently delete the enrollment for {{customer}} in {{schedule}}.",
		noEnrollments: "No enrollments found",
		noCustomersFound: "No customers found",
		searchCustomer: "Search by name or document number",
		selectCustomer: "Select a customer",
		selectedCustomer: "Selected Customer",
		selectedCustomerPlan: "Selected Customer Plan",
		selectSchedule: "Select a schedule",
		accessDenied: "You don't have permission to access enrollments.",
		confirmationModalTitle: "Enrollment Confirmation",
		details: {
			title: "Enrollment Details",
			description: "View comprehensive enrollment information",
			notFound: "Enrollment not found",
			sections: {
				customerInfo: "Customer Information",
				scheduleInfo: "Schedule Information",
				planInfo: "Plan Information",
				enrollmentInfo: "Enrollment Information",
			},
			fields: {
				customerName: "Customer Name",
				customerId: "Customer ID",
				customerIdType: "ID Type",
				customerIdNumber: "ID Number",
				scheduleTitle: "Schedule Title",
				scheduleTime: "Schedule Time",
				instructor: "Instructor",
				planName: "Plan Name",
				planPrice: "Plan Price",
				billingCycle: "Billing Cycle",
				startDate: "Start Date",
				endDate: "End Date",
				status: "Status",
				notes: "Notes",
			},
		},
		selectCustomerPlan: "Select a customer plan",
		fields: {
			customer: "Customer",
			schedule: "Schedule",
			customerPlan: "Customer Plan",
			status: "Status",
			notes: "Notes",
		},
		table: {
			customer: "Customer",
			idType: "ID Type",
			idNumber: "ID Number",
			schedule: "Schedule",
			plan: "Plan",
			startDate: "Start Date",
			endDate: "End Date",
			status: "Status",
		},
		status: {
			active: "Active",
			inactive: "Inactive",
			completed: "Completed",
			cancelled: "Cancelled",
		},
		errors: {
			scheduleAtCapacity: "This schedule is at full capacity",
		},
	},
	payments: {
		title: "Payments",
		description: "Manage customer payments and billing",
		addPayment: "Add Payment",
		addPaymentDescription: "Create a new payment for a customer",
		createPayment: "Create Payment",
		editPayment: "Edit Payment",
		editPaymentDescription: "Update payment details",
		deletePayment: "Delete Payment",
		deletePaymentDescription: "Are you sure you want to delete this payment?",
		deleteConfirmation: "This will permanently delete the payment record.",
		noPaymentsFound: "No payments found",
		searchPlaceholder: "Search by customer name, plan, or amount",
		selectedCustomer: "Selected Customer",
		selectedCustomerAndPlan: "Selected Customer and Plan",
		noCustomersFound: "No customers found",
		noPlansFound: "No plans found for this customer",
		steps: {
			selectCustomer: "Step 1: Select Customer",
			selectCustomerDescription:
				"Select a customer who is enrolled in at least one plan",
			selectPlan: "Step 2: Select Plan",
			selectPlanDescription: "Select a plan the customer is enrolled in",
			paymentDetails: "Step 3: Payment Details",
			paymentDetailsDescription:
				"Enter payment details and complete the transaction",
		},
		fields: {
			customer: "Customer",
			plan: "Plan",
			amount: "Amount",
			currency: "Currency",
			paymentDate: "Payment Date",
			paymentMethod: "Payment Method",
			status: "Status",
			notes: "Notes",
		},
		placeholders: {
			selectCustomer: "Select a customer",
			searchCustomer: "Search for a customer",
			selectPlan: "Select a plan",
			selectCurrency: "Select currency",
			selectPaymentMethod: "Select payment method",
			selectStatus: "Select status",
			notes: "Add any additional notes about this payment",
		},
		methods: {
			creditCard: "Credit Card",
			debitCard: "Debit Card",
			cash: "Cash",
			bankTransfer: "Bank Transfer",
			pix: "PIX",
			other: "Other",
		},
		statuses: {
			completed: "Completed",
			pending: "Pending",
			failed: "Failed",
			refunded: "Refunded",
			cancelled: "Cancelled",
		},
		createSuccess: "Payment created successfully!",
		updateSuccess: "Payment updated successfully!",
		deleteSuccess: "Payment deleted successfully!",
		createError: "Failed to create payment. Please try again.",
		updateError: "Failed to update payment. Please try again.",
		deleteError: "Failed to delete payment. Please try again.",
	},
	medicalRecords: {
		title: "Medical Records",
		description: "Comprehensive medical records management for all customers",
		searchPlaceholder: "Search medical records",
		addMedicalRecord: "Add Medical Record",
		addMedicalRecordDescription:
			"Create a new medical record for this customer",
		addRecord: "Add Record",
		noRecords: "No medical records found",
		creating: "Creating medical record...",
		updating: "Updating medical record...",
		deleting: "Deleting medical record...",
		generatingSummary: "Generating AI summary...",
		create: "Create Record",
		createSuccess: "Medical record created successfully!",
		updateSuccess: "Medical record updated successfully!",
		deleteSuccess: "Medical record deleted successfully!",
		generateSummarySuccess: "AI summary generated successfully!",
		createError: "Failed to create medical record. Please try again.",
		updateError: "Failed to update medical record. Please try again.",
		deleteError: "Failed to delete medical record. Please try again.",
		generateSummaryError: "Failed to generate AI summary. Please try again.",
		unsupportedRecordType: "This record type is not supported for viewing.",
		viewNotImplemented: "View mode not yet implemented for this record type.",
		noOptionsSelected: "No options selected",
		noNotesAvailable: "No notes available",
		noDataAvailable: "No data available",
		selectRecordType: "Select record type",
		newRecord: {
			title: "New Medical Record",
			description: "Create a new medical record for this customer",
			selectType: "Record Type",
			selectTypeDescription:
				"Choose the type of medical record you want to create",
		},
		recordTypeLabels: {
			anamnesis: "Anamnesis",
			physical_evaluation: "Physical Evaluation",
			periodic_evaluation: "Periodic Evaluation",
			treatment: "Treatment Plan",
			other: "Other",
		},
		titlePlaceholder: "Enter record title",
		descriptionPlaceholder: "Enter record description (optional)",
		editMedicalRecord: "Edit Medical Record",
		viewMedicalRecord: "View Medical Record",
		noMedicalRecords: "No Medical Records Found",
		noMedicalRecordsDescription:
			"No medical records match your current search criteria.",
		createNew: "Create New Record",
		selectRecordTypeDescription: "Choose the type of medical record to create",
		fields: {
			customer: "Customer",
			customerName: "Customer Name",
			date: "Date",
			recordType: "Record Type",
			title: "Title",
			description: "Description",
			summary: "Summary",
		},
		recordTypes: {
			anamnesis: "Anamnesis (Patient History)",
			evaluation: "Evaluation",
			treatment: "Treatment",
			assessment: "Assessment",
			other: "Other",
		},
		recordTypeDescriptions: {
			anamnesis:
				"Comprehensive patient history including medical background, current medications, pain characteristics, and lifestyle factors.",
			evaluation: "General evaluation and assessment record.",
			treatment: "Treatment session notes and interventions.",
			assessment: "Clinical assessment and findings.",
			other: "Other types of medical records.",
		},
		filters: {
			all: "All Records",
			byCustomer: "By Customer",
			byType: "By Type",
			byDate: "By Date",
		},
		actions: {
			viewDetails: "View Details",
			editRecord: "Edit Record",
			deleteRecord: "Delete Record",
		},
		// AI Summary
		aiSummary: {
			title: "AI Summary",
			generateButton: "Generate AI Summary",
			generating: "Generating...",
			showSummary: "Show Summary",
			hideSummary: "Hide Summary",
			noSummary: "No summary available",
			processing: "Processing",
			refresh: "Refresh",
			refreshing: "Refreshing...",
		},

		// Form Answers Display
		formAnswers: {
			title: "Form Answers",
			showDetails: "Show Details",
			hideDetails: "Hide Details",
		},

		// Anamnesis (Patient History) specific translations
		anamnesis: {
			title: "Anamnesis (Patient History)",
			description: "Comprehensive patient history and subjective assessment",

			// Section titles
			presentingComplaint: "A. Presenting Complaint",
			medicalSurgicalHistory: "B. Medical & Surgical History",
			lifestyleActivity: "C. Lifestyle & Activity",
			goalsPreferences: "D. Goals & Preferences",

			// A. Presenting Complaint
			mainReasonTitle: "Main reason for today's visit",
			mainReason: {
				pain: "Pain",
				stiffness: "Stiffness",
				weakness: "Weakness",
				numbnessTingling: "Numbness/tingling",
				swelling: "Swelling",
				instability: "Instability",
				balanceIssues: "Balance issues",
				postSurgicalRehab: "Post‑surgical rehab",
				sportsInjury: "Sports injury",
				workAccident: "Work accident",
				other: "Other",
			},
			bodyRegionTitle: "Body region involved (tick all)",
			bodyRegion: {
				neck: "Neck",
				upperBack: "Upper back",
				lowBack: "Low back",
				jawTMJ: "Jaw/TMJ",
				shoulderL: "Shoulder L",
				shoulderR: "Shoulder R",
				elbowL: "Elbow L",
				elbowR: "Elbow R",
				wristHandL: "Wrist/Hand L",
				wristHandR: "Wrist/Hand R",
				hipL: "Hip L",
				hipR: "Hip R",
				kneeL: "Knee L",
				kneeR: "Knee R",
				ankleFootL: "Ankle/Foot L",
				ankleFootR: "Ankle/Foot R",
				pelvicWomensHealth: "Pelvic / Women's health",
				other: "Other",
			},
			onsetTitle: "Onset",
			onset: {
				suddenTrauma: "Sudden trauma",
				gradualOveruse: "Gradual/overuse",
				postOperative: "Post‑operative",
				recurringFlare: "Recurring flare",
				chronicMoreThan6Months: "Chronic > 6 months",
			},
			painQualityTitle: "Pain quality",
			painQuality: {
				sharp: "Sharp",
				dullAche: "Dull/ache",
				burning: "Burning",
				throbbing: "Throbbing",
				cramping: "Cramping",
				pinsNeedles: "Pins & needles",
			},
			worseWithTitle: "Worse with",
			worseWith: {
				movement: "Movement",
				rest: "Rest",
				sitting: "Sitting",
				standing: "Standing",
				walkingRunning: "Walking/Running",
				lifting: "Lifting",
				bendingTwisting: "Bending/Twisting",
				morning: "Morning",
				eveningNight: "Evening/Night",
				coughSneeze: "Cough/Sneeze",
			},
			betterWithTitle: "Better with",
			betterWith: {
				rest: "Rest",
				heat: "Heat",
				ice: "Ice",
				medication: "Medication",
				stretching: "Stretching",
				exercise: "Exercise",
				massage: "Massage",
				nothingHelps: "Nothing helps",
			},
			redFlagSymptomsTitle: 'Recent "red‑flag" symptoms',
			redFlagSymptoms: {
				unexplainedWeightLoss: "Unexplained weight loss",
				feverNightSweats: "Fever/night sweats",
				nightPainUnrelievedByPosition: "Night pain unrelieved by position",
				bowelBladderChanges: "Bowel/bladder changes",
				saddleNumbness: "Saddle numbness",
				progressiveWeakness: "Progressive weakness",
				dizzinessFainting: "Dizziness/fainting",
				none: "None",
			},

			// B. Medical & Surgical History
			pastDiagnosesTitle: "Past diagnoses",
			pastDiagnoses: {
				hypertension: "Hypertension",
				heartDisease: "Heart disease",
				strokeTIA: "Stroke/TIA",
				asthmaCOPD: "Asthma/COPD",
				diabetesT1: "Diabetes T1",
				diabetesT2: "Diabetes T2",
				osteoporosis: "Osteoporosis",
				osteoarthritis: "Osteoarthritis",
				rheumatoidAutoimmune: "Rheumatoid/autoimmune",
				cancerPastPresent: "Cancer (past/present)",
				neurologicalDisorder: "Neurological disorder",
				epilepsy: "Epilepsy",
				depressionAnxiety: "Depression/Anxiety",
				bloodClotDVT: "Blood clot/DVT",
				infectiousDisease: "Infectious disease (HIV/Hepatitis)",
				none: "None",
			},
			surgeriesHospitalStaysTitle: "Surgeries / hospital stays",
			surgeriesHospitalStays: {
				spine: "Spine",
				jointReplacement: "Joint replacement",
				fractureFixation: "Fracture fixation",
				arthroscopy: "Arthroscopy",
				cardiac: "Cardiac",
				abdominalPelvic: "Abdominal/Pelvic",
				cSection: "C‑section",
				other: "Other",
				none: "None",
			},
			currentRegularMedicationTitle: "Current regular medication",
			currentRegularMedication: {
				painNSAIDs: "Pain/NSAIDs",
				steroids: "Steroids",
				bloodThinners: "Blood thinners",
				bpMeds: "BP meds",
				cholesterolMeds: "Cholesterol meds",
				diabetesMedsInsulin: "Diabetes meds/Insulin",
				osteoporosisMeds: "Osteoporosis meds",
				antidepressants: "Antidepressants",
				muscleRelaxants: "Muscle relaxants",
				none: "None",
			},
			allergiesSensitivitiesTitle: "Allergies / sensitivities",
			allergiesSensitivities: {
				latex: "Latex",
				adhesive: "Adhesive",
				nsaids: "NSAIDs",
				antibiotics: "Antibiotics",
				food: "Food",
				iodineContrast: "Iodine/Contrast",
				noneKnown: "None known",
			},
			implantsDevicesTitle: "Implants / devices",
			implantsDevices: {
				pacemakerICD: "Pacemaker/ICD",
				metalHardware: "Metal hardware",
				jointProsthesis: "Joint prosthesis",
				painPumpStimulator: "Pain pump/Stimulator",
				cochlearImplant: "Cochlear implant",
				other: "Other",
				none: "None",
			},
			womensHealthTitle: "Women's health (if applicable)",
			womensHealth: {
				pregnant: "Pregnant",
				lessThan6MonthsPostPartum: "< 6 mo post‑partum",
				pelvicFloorIssues: "Pelvic floor issues",
				none: "None",
			},

			// C. Lifestyle & Activity
			workDemandsTitle: "Work demands",
			workDemands: {
				mostlySitting: "Mostly sitting",
				prolongedStanding: "Prolonged standing",
				heavyLifting: "Heavy lifting",
				repetitiveTasks: "Repetitive tasks",
				shiftNightWork: "Shift/night work",
				offWorkDueToInjury: "Off work due to injury",
			},
			physicalActivityLevelTitle: "Physical activity level",
			physicalActivityLevel: {
				none: "Sendentary",
				light1To2TimesWeek: "Light (1–2 × wk)",
				moderate3To4TimesWeek: "Moderate (3–4 × wk)",
				vigorous5OrMoreTimesWeek: "Vigorous (≥ 5 × wk)",
				competitiveSport: "Professional Athlete",
			},
			regularExerciseTitle: "Regular exercise",
			regularExercise: {
				walking: "Walking",
				running: "Running",
				cycling: "Cycling",
				swimming: "Swimming",
				gymWeights: "Gym/Weights",
				teamSports: "Team sports",
				yogaPilates: "Yoga/Pilates",
				other: "Other",
				none: "None",
			},
			lifestyleFactorsTitle: "Lifestyle factors",
			lifestyleFactors: {
				currentSmoker: "Current smoker",
				formerSmoker: "Former smoker",
				neverSmoked: "Never smoked",
				alcoholMoreThan14UnitsWeek: "Alcohol > 14 units/wk",
				alcoholLessOrEqual14UnitsWeek: "Alcohol ≤ 14 units/wk",
				caffeineMoreThan3CupsDay: "Caffeine > 3 cups/day",
				poorSleepLessThan6Hours: "Poor sleep (< 6 h)",
				highStress: "High stress",
			},
			sleepQualityTitle: "Sleep quality",
			sleepQuality: {
				good: "Good",
				fairOccasionalWaking: "Fair occasional waking",
				poorFrequentWaking: "Poor frequent waking",
				wakesDueToPain: "Wakes due to pain",
			},
			dailyActivitiesLimitedTitle:
				"Daily activities limited by current problem",
			dailyActivitiesLimited: {
				dressing: "Dressing",
				bathing: "Bathing",
				stairs: "Stairs",
				standingMoreThan30Min: "Standing > 30 min",
				sittingMoreThan30Min: "Sitting > 30 min",
				walkingMoreThan15Min: "Walking > 15 min",
				drivingMoreThan30Min: "Driving > 30 min",
				liftingMoreThan5Kg: "Lifting > 5 kg",
				reachingOverhead: "Reaching overhead",
				gettingUpFromFloor: "Getting up from floor",
			},
			previousTreatmentsTriedTitle: "Previous treatments tried",
			previousTreatmentsTried: {
				physiotherapy: "Physiotherapy",
				chiropractic: "Chiropractic",
				osteopathy: "Osteopathy",
				massage: "Massage",
				acupunctureDryNeedling: "Acupuncture/Dry needling",
				injection: "Injection",
				surgery: "Surgery",
				imagingOnly: "Imaging only",
				none: "None",
			},

			// D. Goals & Preferences
			goalsForPhysiotherapyTitle: "Goals for physiotherapy",
			goalsForPhysiotherapy: {
				decreasePain: "Decrease pain",
				improveMobility: "Improve mobility",
				increaseStrength: "Increase strength",
				improveBalance: "Improve balance",
				returnToSport: "Return to sport",
				returnToWork: "Return to work",
				preventRecurrence: "Prevent recurrence",
				postureEducation: "Posture education",
				other: "Other",
			},
			treatmentMethodsInterestedInTitle:
				"Treatment methods I'm interested in / open to",
			treatmentMethodsInterestedIn: {
				manualTherapy: "Manual therapy",
				jointMobilisationManipulation: "Joint mobilisation/manipulation",
				exerciseProgramme: "Exercise programme",
				dryNeedling: "Dry needling",
				electrotherapyTENSUltrasound: "Electrotherapy (TENS/ultrasound)",
				tapingBracing: "Taping/Bracing",
				heatCold: "Heat/Cold",
				noPreference: "No preference",
			},
			consentTitle: "Consent",
			consent: {
				understandAndConsentToTreatment:
					"I understand and consent to the assessment and proposed treatment",
			},

			// Referral Source
			referralSourceSection: "How Did You Hear About Us?",
			howDidYouHearAboutUsTitle: "How did you hear about our clinic?",
			referralSource: {
				instagram: "Instagram",
				facebook: "Facebook",
				google: "Google Search",
				googleMaps: "Google Maps",
				website: "Our Website",
				friendFamily: "Friend/Family Recommendation",
				existingClient: "Existing Client Referral",
				healthcareProfessional: "Healthcare Professional Referral",
				advertisement: "Advertisement (TV/Radio/Print)",
				walkingBy: "Walking By/Saw the Clinic",
				onlineReview: "Online Review/Rating",
				other: "Other",
			},
		},

		// Physical Evaluation
		physicalEvaluation: {
			bodyMeasurements: "Body Measurements",
			vitalSigns: "Vital Signs",
			autoCalculated: "Auto-calculated",
			vitalsAnthropometrics: "1 · Vitals & Anthropometrics",
			height: "Height",
			weight: "Weight",
			bmi: "BMI",
			restingHeartRate: "Resting heart-rate",
			bloodPressure: "Blood-pressure",

			posturalObservation: "2 · Postural Observation (standing relaxed)",
			headNeck: "Head/Neck",
			neutral: "Neutral",
			forwardHead: "Forward head",
			sideBendR: "Side-bend R",
			sideBendL: "Side-bend L",
			shoulders: "Shoulders",
			level: "Level",
			elevatedR: "Elevated R",
			elevatedL: "Elevated L",
			rounded: "Rounded",
			thoracicCurve: "Thoracic curve",
			normal: "Normal",
			increasedKyphosis: "↑ Kyphosis",
			decreasedKyphosis: "↓ Kyphosis",
			lumbarCurve: "Lumbar curve",
			increasedLordosis: "↑ Lordosis",
			decreasedLordosis: "↓ Lordosis",
			pelvis: "Pelvis",
			anteriorTilt: "Anterior tilt",
			posteriorTilt: "Posterior tilt",
			lHike: "L hike",
			rHike: "R hike",
			kneeAlignment: "Knee alignment",
			genuValgum: "Genu valgum",
			genuVarum: "Genu varum",
			footAnkle: "Foot/Ankle",
			neutralArch: "Neutral arch",
			pesPlanus: "Pes planus",
			pesCavus: "Pes cavus",
			pronationR: "Pronation R",
			pronationL: "Pronation L",

			breathingCoreControl: "3 · Breathing & Core Control (Pilates focus)",
			breathingPattern: "Breathing pattern",
			diaphragmatic: "Diaphragmatic (360°)",
			upperChestDominant: "Upper-chest dominant",
			paradoxical: "Paradoxical",
			coreEngagement: 'Core engagement cue ("draw-up/zip")',
			ableToActivate: "Able to activate",
			unablePoorAwareness: "Unable/poor awareness",
			pelvicFloorCue: "Pelvic floor cue",
			adequateContraction: "Adequate contraction",
			weakAbsent: "Weak/absent",
			overActive: "Over-active",
			spinalImprintControl: "Spinal imprint control (supine)",
			maintainsNeutral: "Maintains neutral",
			flattensExcessively: "Flattens excessively",
			hyperLordotic: "Hyper-lordotic",

			rangeOfMotion:
				"4 · Range of Motion (quick screen – goniometer if limited)",
			wnl: "WNL",
			mildDecrease: "Mild ↓",
			modDecrease: "Mod ↓",
			severeDecrease: "Severe ↓",
			cervical: "Cervical",
			thoracicRotation: "Thoracic rotation",
			lumbarFlexExtend: "Lumbar flex/extend",
			shoulderL: "Shoulder (flex/abd) L",
			shoulderR: "Shoulder (flex/abd) R",
			hipFlexL: "Hip flex L",
			hipFlexR: "Hip flex R",
			ankleDosiflexL: "Ankle dorsiflex L",
			ankleDosiflexR: "Ankle dorsiflex R",

			flexibilityTests: "5 · Flexibility Tests",
			hamstrings: "Hamstrings (straight-leg-raise)",
			hamstringsTight: "≤ 70° tight",
			hamstringsNormal: "> 70° WNL",
			hipFlexors: "Hip flexors (Thomas test)",
			tight: "Tight",
			quadriceps: "Quadriceps (Ely test)",
			pectoralisMinor: "Pectoralis minor length",
			calf: "Calf (gastro-soleus)",

			muscleStrengthEndurance: "6 · Muscle Strength / Endurance",
			manualMuscleTest: "Manual Muscle Test quick screen",
			allMajorGroups: "All major groups ≥ 4/5",
			deficits: "If deficits:",
			cervicalFlexors: "Cervical flexors",
			scapularStabilisers: "Scapular stabilisers",
			core: "Core",
			gluteMax: "Glute max",
			gluteMed: "Glute med",
			quads: "Quads",
			coreEndurance: "Core endurance (plank)",
			less20s: "< 20 s",
			between20and60s: "20-60 s",
			more60s: "> 60 s",

			balanceNeuromotorControl: "7 · Balance & Neuromotor Control",
			romberg: "Romberg 30 s",
			stable: "Stable",
			sways: "Sways",
			tandemStance: "Tandem stance 30 s",
			singleLegStanceL: "Single-leg stance 10 s L",
			singleLegStanceR: "Single-leg stance 10 s R",
			yes: "Yes",
			no: "No",
			yBalance: "Y-Balance / Star-Excursion",
			within10Percent: "Within 10% bilateral",
			more10PercentAsymmetry: "> 10% asymmetry",

			functionalMovementScreen: "8 · Functional Movement Screen",
			overheadSquat: "Overhead squat",
			pass: "Pass",
			heelsLift: "Heels lift",
			kneeValgus: "Knee valgus",
			forwardLean: "Forward lean",
			lunge: "Lunge (forward)",
			balanceLoss: "Balance loss",
			trunkShift: "Trunk shift",
			stepDown: "Step-down",
			hipDrop: "Hip drop",
			kneeMedial: "Knee medial",
			pain: "Pain",
			bridge: "Bridge (glute activation)",
			maintainsPelvisLevel: "Maintains pelvis level",
			pelvicDropR: "Pelvic drop R",
			pelvicDropL: "Pelvic drop L",

			cardiorespiratoryScreen: "9 · Cardiorespiratory Screen",
			stepTestRecovery: "3-min step test HR recovery to < 100 bpm by 1 min",
			dyspnoeaChestDiscomfort: "Any undue dyspnoea / chest discomfort",

			specialTests: "10 · Special Tests (tick positives)",
			positiveTests: "Positive tests",
			slrNerveTension: "SLR nerve tension",
			spurlings: "Spurling's",
			lachman: "Lachman",
			mcmurray: "McMurray",
			neerEmptyCan: "Neer/Empty-Can",
			faber: "FABER",
			trendelenburg: "Trendelenburg",
			other: "Other",

			readinessGoals: "11 · Readiness & Goals",
			exerciseReadiness: "Exercise readiness",
			clearedForFullPilatesMat: "Cleared for full Pilates mat",
			clearedForApparatus: "Cleared for apparatus",
			needModifiedProgram: "Need modified program",
			primaryGoals: "Primary goals",
			painRelief: "Pain relief",
			posture: "Posture",
			flexibility: "Flexibility",
			coreStability: "Core stability",
			sportSpecific: "Sport-specific",
			stressManagement: "Stress management",
		},

		// Periodic Evaluation
		periodicEvaluation: {
			// A. Visit Details
			visitDetails: "A. Visit Details",
			date: "Date",
			weeksSinceLastEval: "Weeks since last evaluation",
			week1: "1",
			week2: "2",
			week3: "3",
			weeks4to6: "4–6",
			moreThan6: "> 6",
			sessionsCompleted: "Sessions completed this cycle",
			sessions1to5: "1–5",
			sessions6to10: "6–10",
			sessions11to15: "11–15",
			sessionsMore15: "> 15",

			// B. Subjective Status
			subjectiveStatus: "B. Subjective Status (patient‑reported)",
			overallChange: "Overall change since last eval",
			muchBetter: "Much better (≥ 75%)",
			better: "Better (25–74%)",
			noChange: "No change",
			worse: "Worse",
			averagePain: "Average pain (last 24 h)",
			painNone: "0 None",
			painMild: "1–3 Mild",
			painModerate: "4–6 Moderate",
			painSevere: "7–10 Severe",
			symptomFrequency: "Symptom frequency",
			rare: "Rare (< 1× wk)",
			intermittent: "Intermittent",
			constant: "Constant",
			newSymptoms: "New / expanded symptoms",
			none: "None",
			newPainArea: "New pain area",
			swelling: "Swelling",
			numbnessTingling: "Numbness/tingling",
			instability: "Instability",
			other: "Other",
			activitiesAchievable: "Activities now achievable",
			adlsPainFree: "ADLs pain‑free",
			fullWorkDuties: "Full work duties",
			recreationalExercise: "Recreational exercise",
			sportDrills: "Sport drills",
			fullSport: "Full sport",
			stillLimited: "Still limited",

			// C. Adherence & Lifestyle
			adherenceLifestyle: "C. Adherence & Lifestyle",
			homeExerciseCompliance: "Home‑exercise compliance",
			over80: "≥ 80%",
			between50and79: "50–79%",
			between1and49: "1–49%",
			zero: "0%",
			pilatesAttendance: "Pilates class attendance",
			allScheduled: "All scheduled",
			missed1to2: "Missed 1–2",
			missedMore2: "Missed > 2",
			paused: "Paused",
			sleepQuality: "Sleep quality",
			improved: "Improved",
			same: "Same",
			worsened: "Worsened",
			stressLevel: "Stress level",
			lower: "Lower",
			higher: "Higher",
			nutritionHydration: "Nutrition / hydration adequate",
			yes: "Yes",
			needsWork: "Needs work",

			// D. Objective Re‑Assessment
			objectiveReassessment: "D. Objective Re‑Assessment",
			postureAlignment: "Posture alignment",
			cervicalROM: "Cervical ROM",
			shoulderROM: "Shoulder ROM",
			lumbarFlexExtend: "Lumbar flex/extend",
			hipMobility: "Hip mobility",
			hamstringLength: "Hamstring length",
			coreEndurance: "Core endurance (plank)",
			gluteStrength: "Glute strength",
			singleLegBalance: "Single‑leg balance 10 s",
			functionalMovementScore: "Functional movement score",
			wnl: "WNL",

			// E. Pilates Proficiency
			pilatesProficiency: "E. Pilates Proficiency",
			matworkLevel: "Matwork level achieved",
			fundamentals: "Fundamentals",
			beginnerFlow: "Beginner flow",
			intermediate: "Intermediate",
			advanced: "Advanced",
			reformerSkill: "Reformer",
			cadillacSkill: "Cadillac",
			chairSkill: "Chair",
			beginner: "Beg",
			breathing: "Breathing",
			centering: "Centering",
			control: "Control",
			good: "Good",
			fair: "Fair",
			poor: "Poor",

			// F. Outcome‑Measure Snapshot
			outcomeMeasures: "F. Outcome‑Measure Snapshot",
			disabilityFunctionScore: "Disability / function score",
			better20Plus: "≥ 20% better",
			better10to19: "10–19% better",
			functionalScale: "Patient‑Specific Functional Scale",
			goalsMet: "Goals met",
			partiallyMet: "Partially met",
			notMet: "Not met",

			// G. Red‑Flag Check
			redFlagCheck: "G. Red‑Flag Check (since last eval)",
			redFlags: "Red flags",
			nightPain: "Night pain",
			weightLoss: "Unexplained weight loss",
			feverChills: "Fever/chills",
			bowelBladder: "Bowel/bladder changes",
			neuroDeficit: "Progressive neuro deficit",

			// H. Adverse Events
			adverseEvents: "H. Adverse Events",
			adverseEventsTitle: "Adverse events",
			soreness: "Post‑session soreness > 48 h",
			dizziness: "Dizziness",
			skinReaction: "Skin reaction",

			// I. Plan Forward
			planForward: "I. Plan Forward",
			treatmentFrequency: "Treatment frequency",
			maintain: "Maintain",
			increase: "Increase",
			decrease: "Decrease",
			discharge: "Discharge next visit",
			programAdjustments: "Program adjustments",
			progressLoad: "Progress load/complexity",
			addApparatus: "Add new Pilates apparatus",
			sportSpecific: "Introduce sport‑specific drills",
			workConditioning: "Work conditioning",
			maintenance: "Shift to maintenance/wellness",
			referralsNeeded: "Referrals needed",
			physician: "Physician",
			imaging: "Imaging",
			specialist: "Specialist (e.g., nutrition, mental health)",
			updatedGoals: "Updated goals set",
			continueExisting: "Continue existing",
		},

		// Treatment Plan
		treatmentPlan: {
			schedule: "Schedule",
			additionalSettings: "Additional Settings",
			// 1. Interventions Planned
			interventionsPlanned: "1 · Interventions Planned",

			// A. Manual Therapy
			manualTherapy: "A. Manual Therapy",
			softTissueRelease: "Soft‑tissue release",
			jointMobilisation: "Joint mobilisation",
			manipulation: "Manipulation",
			myofascialRelease: "Myofascial release",

			// B. Therapeutic Exercise / Pilates
			therapeuticExercisePilates: "B. Therapeutic Exercise / Pilates",
			rangeOfMotionDrills: "Range‑of‑motion drills",
			stretching: "Stretching",
			strengthening: "Strengthening",
			neuromuscularReEd: "Neuromuscular re‑ed",
			pilatesMatFundamentals: "Pilates mat fundamentals",
			pilatesReformer: "Pilates reformer",
			pilatesChairCadillac: "Pilates chair / cadillac",
			sportSpecificConditioning: "Sport‑specific conditioning",
			functionalMovementReTraining: "Functional movement re‑training",

			// C. Modalities / Adjuncts
			modalitiesAdjuncts: "C. Modalities / Adjuncts",
			heatCryotherapy: "Heat / Cryotherapy",
			tensNmes: "TENS / NMES",
			ultrasound: "Ultrasound",
			dryNeedling: "Dry needling",
			kTaping: "K‑Taping",
			traction: "Traction",
			bracingOrthosis: "Bracing / orthosis",

			// D. Education & Self‑Management
			educationSelfManagement: "D. Education & Self‑Management",
			postureErgonomics: "Posture / ergonomics",
			bodyMechanics: "Body‑mechanics",
			breathingRelaxation: "Breathing & relaxation",
			homeExerciseProgram: "Home exercise program (HEP)",
			lifestyleSleepHydration: "Lifestyle / sleep / hydration cues",

			// 2. Frequency & Duration
			frequencyDuration: "2 · Frequency & Duration",
			inClinicSessions: "In‑clinic sessions",
			onePerWeek: "1 × wk",
			twoPerWeek: "2 × wk",
			threePerWeek: "3 × wk",
			cycleLength: "Cycle length",
			threeWeeks: "3 wks",
			fourWeeks: "4 wks",
			sixWeeks: "6 wks",
			eightWeeks: "8 wks",
			hepDosage: "HEP dosage",
			daily: "Daily",
			fivePerWeek: "5 × wk",
			threePerWeekHep: "3 × wk",
			reEvaluationFrequency: "Next re‑evaluation",
			fourWeeksReEval: "4 weeks",
			sixWeeksReEval: "6 weeks",
			nextReEvaluationDate: "Next re‑evaluation date",
			otherFrequency: "Other frequency",
			otherFrequencyPlaceholder: "Specify other frequency",
			otherHepDosage: "Other HEP dosage",
			otherHepDosagePlaceholder: "Specify other HEP dosage",

			// 3. Required Equipment / Referrals
			requiredEquipmentReferrals: "3 · Required Equipment / Referrals",
			equipmentReferralsTitle: "Equipment / Referrals",
			none: "None",
			braceSplint: "Brace / splint",
			assistiveDevice: "Assistive device",
			imagingRequest: "Imaging request",
			physicianFollowUp: "Physician follow‑up",
			nutritionMentalHealthConsult: "Nutrition / mental‑health consult",
			otherEquipment: "Other equipment",
			otherEquipmentPlaceholder: "Specify other equipment",

			// 4. Observations
			observations: "4 · Observations",
			observationsPlaceholder: "Enter your observations and notes here...",
		},

		// Other Records
		other: {
			basicInformation: "Basic Information",
			findingsAndActions: "Findings & Actions",
			followUp: "Follow-up",
			category: "Category",
			categoryPlaceholder: "Enter category",
			details: "Details",
			detailsPlaceholder: "Enter detailed information about this record",
			relevantFindings: "Relevant Findings",
			relevantFindingsPlaceholder:
				"Enter any relevant findings or observations",
			actionItems: "Action Items",
			actionItemsPlaceholder: "Enter action items or next steps",
			followUpRequired: "Follow-up Required",
			followUpDate: "Follow-up Date",
		},
	},
	events: {
		title: "Events",
		description: "Manage automated events and messaging for your studio",
		accessDenied: "You don't have permission to access events.",
		birthdayEvents: {
			title: "Birthday Events",
			description: "Manage birthday celebrations and automated messages",
			upcomingTitle: "Upcoming Birthdays",
			configurationTitle: "Birthday Event Configuration",
			noUpcomingEvents: "No upcoming birthdays in the next 30 days",
			customerName: "Customer",
			birthday: "Birthday",
			daysUntil: "Days Until",
			age: "Age",
			actions: "Actions",
			sendMessage: "Send Message",
			markAsSent: "Mark as Sent",
			configuration: {
				enabled: "Enable Birthday Messages",
				enabledDescription: "Automatically send birthday messages to customers",
				timing: "Message Timing",
				timingDescription: "When to send birthday messages",
				daysBeforeLabel: "Days before birthday",
				onBirthdayLabel: "On birthday",
				daysAfterLabel: "Days after birthday",
				messageTemplate: "Message Template",
				messageTemplateDescription: "Customize the birthday message template",
				defaultTemplate:
					"Happy Birthday {{customerName}}! 🎉 Wishing you a wonderful day filled with joy and happiness. Thank you for being part of our Pilates family!",
				channels: "Communication Channels",
				channelsDescription: "Select how to send birthday messages",
				email: "Email",
				whatsapp: "WhatsApp",
				sms: "SMS",
				saveConfiguration: "Save Configuration",
				configurationSaved: "Birthday event configuration saved successfully",
				configurationError: "Failed to save configuration. Please try again.",
			},
		},
		paymentReminders: {
			title: "Payment Reminder Events",
			description: "Manage payment reminders and automated notifications",
			upcomingTitle: "Upcoming Payment Reminders",
			configurationTitle: "Payment Reminder Configuration",
			noUpcomingEvents: "No upcoming payment reminders",
			customerName: "Customer",
			planName: "Plan",
			dueDate: "Due Date",
			amount: "Amount",
			daysUntilDue: "Days Until Due",
			actions: "Actions",
			sendReminder: "Send Reminder",
			markAsSent: "Mark as Sent",
			configuration: {
				enabled: "Enable Payment Reminders",
				enabledDescription: "Automatically send payment reminder messages",
				timing: "Reminder Timing",
				timingDescription: "When to send payment reminders",
				daysBeforeLabel: "Days before due date",
				onDueDateLabel: "On due date",
				daysAfterLabel: "Days after due date (overdue)",
				messageTemplate: "Message Template",
				messageTemplateDescription:
					"Customize the payment reminder message template",
				defaultTemplate:
					"Hi {{customerName}}, this is a friendly reminder that your {{planName}} payment of {{amount}} {{currency}} is due on {{dueDate}}. Please make your payment to continue enjoying our services.",
				overdueTemplate: "Overdue Message Template",
				overdueTemplateDescription: "Message for overdue payments",
				defaultOverdueTemplate:
					"Hi {{customerName}}, your {{planName}} payment of {{amount}} {{currency}} was due on {{dueDate}} and is now overdue. Please make your payment as soon as possible to avoid service interruption.",
				channels: "Communication Channels",
				channelsDescription: "Select how to send payment reminders",
				email: "Email",
				whatsapp: "WhatsApp",
				sms: "SMS",
				saveConfiguration: "Save Configuration",
				configurationSaved: "Payment reminder configuration saved successfully",
				configurationError: "Failed to save configuration. Please try again.",
			},
		},
	},
	notifications: {
		config: {
			toasts: {
				updating: "Updating notification settings...",
				updateSuccess: "Notification settings updated successfully",
				updateError: "Failed to update notification settings",
			},
		},
		exclusions: {
			toasts: {
				adding: "Adding exclusion...",
				addSuccess: "Customer excluded from notifications",
				addError: "Failed to exclude customer",
				removing: "Removing exclusion...",
				removeSuccess: "Customer re-enabled for notifications",
				removeError: "Failed to remove exclusion",
			},
		},
		channels: {
			title: "Notification Channels",
			description: "Choose which channels to use for sending notifications",
			email: "Email",
			emailDescription: "Send notifications via email",
			sms: "SMS",
			smsDescription: "Send notifications via text message",
			whatsapp: "WhatsApp",
			whatsappDescription: "Send notifications via WhatsApp",
			smsTemplate: "SMS Template",
			smsTemplateDescription:
				"Customize the SMS message content (max 160 characters)",
			smsBodyLabel: "SMS Message",
			smsBodyPlaceholder: "Enter your SMS message here...",
			smsCharLimit: "Character limit: 160",
			whatsappTemplate: "WhatsApp Template",
			whatsappTemplateDescription: "Customize the WhatsApp message content",
			whatsappBodyLabel: "WhatsApp Message",
			whatsappBodyPlaceholder: "Enter your WhatsApp message here...",
			whatsappHint: "WhatsApp messages support emojis and basic formatting",
		},
		birthdayReminder: {
			title: "Birthday Reminder Configuration",
			description: "Configure automated birthday emails sent to your customers",
			enableTitle: "Birthday Notifications",
			enableDescription:
				"Enable or disable automated birthday email notifications",
			enableLabel: "Send birthday reminder emails",
			messageTitle: "Email Template",
			messageDescription: "Customize the birthday email content",
			subjectLabel: "Email Subject",
			subjectPlaceholder: "Happy Birthday from Pilates Studio!",
			bodyLabel: "Email Body",
			bodyPlaceholder:
				"Happy Birthday {{customerName}}! We wish you a wonderful day filled with joy.",
			templateHint:
				"Use {{customerName}} to include the customer's name in the message",
			variablesButton: "Variables",
			variablesTitle: "Available Template Variables",
			variablesDescription:
				"Click the copy button to copy a variable, then paste it into your template.",
			useTemplateButton: "Use Template",
			variables: {
				customerName: "Customer's full name",
				customerFirstName: "Customer's first name",
				customerLastName: "Customer's last name",
				organizationName: "Your organization name",
			},
			exclusionsTitle: "Excluded Customers",
			exclusionsDescription:
				"These customers will not receive birthday notifications",
			noExclusions: "No customers are excluded from birthday notifications",
			reason: "Reason",
			moreExclusions: "Showing 10 of {{total}} excluded customers",
			addExclusion: "Add Customer",
			addExclusionTitle: "Exclude Customer from Birthday Notifications",
			addExclusionDescription:
				"Search for a customer to exclude from receiving birthday notifications.",
			searchCustomerPlaceholder: "Search by name or email...",
			searchMinChars: "Type at least 2 characters to search",
			noCustomersFound: "No customers found",
			alreadyExcluded: "Already excluded",
			reasonLabel: "Reason (optional)",
			reasonPlaceholder: "e.g., Customer requested no emails",
			reasonHint: "Provide a reason for excluding this customer",
			addExclusionButton: "Exclude Customer",
		},
		enrollmentExpiry: {
			title: "Enrollment Expiry Reminder Configuration",
			description:
				"Configure automated reminders sent before customer enrollments expire",
			enableTitle: "Enrollment Expiry Notifications",
			enableDescription:
				"Enable or disable automated enrollment expiry reminder emails",
			enableLabel: "Send enrollment expiry reminder emails",
			configTitle: "Reminder Settings",
			configDescription: "Configure when reminders should be sent",
			notifyOnExpiryDayLabel: "Notify on expiry day",
			notifyOnExpiryDayDescription:
				"Send a reminder on the day the enrollment expires",
			notifyDaysBeforeLabel: "Notify before expiry",
			notifyDaysBeforeDescription:
				"Send a reminder a specified number of days before the enrollment expires",
			daysBeforeExpiryLabel: "Days before expiry",
			daysBeforeExpiryHint: "days before enrollment expires",
			messageTitle: "Email Template",
			messageDescription:
				"Customize the enrollment expiry reminder email content",
			subjectLabel: "Email Subject",
			subjectPlaceholder: "Your enrollment is expiring soon",
			bodyLabel: "Email Body",
			bodyPlaceholder:
				"Dear {{customerName}}, your enrollment for {{planName}} will expire on {{expiryDate}}.",
			templateHint:
				"Use template variables to personalize the message for each customer",
			useTemplateButton: "Use Template",
			variablesButton: "Variables",
			variablesTitle: "Available Template Variables",
			variablesDescription:
				"Click the copy button to copy a variable, then paste it into your template.",
			variables: {
				customerName: "Customer's full name",
				customerFirstName: "Customer's first name",
				customerLastName: "Customer's last name",
				organizationName: "Your organization name",
				planName: "The name of the customer's plan",
				expiryDate: "The enrollment expiry date",
				daysRemaining: "Number of days until expiry",
			},
			exclusionsTitle: "Excluded Customers",
			exclusionsDescription:
				"These customers will not receive enrollment expiry reminders",
			noExclusions:
				"No customers are excluded from enrollment expiry notifications",
			reason: "Reason",
			moreExclusions: "Showing 10 of {{total}} excluded customers",
			addExclusion: "Add Customer",
			addExclusionTitle:
				"Exclude Customer from Enrollment Expiry Notifications",
			addExclusionDescription:
				"Search for a customer to exclude from receiving enrollment expiry reminders.",
			searchCustomerPlaceholder: "Search by name or email...",
			searchMinChars: "Type at least 2 characters to search",
			noCustomersFound: "No customers found",
			alreadyExcluded: "Already excluded",
			reasonLabel: "Reason (optional)",
			reasonPlaceholder: "e.g., Customer has auto-renewal",
			reasonHint: "Provide a reason for excluding this customer",
			addExclusionButton: "Exclude Customer",
		},
	},
	establishments: {
		searchPlaceholder: "Search establishment",
		selector: {
			title: "Select Establishment",
			description: "Choose the establishment you want to work with",
			select: "Select",
			noAccess: "No Access",
			noAccessDescription: "You don't have access to any establishments",
			contactAdmin: "Please contact your administrator for access",
			errorLoading: "Error loading establishments",
		},
		management: {
			title: "Establishments",
			description: "Manage your organization's establishments",
			createNew: "Create New Establishment",
			noEstablishments: "No Establishments",
			noEstablishmentsDescription: "You haven't created any establishments yet",
			noEstablishmentsSearchDescription: "No establishments match your search",
			createFirst: "Create Your First Establishment",
			filterByEstablishment: "Filter by Establishment",
			table: {
				name: "Name",
				description: "Description",
				address: "Address",
				phone: "Phone",
				email: "Email",
				createdAt: "Created",
				actions: "Actions",
			},
			form: {
				sections: {
					basicInfo: "Basic Information",
					identity: "Identity",
					location: "Location",
					contact: "Contact",
				},
				title: "New establishment",
				modalSubtitle:
					"Only the name is required. Address and contact can come later.",
				optional: "optional",
				counter: "{{current}}/{{max}}",
				name: "Name",
				namePlaceholder: "Studio Paulista",
				nameHint: "How staff and clients will see this location.",
				description: "Description",
				descriptionPlaceholder:
					"Two studios, reformer pilates and physiotherapy.",
				address: "Address",
				streetAddress: "Street address",
				addressPlaceholder: "Av. Paulista 1000",
				phone: "Phone",
				phonePlaceholder: "(11) 3222-1100",
				email: "Email",
				emailPlaceholder: "paulista@studio.com",
				emailInvalid: "That email address looks incomplete.",
				contactHint: "Shown to clients on receipts and booking confirmations.",
				create: "Create establishment",
				update: "Update establishment",
				cancel: "Cancel",
				creating: "Creating...",
				updating: "Updating...",
			},
			actions: {
				edit: "Edit",
				delete: "Delete",
				confirmDelete: "Are you sure you want to delete this establishment?",
				confirmDeleteDescription:
					"This action cannot be undone. All data associated with this establishment will be permanently deleted.",
				confirmDeleteWarning:
					"Warning: All schedules associated with this establishment will also be deleted.",
				confirmDeletePhrase: "confirm and delete",
			},
			messages: {
				createSuccess: "Establishment created successfully",
				createError: "Failed to create establishment. Please try again.",
				updateSuccess: "Establishment updated successfully",
				updateError: "Failed to update establishment. Please try again.",
				deleteSuccess: "Establishment deleted successfully",
				deleteError: "Failed to delete establishment. Please try again.",
				loadError: "Failed to load establishments. Please try again.",
			},
			toasts: {
				creating: "Creating establishment...",
				createSuccess: "Establishment created successfully!",
				createError: "Failed to create establishment. Please try again.",
				updating: "Updating establishment...",
				updateSuccess: "Establishment updated successfully!",
				updateError: "Failed to update establishment. Please try again.",
				deleting: "Deleting establishment...",
				deleteSuccess: "Establishment deleted successfully!",
				deleteError: "Failed to delete establishment. Please try again.",
			},
		},
	},
	staff: {
		searchPlaceholder: "Search staff members and invitations...",
		noStaffFound: "No staff members found",
		management: {
			title: "Staff Management",
			description:
				"Manage the staff members of your organization and their roles",
			inviteNew: "Invite New Staff Member",
			inviteDescription:
				"Send an invitation to a new staff member to join your organization",
			noStaff: "No staff members yet",
			noStaffDescription:
				"Get started by inviting your first staff member to join your organization.",
			noStaffSearchDescription:
				"No staff members or invitations found matching your search criteria.",
			filterByStaff: "Filter by Instructor",
		},
		navigation: {
			title: "Staff Member Details",
			description: "View and manage staff member information",
			unknownStaff: "Unknown Staff Member",
			overview: "Overview",
			staffData: "Staff Data",
			permissions: "Role & Permissions",
		},
		overview: {
			totalSchedules: "Total Schedules",
			personalInformation: "Personal Information",
			organizationInformation: "Organization Information",
			role: "Role",
			joinedAt: "Joined At",
			quickActions: {
				removeStaffMember: "Remove Staff Member",
				revokeInvitation: "Revoke Invitation",
				migrateSchedules: "Migrate Schedules",
			},
			revokeInvitation: {
				title: "Revoke Invitation",
				description:
					"Are you sure you want to revoke the invitation for {{name}}?",
			},
			invitationInfo: {
				title: "Invitation Details",
				email: "Email",
				role: "Role",
				expiresAt: "Expires",
			},
		},
		edit: {
			title: "Edit Staff Member",
			description: "Edit {{name}}'s information and permissions",
		},
		schedules: {
			title: "Assigned Schedules",
			description: "View all schedules assigned to this staff member",
			noSchedules: "No schedules assigned",
			noSchedulesDescription:
				"This staff member is not currently assigned to any schedules.",
		},
		permissions: {
			title: "Role & Permissions",
			description: "Manage staff member's role and establishment access",
		},

		table: {
			member: "Staff Member",
			role: "Role",
			status: "Status",
			joinedAt: "Joined At",
			actions: "Actions",
		},
		form: {
			sections: {
				contact: "Contact Information",
				permissions: "Role & Permissions",
				information: {
					title: "Staff Information",
					description: "Basic information about the staff member",
					editMode: "Edit your name",
					firstName: "First Name",
					lastName: "Last Name",
					firstNamePlaceholder: "Enter first name",
					lastNamePlaceholder: "Enter last name",
					color: "Color",
					colorDescription:
						"This color will be used to identify this staff member in schedules and calendars",
					saveChanges: "Save Changes",
					cancel: "Cancel",
					updateSuccess: "Name updated successfully",
					updateError: "Failed to update name. Please try again.",
				},
				organizationRole: {
					title: "Organization Role",
					description:
						"Set the organization-level role and permissions for this staff member",
				},
				establishments: {
					title: "Establishment Access",
					description:
						"Assign this staff member to establishments for data access",
				},
			},
			email: "Email Address",
			emailPlaceholder: "Enter email address",
			name: "Name (Optional)",
			namePlaceholder: "Enter full name",
			role: "Role",
			joinedAt: "Joined on {{date}}",
			organizationRole: "Organization Role",
			organizationRoleDescription:
				"This role determines what features the staff member can access across the organization",
			selectOrganizationRole: "Select an organization role",
			organizationRolesHeader: "Organization Roles",
			assignEstablishment: "Assign to Establishment",
			assignEstablishmentDescription:
				"Select an establishment to give this staff member access to its data",
			assignEstablishments: "Assign to Establishments",
			assignEstablishmentsDescription:
				"Select establishments to give this staff member access to their data",
			selectEstablishment: "Select establishment",
			selectedEstablishments: "{{count}} establishment(s) selected",
			currentAssignments: "Currently Assigned To",
			availableEstablishments: "Available Establishments",
			assignedOn: "assigned on {{date}}",
			removeAssignment: "Remove assignment",
			allEstablishmentsAssigned:
				"This staff member is already assigned to all establishments",
			updateRole: "Update Role",
			assign: "Assign",
			assignSelected: "Assign Selected",
			viewPermissions: "View Permissions",
			permissionsMatrix: "Permissions Matrix",
			rolePermissionsMatrix: "Role Permissions Matrix",
			permissionsDescription:
				"Below are the permissions granted to the selected role.",
			permissionsMatrixDescription:
				"This matrix shows all permissions for each role in the organization.",
			permission: "Permission",
			roleDescription: {
				title: "Role Permissions:",
				administrator:
					"Can manage all aspects of the organization including staff, establishments, and settings.",
				viewer:
					"Can view organization data but cannot make changes or manage other staff members.",
			},
			roleDescriptions: {
				org_owner: "Full access to all organization features and settings",
				org_administrator:
					"Manage organization settings, staff, and all features",
				org_manager: "Manage daily operations, staff, and most features",
				org_medical_professional:
					"Access to medical records and related features",
				org_accountant: "Access to financial data and payment management",
				org_viewer: "View-only access to organization data",
				org_instructor_calendar_only:
					"View-only access to attendance calendar and sessions",
				org_no_access: "Suspended — no access to any organization features",
				viewer:
					"Can view organization data but cannot make changes or manage other staff members.",
			},

			sendInvite: "Send Invite",
		},
		editRole: {
			title: "Edit Staff Role",
			description: "Change role for {{name}}",
			organizationRole: "Organization Role",
			organizationRoleDescription:
				"This role applies to the entire organization and determines overall permissions.",
		},
		remove: {
			title: "Remove Staff Member",
			description:
				"Are you sure you want to remove {{name}} from the organization? This action cannot be undone.",
			confirm: "Remove Staff Member",
			loadingSchedules: "Loading schedules...",
			schedulesWarning:
				"This staff member has {{count}} schedule(s) with upcoming sessions:",
			schedulesBlockedMessage:
				"You must reassign or remove all schedules with future sessions before this staff member can be deleted.",
		},
		status: {
			active: "Active",
			pending: "Pending",
		},
		invitation: {
			expires: "Expires",
			revokeSuccess: "Invitation revoked successfully",
			revokeError: "Failed to revoke invitation. Please try again.",
			revoke: {
				title: "Revoke Invitation",
				description:
					"Are you sure you want to revoke the invitation for {{name}}? This action cannot be undone.",
				confirm: "Revoke Invitation",
			},
		},
		validation: {
			emailRequired: "Email is required",
		},
		inviteSuccess: "Staff invitation sent successfully",
		inviteError: "Failed to send staff invitation. Please try again",
		roleUpdateSuccess: "Staff role updated successfully",
		roleUpdateError: "Failed to update staff role. Please try again.",
		removeSuccess: "Staff member removed successfully",
		removeError: "Failed to remove staff member. Please try again.",
		toasts: {
			inviting: "Sending staff invitation...",
			inviteSuccess: "Staff invitation sent successfully!",
			inviteError: "Failed to send staff invitation. Please try again.",
			updating: "Updating staff role...",
			updateSuccess: "Staff role updated successfully!",
			updateError: "Failed to update staff role. Please try again.",
			removing: "Removing staff member...",
			removeSuccess: "Staff member removed successfully!",
			removeError: "Failed to remove staff member. Please try again.",
			revoking: "Revoking invitation...",
			revokeSuccess: "Invitation revoked successfully!",
			revokeError: "Failed to revoke invitation. Please try again.",
		},
		actions: {
			assignToEstablishment: "Assign to Establishment",
		},
		migrateSchedules: {
			title: "Migrate Schedules",
			description:
				"Select schedules to migrate and assign them to target staff members.",
			warning:
				"This action will transfer the selected schedules and their sessions to the assigned staff members. This operation cannot be easily undone.",
			searchPlaceholder: "Search schedules...",
			assignSelectedTo: "Assign selected to:",
			assignButton: "Assign",
			selectTargetPlaceholder: "Select a staff member...",
			assignedCount: "{{count}} schedule(s) assigned to migrate",
			noAssignments: "No schedules assigned yet",
			continueButton: "Continue",
			confirmationWarning:
				"You are about to migrate {{count}} schedule(s). This action cannot be easily undone.",
			confirmationDescription:
				"All assigned schedules and their sessions will be transferred to the selected staff members.",
			assignmentSummary: "Assignment Summary",
			schedulesCount_one: "schedule",
			schedulesCount_other: "schedules",
			confirmLabel: 'Type "confirm" to proceed',
			confirmPlaceholder: "confirm",
			confirmButton: "Migrate Schedules",
			toasts: {
				migrating: "Migrating schedules...",
				migrateSuccess: "Schedules migrated successfully!",
				migrateError: "Failed to migrate schedules. Please try again.",
			},
		},
		assignEstablishment: {
			title: "Assign to Establishment",
			description: "Assign {{name}} to an establishment with a specific role",
			establishment: "Establishment",
			selectEstablishment: "Select an establishment",
			role: "Establishment Role",
			establishmentRole: "Establishment Role",
			establishmentRoleDescription:
				"This role applies only to the selected establishment and determines local permissions.",
			selectEstablishmentRole: "Select an establishment role",
			establishmentRolesHeader: "Establishment-Level Roles",
			confirm: "Assign to Establishment",
			roleDescriptions: {
				establishment_manager:
					"Manage all aspects of this specific establishment",
				instructor:
					"Conduct classes and manage schedules at this establishment",
				receptionist: "Handle front desk operations and customer service",
				medical_staff: "Provide medical services and manage health records",
				assistant: "Support daily operations and assist other staff",
				viewer: "View establishment information without making changes",
			},
		},
	},
	establishmentStaff: {
		toasts: {
			assigning: "Assigning staff to establishment...",
			assignSuccess: "Staff assigned to establishment successfully!",
			assignError: "Failed to assign staff to establishment. Please try again.",
			bulkAssigning: "Assigning staff to establishments...",
			bulkAssignSuccess: "Staff assigned to establishments successfully!",
			bulkAssignError:
				"Failed to assign staff to establishments. Please try again.",
			updating: "Updating establishment staff role...",
			updateSuccess: "Establishment staff role updated successfully!",
			updateError:
				"Failed to update establishment staff role. Please try again.",
			removing: "Removing staff from establishment...",
			removeSuccess: "Staff removed from establishment successfully!",
			removeError:
				"Failed to remove staff from establishment. Please try again.",
		},
	},
	billing: {
		monthly: "Monthly",
		quarterly: "Quarterly",
		semi_annual: "Semi-Annual",
		annually: "Annually",
		status: {
			DRAFT: "Draft",
			OPEN: "Open",
			PARTIALLY_PAID: "Partially Paid",
			PAID: "Paid",
			OVERDUE: "Overdue",
			CANCELED: "Canceled",
		},
		paymentStatus: {
			PENDING: "Pending",
			PROCESSING: "Processing",
			SUCCEEDED: "Succeeded",
			PARTIALLY_REFUNDED: "Partially Refunded",
			REFUNDED: "Refunded",
			CHARGEBACK_PENDING: "Chargeback Pending",
			CHARGEBACK_LOST: "Chargeback Lost",
			FAILED: "Failed",
			CANCELED: "Canceled",
		},
		navigation: {
			title: "Billing",
			invoices: "Invoices",
			payments: "Payments",
		},
		invoices: {
			title: "Invoices",
			description: "Manage invoices and billing",
			noInvoices: "No invoices found",
			noInvoicesDescription: "You haven't created any invoices yet",
			noInvoicesSearchDescription: "No invoices found matching your search",
			createFirst: "Create Your First Invoice",
			searchPlaceholder: "Search by invoice #, customer, or amount...",
			createInvoice: "Create Invoice",
			invoiceNumber: "Invoice #",
			customer: "Customer",
			enrollment: "Enrollment",
			amount: "Amount",
			amountDue: "Amount Due",
			amountPaid: "Amount Paid",
			payments: "Payments",
			dueDate: "Due Date",
			issueDate: "Issue Date",
			status: "Status",
			lineItems: "Line Items",
			periodStart: "Period Start",
			periodEnd: "Period End",
			notes: "Notes",
			actions: {
				create: "Create Invoice",
				view: "View Invoice",
				edit: "Edit Invoice",
				issue: "Issue Invoice",
				cancel: "Cancel Invoice",
				recordPayment: "Record Payment",
			},
			statuses: {
				DRAFT: "Draft",
				OPEN: "Open",
				PARTIALLY_PAID: "Partially Paid",
				PAID: "Paid",
				OVERDUE: "Overdue",
				CANCELED: "Canceled",
			},
			toasts: {
				creating: "Creating invoice...",
				createSuccess: "Invoice created successfully!",
				createError: "Failed to create invoice. Please try again.",
				updating: "Updating invoice...",
				updateSuccess: "Invoice updated successfully!",
				updateError: "Failed to update invoice. Please try again.",
				issuing: "Issuing invoice...",
				issueSuccess: "Invoice issued successfully!",
				issueError: "Failed to issue invoice. Please try again.",
				canceling: "Canceling invoice...",
				cancelSuccess: "Invoice canceled successfully!",
				cancelError: "Failed to cancel invoice. Please try again.",
			},
			cancelDialog: {
				title: "Cancel Invoice",
				description:
					"Are you sure you want to cancel invoice {{invoiceNumber}}? This action cannot be undone.",
				invoiceInfoTitle: "Invoice details",
				confirm: "Yes, cancel invoice",
				loading: "Canceling invoice...",
			},
		},
		payments: {
			title: "Payments",
			description: "View and manage payments",
			noPayments: "No payments found",
			recordPayment: "Record Payment",
			amount: "Amount",
			method: "Method",
			status: "Status",
			paidAt: "Paid At",
			invoice: "Invoice",
			customer: "Customer",
			customerName: "Customer Name",
			reference: "Reference",
			notes: "Notes",
			walkInCustomer: "Walk-in Customer",
			actions: {
				view: "View Payment",
				cancel: "Cancel Payment",
				refund: "Refund",
			},
			statuses: {
				PENDING: "Pending",
				PROCESSING: "Processing",
				SUCCEEDED: "Succeeded",
				PARTIALLY_REFUNDED: "Partially Refunded",
				REFUNDED: "Refunded",
				CHARGEBACK_PENDING: "Chargeback Pending",
				CHARGEBACK_LOST: "Chargeback Lost",
				FAILED: "Failed",
				CANCELED: "Canceled",
			},
			methods: {
				CARD: "Card",
				PIX: "PIX",
				BOLETO: "Boleto",
				CASH: "Cash",
				BANK_TRANSFER: "Bank Transfer",
				OTHER: "Other",
			},
			toasts: {
				creating: "Recording payment...",
				createSuccess: "Payment recorded successfully!",
				createError: "Failed to record payment. Please try again.",
				canceling: "Canceling payment...",
				cancelSuccess: "Payment canceled successfully!",
				cancelError: "Failed to cancel payment. Please try again.",
			},
		},
		refunds: {
			title: "Refunds",
			description: "View and manage refunds",
			createRefund: "Create Refund",
			amount: "Amount",
			reason: "Reason",
			status: "Status",
			processedAt: "Processed At",
			statuses: {
				PENDING: "Pending",
				PROCESSING: "Processing",
				SUCCEEDED: "Succeeded",
				FAILED: "Failed",
			},
			toasts: {
				creating: "Processing refund...",
				createSuccess: "Refund processed successfully!",
				createError: "Failed to process refund. Please try again.",
			},
		},
		invoiceDetails: {
			title: "Invoice Details",
			description: "View and manage invoice details",
			tabs: {
				overview: "Overview",
				payments: "Payments",
				refunds: "Refunds",
				disputes: "Disputes",
			},
			overview: {
				invoiceId: "Invoice ID",
				customer: "Customer",
				dates: "Dates",
				issuedAt: "Issued",
				dueDate: "Due Date",
				paidAt: "Paid",
				summary: "Summary",
				total: "Total",
				paid: "Paid",
				remaining: "Remaining",
				lineItems: "Line Items",
				description: "Description",
				quantity: "Qty",
				unitPrice: "Unit Price",
				amount: "Amount",
				recentPayments: "Recent Payments",
				unknownMethod: "Unknown",
				notes: "Notes",
			},
			payments: {
				title: "Payments",
				paidOf: "{{paid}} paid of {{total}}",
				recordPayment: "Record Payment",
				paymentsList: "Payments List",
				noPayments: "No payments recorded yet",
				date: "Date",
				method: "Method",
				status: "Status",
				reference: "Payment Ref",
				refundedAmount: "Refunded Amount",
				amount: "Amount",
				actions: "Actions",
				unknownMethod: "Unknown",
				refund: "Refund",
				remainingBalance: "Remaining Balance",
			},
			refunds: {
				title: "Refunds",
				description: "View refunds for this invoice",
				refundsList: "Refunds List",
				noRefunds: "No refunds recorded",
				noRefundsHint: "Refunds can be created from the Payments tab",
				date: "Date",
				paymentRef: "Payment Ref",
				reason: "Reason",
				status: "Status",
				amount: "Amount",
			},
			disputes: {
				title: "Disputes",
				description: "View disputes for this invoice",
				disputesList: "Disputes List",
				noDisputes: "No disputes recorded",
				noDisputesHint: "Disputes are synced from payment providers",
				date: "Date",
				type: "Type",
				reason: "Reason",
				status: "Status",
				amount: "Amount",
			},
		},
		refund: {
			title: "Create Refund",
			description: "Refund payment of {{paymentAmount}}",
			refundType: "Refund Type",
			fullRefund: "Full Refund",
			invoiceLine: "Invoice Line (Product Return)",
			customAmount: "Custom Amount",
			selectLine: "Select Invoice Line",
			selectLines:
				"Optional: select line items only to add them as a refund reason",
			selectLinePlaceholder: "Select a line item...",
			quantity: "Quantity to Refund",
			amount: "Refund Amount",
			reason: "Reason for Refund *",
			reasonPlaceholder: "Enter the reason for this refund...",
			autoReason: "Refund for: {{description}} x{{quantity}} (${{amount}})",
			autoReasonMultiple: "Refund for: {{items}} (${{amount}})",
			noLineItems: "No line items available",
			summary: "Refund Summary",
			refundAmount: "Refund Amount",
			exceedsMax: "Amount exceeds maximum refundable",
			readyToProcess: "Ready to process",
			confirm: "Confirm Refund",
		},
		refundStatus: {
			pending: "Pending",
			succeeded: "Succeeded",
			failed: "Failed",
		},
		recordPayment: {
			title: "Record Payment",
			description: "Record a payment for this invoice",
			total: "Total",
			paid: "Paid",
			outstanding: "Outstanding",
			amount: "Payment Amount",
			method: "Payment Method",
			date: "Payment Date",
			reference: "External Reference",
			referencePlaceholder: "PIX transaction ID, check number, etc.",
			notes: "Notes",
			notesPlaceholder: "Any additional notes about this payment...",
			summary: "Payment Summary",
			recordingAmount: "Recording {{amount}} payment via {{method}}",
			remainingAfter: "Remaining balance after payment",
			invoiceWillBe: "Invoice will be marked as",
			exceedsOutstanding: "Amount cannot exceed outstanding balance ({{max}})",
			readyToRecord: "Ready to record",
			confirm: "Record Payment",
		},
		disputeStatus: {
			open: "Open",
			underReview: "Under Review",
			won: "Won",
			lost: "Lost",
		},
		providerAccounts: {
			title: "Payment Methods",
			description: "Manage payment provider accounts",
			noAccounts: "No payment methods configured",
			addAccount: "Add Payment Method",
			accountName: "Account Name",
			provider: "Provider",
			selectProvider: "Select a provider",
			methodName: "Name",
			methodNamePlaceholder: "Enter payment method name",
			supportedMethods: "Supported Methods",
			isDefault: "Default",
			isActive: "Active",
			providers: {
				MANUAL: "Manual",
			},
			toasts: {
				creating: "Creating payment method...",
				createSuccess: "Payment method created successfully!",
				createError: "Failed to create payment method. Please try again.",
				updating: "Updating payment method...",
				updateSuccess: "Payment method updated successfully!",
				updateError: "Failed to update payment method. Please try again.",
				deleting: "Deleting payment method...",
				deleteSuccess: "Payment method deleted successfully!",
				deleteError: "Failed to delete payment method. Please try again.",
			},
		},
		lineItemTypes: {
			enrollment: "Enrollment",
			product: "Product",
			service: "Service",
			discount: "Discount",
			credit: "Credit",
			fee: "Fee",
		},
		currencies: {
			BRL: "Brazilian Real (R$)",
			USD: "US Dollar ($)",
		},
		paymentMethods: {
			card: "Card",
			pix: "PIX",
			boleto: "Boleto",
			cash: "Cash",
			bank_transfer: "Bank Transfer",
			other: "Other",
		},
		wizard: {
			title: "Create Invoice",
			description: "Create a new invoice and optionally record payments",
			steps: {
				invoice: "Invoice Details",
				payment: "Record Payments",
			},
			actions: {
				createInvoice: "Create Invoice",
				proceedToPayment: "Continue to payment",
			},
			invoice: {
				customer: "Customer",
				selectCustomer: "Select Customer",
				selectCustomerDescription:
					"Search and select a customer for this invoice",
				clickToSelect: "Click to select",
				searchCustomerPlaceholder: "Search by name, email, or ID...",
				typeToSearch: "Type at least 2 characters to search",
				noCustomersFound: "No customers found",
				currency: "Currency",
				dueDate: "Due Date",
				lineItems: "Line Items",
				lineItemsDescription: "Add products, services, or enrollments",
				addLineItem: "Add Line Item",
				addFirstItem: "Add First Item",
				addAnotherItem: "Add Another Item",
				noLineItems: "No line items added",
				noLineItemsHint:
					"Add items to create the invoice. Click the button above to start.",
				item: "item",
				items: "items",
				type: "Type",
				description: "Description",
				descriptionPlaceholder: "Enter description...",
				quantity: "Qty",
				unitAmount: "Unit Price",
				total: "Total",
				totalAmount: "Total Amount",
				notes: "Notes",
				notesPlaceholder: "Add any notes for this invoice...",
				selectCustomerFirst: "Select a customer first",
				noEnrollmentsAvailable: "No pending enrollments",
				selectEnrollment: "Select enrollment...",
				ends: "Ends",
				validation: {
					singleCurrencyTitle: "All items must use the same currency",
					singleCurrencyMessage:
						"This invoice contains items in different currencies. Please adjust or remove items so they all use the same currency.",
				},
			},
			payment: {
				invoiceTotal: "Invoice Total",
				totalPaid: "Total Paid",
				outstanding: "Outstanding",
				invoiceFor: "Invoice for",
				noCustomer: "No customer",
				paymentProgress: "Payment progress",
				description:
					"Add payments to record against this invoice. This step is optional - you can skip it and record payments later.",
				addPayment: "Add Payment",
				addAnotherPayment: "Add Another Payment",
				payFullAmount: "Pay Full Amount",
				payCustomAmount: "Pay Custom Amount",
				noPayments: "No payments added",
				noPaymentsHint:
					"You can record the full payment now or skip this step and record later",
				paymentNumber: "Payment #{{number}}",
				paymentSingular: "payment",
				paymentPlural: "payments",
				amount: "Amount",
				method: "Payment Method",
				date: "Payment Date",
				reference: "Reference",
				referencePlaceholder: "Transaction ID, receipt number, etc.",
				notes: "Notes",
				notesPlaceholder: "Additional notes...",
				additionalOptions: "Additional options",
				fullyPaid: "Fully paid",
			},
			confirmation: {
				title: "Review & Confirm",
				description:
					"Review the details below before finalizing. Click 'Create Invoice' to complete.",
				customer: "Customer",
				invoiceSummary: "Invoice Items",
				dueDate: "Due Date",
				paymentsSummary: "Payments to Record",
				fullyPaid: "This invoice will be marked as fully paid",
				partiallyPaid: "Outstanding balance: {{amount}}",
				noPendingPayment: "No payment will be recorded",
			},
		},
	},
	customerPlans: {
		billingCycle: {
			monthly: "Monthly",
			quarterly: "Quarterly",
			semi_annual: "Semi-Annual",
			annually: "Annually",
		},
		billingCyclePlan: {
			monthly: "Monthly plan",
			quarterly: "Quarterly plan",
			semi_annual: "Semi-annual plan",
			annually: "Annual plan",
		},
		management: {
			title: "Customer Plans",
			description: "Manage your organization's customer plans",
			createNew: "Create New Plan",
			noPlans: "No Customer Plans",
			noPlansDescription: "You haven't created any customer plans yet",
			createFirst: "Create Your First Plan",
			delete: {
				title: "Delete Customer Plan",
				description:
					"Are you sure you want to delete this customer plan? This action cannot be undone.",
			},
			table: {
				name: "Name",
				description: "Description",
				price: "Price",
				billingCycle: "Billing Cycle",
				features: "Services Offered",
				establishments: "Establishments",
				allEstablishments: "All Establishments",
				weeklySessionsLimit: "Weekly Sessions",
				status: "Status",
				actions: "Actions",
				totalAmount: "Total Amount",
				monthlyAverage: "Monthly Average",
			},
			form: {
				sections: {
					basicInfo: "Basic Information",
					pricing: "Pricing & Billing",
					features: "Services Offered",
					establishments: "Establishments",
					status: "Plan Status",
				},
				name: "Name",
				namePlaceholder: "e.g., Premium Monthly, Student Plan",
				nameHint:
					"Choose a clear, descriptive name that customers will recognize",
				nameMaxLength: "{{current}}/{{max}} characters",
				description: "Description",
				descriptionPlaceholder:
					"Describe what this plan includes and who it's designed for...",
				descriptionHint:
					"A good description helps customers understand the plan value",
				price: "Price",
				pricePlaceholder: "0.00",
				priceHint: "Set the price for the selected billing cycle",
				currency: "Currency",
				currencyPlaceholder: "Select currency",
				billingCycle: "Billing Cycle",
				billingCycleHint: "How often customers will be billed for this plan",
				billingCycleOptions: {
					MONTHLY: "Monthly",
					QUARTERLY: "Quarterly",
					SEMI_ANNUAL: "Semi-Annual",
					ANNUALLY: "Annually",
				},
				features: "Services",
				featuresPlaceholder:
					"e.g., Access to all equipment, 1-on-1 consultation",
				featuresHint: "List the services and benefits included in this plan",
				addFeature: "Add Service",
				removeFeature: "Remove",
				quickServicesTitle: "Quick add: tap to add popular services",
				quickServices: {
					pilates: "Pilates",
					yoga: "Yoga",
					meditation: "Meditation",
					functionalTraining: "Functional training",
					stretching: "Stretching",
					physiotherapy: "Physiotherapy",
				},
				weeklySessionsLimit: "Weekly Sessions Limit",
				weeklySessionsLimitPlaceholder: "e.g., 3",
				weeklySessionsLimitHint:
					"Optional: Limit sessions per week (1-20). Leave empty for unlimited",
				establishments: "Establishments",
				establishmentsOptional: "optional",
				establishmentsPlaceholder: "Select establishments (optional)",
				establishmentsSelected: "establishments selected",
				clearEstablishments: "Clear All",
				establishmentsHelp:
					"Leave empty to make this plan available in all establishments",
				selectedEstablishments: "Selected Establishments",
				isActive: "Active",
				statusDescription:
					"Active plans are visible to customers and can be purchased",
				statusHint: "Inactive plans won't be available for new enrollments",
				create: "Create Plan",
				update: "Update Plan",
				cancel: "Cancel",
				creating: "Creating...",
				updating: "Updating...",
				requiredFields: "* Required fields",
				modalSubtitle:
					"Define what the customer gets, what they pay and how often.",
				counter: "{{current}}/{{max}}",
				amountPerCycle: "Amount per cycle",
				priceEmptyHint: "The total charged each cycle.",
				priceWeeklyHint: "Works out to {{amount}} per week.",
				sessionsPerWeek: "Sessions per week",
				unlimited: "Unlimited",
				decrementSessions: "One session fewer",
				incrementSessions: "One session more",
				servicesSelectedCount: "{{total}} selected",
				addServicePlaceholder: "Add another service…",
				addServiceButton: "Add",
				allEstablishments: "All units",
				availabilityAllHint:
					"Available in every unit, including the ones you open later.",
				availabilitySpecificHint: "Visible only in the selected units.",
				activateOnCreate: "Activate on create",
				activeOnHint: "Customers will be able to subscribe immediately.",
				activeOffHint: "Saved as a draft, invisible to customers.",
				validation: {
					nameRequired: "Plan name is required",
					descriptionRequired: "Plan description is required",
					priceRequired: "Valid price is required",
					priceInvalid: "Enter a valid price",
					priceTooLarge: "Price must be less than 1,000,000.00",
					featuresRequired: "At least one service is required",
					weeklySessionsLimitInvalid:
						"Weekly sessions limit must be between 1 and 20",
				},
			},
			actions: {
				edit: "Edit",
				delete: "Delete",
				activate: "Activate",
				deactivate: "Deactivate",
				confirmDelete: "Are you sure you want to delete this customer plan?",
				confirmDeleteDescription:
					"This action cannot be undone. All data associated with this plan will be permanently deleted.",
				confirmDeleteWarning:
					"Note: Customer plans with enrolled users cannot be deleted until all related enrollments are removed from this plan.",
			},
			status: {
				active: "Active",
				inactive: "Inactive",
			},
			messages: {
				createSuccess: "Customer plan created successfully",
				createError: "Failed to create customer plan. Please try again.",
				updateSuccess: "Customer plan updated successfully",
				updateError: "Failed to update customer plan. Please try again.",
				deleteSuccess: "Customer plan deleted successfully",
				deleteError: "Failed to delete customer plan. Please try again.",
				loadError: "Failed to load customer plans. Please try again.",
				featuresRequired: "At least one service is required",
			},
			toasts: {
				creating: "Creating customer plan...",
				createSuccess: "Customer plan created successfully!",
				createError: "Failed to create customer plan. Please try again.",
				updating: "Updating customer plan...",
				updateSuccess: "Customer plan updated successfully!",
				updateError: "Failed to update customer plan. Please try again.",
				deleting: "Deleting customer plan...",
				deleteSuccess: "Customer plan deleted successfully!",
				deleteError: "Failed to delete customer plan. Please try again.",
			},
		},
	},
	enrollments: {
		confirmation_modal: {
			title: "Enrollment Confirmation",
		},
		conflictWarningModal: {
			title: "Schedule Conflicts Detected",
			description:
				"The customer already has active enrollments with schedules that conflict with the new schedule you are creating.",
			confirmHint:
				"You can still proceed, but the customer will have overlapping schedules.",
			confirm: "Proceed Anyway",
		},
		management: {
			title: "Enrollment Management",
			description: "Manage customer enrollments in schedules and plans",
		},
		navigation: {
			title: "Enrollment Details",
			description: "View and manage enrollment information",
			edit: "Edit Enrollment",
			unknownCustomer: "Unknown Customer",
		},
		errors: {
			inlineModeNotAllowed:
				"Inline creation mode not allowed for this organization",
			scheduleConflictsFound: "Schedule conflicts found: {{details}}",
			invalidPayloadKind: "Invalid request kind: {{kind}}",
			permissionDenied: "Permission denied: {{details}}",
			duplicateEnrollment:
				"Duplicate enrollment: Customer is already enrolled in this schedule",
			weeklyLimitExceeded:
				"Weekly limit exceeded: {{current}} of {{limit}} sessions",
			scheduleInactive: "Schedule inactive: {{details}}",
			scheduleNotFound: "Schedule not found: {{details}}",
			customerNotFound: "Customer not found: {{details}}",
			customerPlanNotFound: "Customer plan not found: {{details}}",
			establishmentNotFound: "Establishment not found: {{details}}",
			staffMemberNotFound: "Staff member not found: {{details}}",
			invalidDateRange: "Invalid date range: {{details}}",
			capacityExceeded: "Capacity exceeded: {{details}}",
			validationFailed: "Validation failed: {{details}}",
			databaseError: "Database error: {{details}}",
			networkError: "Network error: {{details}}",
			unknownError: "Unknown error: {{details}}",
		},
		list: {
			title: "Enrollments",
			empty: "No enrollments found",
		},
		table: {
			customer: "Customer",
			plan: "Plan",
			schedule: "Schedule",
			schedules: "Schedules",
			status: "Status",
			startDate: "Start Date",
			endDate: "End Date",
			noEndDate: "No end date",
			actions: "Actions",
		},
		filters: {
			statusLabel: "Status",
			statusPlaceholder: "Filter by status",
			activeAndPending: "Active & Pending",
			allStatuses: "All Statuses",
			selectedStatuses: "{{count}} status(es) selected",
			expiringSoon: "Expiring Soon",
			missingSchedule: "Missing schedule",
			classArchived: "Class archived",
		},
		badges: {
			closeToExpire: "Expiring soon",
			missingSchedule: "No schedule — action needed",
			classArchived: "Class archived",
		},
		status: {
			pending: "Pending",
			active: "Active",
			paused: "Paused",
			canceled: "Canceled",
			completed: "Completed",
			expired: "Expired",
		},
		delete: {
			title: "Delete Enrollment",
			description:
				"Are you sure you want to delete this enrollment? This will remove the customer from all related schedule sessions.",
		},
		cancel: {
			title: "Cancel Enrollment",
			description:
				"Are you sure you want to cancel this enrollment? The customer will be removed from all future schedule sessions.",
			confirm: "Cancel Enrollment",
			onlyEnrollment: "Only",
			schedulesOnlyThisEnrollment:
				"{{count}} schedule(s) only have this enrollment",
			schedulesOnlyThisEnrollment_one: "This schedule only has this enrollment",
			schedulesOnlyThisEnrollment_other:
				"{{count}} schedules only have this enrollment",
			deleteSchedulesExplanation:
				"You can also delete the schedules that will have no enrollments after cancellation.",
			alsoDeleteSchedules:
				"Also delete the schedules with no other enrollments",
			alsoDeleteSchedules_one:
				"Also delete the schedule with no other enrollments",
			alsoDeleteSchedules_other:
				"Also delete the {{count}} schedules with no other enrollments",
		},
		actions: {
			create: "Create Enrollment",
			proceedToPayment: "Proceed to Payment",
			payNow: "Pay Now",
			confirmDelete:
				"Are you sure you want to delete this enrollment? This will remove the customer from all related schedule sessions.",
			pause: "Pause",
			unpause: "Resume",
			renew: "Renew",
			extend: "Extend",
		},
		renewal: {
			description: "{{planName}} - Period: {{startDate}} - {{endDate}}",
		},
		pause: {
			title: "Pause Enrollment",
			description:
				"Pausing this enrollment will temporarily suspend the customer from attending scheduled sessions. You can resume it at any time.",
			confirm: "Pause Enrollment",
			reasonLabel: "Reason (optional)",
			reasonPlaceholder: "Enter a reason for pausing...",
			pauseEndDateLabel: "Resume Date (optional)",
			pauseEndDateHint: "Leave empty for indefinite pause",
		},
		unpause: {
			title: "Resume Enrollment",
			description:
				"Resuming this enrollment will restore the customer's access to scheduled sessions.",
			confirm: "Resume Enrollment",
			pausedSince: "Paused Since",
			daysPaused: "Days Paused",
			currentEndDate: "Current End Date",
			newEndDate: "New End Date",
			daysAdded: "{{count}} day(s) will be added",
			reattachRequired:
				"This enrollment's class was archived while it was paused. Choose an active class to resume into.",
			reattachLabel: "Resume into class",
			reattachPlaceholder: "Select a class",
			missingActiveSchedule:
				"Select an active class to resume this enrollment into.",
		},
		extend: {
			title: "Extend Enrollment",
			description:
				"Extend the enrollment's end date. Associated schedules and sessions will be updated automatically.",
			confirm: "Extend Enrollment",
			currentEndDate: "Current End Date",
			newEndDateLabel: "New End Date",
			reasonLabel: "Reason (optional)",
			reasonPlaceholder: "Enter a reason for extending...",
			quickPick: {
				oneMonth: "+1 month",
				threeMonths: "+3 months",
				oneCycle: "+1 cycle",
			},
			errors: {
				required: "Please select a new end date.",
				mustBeAfterCurrent: "New end date must be after the current end date.",
				noEndDate:
					"This enrollment does not have an end date and cannot be extended.",
			},
		},
		create: {
			title: "Create Enrollment",
			description: "Enroll a customer in a schedule with a specific plan",
			success: "Enrollment created successfully!",
		},
		stepper: {
			customer: "Customer",
			plan: "Plan",
			schedule: "Schedule",
			review: "Review",
		},
		planHelper: {
			totalForPeriod: "Average: {{monthlyAmount}}/month",
			weeklyLimit: "Max {{limit}} sessions/week",
		},
		edit: {
			title: "Edit Enrollment",
			description: "Update enrollment details and status",
			schedulesDescription: "Schedules assigned to this enrollment",
			notesDescription: "Additional notes and observations",
			noSchedules: "No schedules assigned to this enrollment",
			noNotes: "No notes added yet",
			addNotes: "Add notes",
			planFeatures: "Plan Features",
			planFeaturesDescription: "Features included in the customer plan",
			customerPlanCannotBeChanged:
				"The customer plan cannot be changed after enrollment creation.",
			selectSchedules: "Select the schedules for this enrollment",
			noSchedulesAvailable: "No schedules available for this organization",
			noSchedulesSelected: "No schedules selected",
			noScheduleAlertTitle: "No schedule attached",
			noScheduleAlertDescription:
				"This enrollment has no schedule, so the customer won't appear in any sessions. Attach a schedule to fix it.",
			classArchivedAlertTitle: "Class archived",
			classArchivedAlertDescription:
				"The class this enrollment was attached to was archived, so it is paused. Attach an active schedule to resume it.",
			attachSchedule: "Attach schedule",
			selectedSchedulesCount: "{{count}} schedule(s) selected",
			editSchedules: "Edit Schedules",
			saveScheduleChanges: "Save Changes",
			viewSchedule: "View Schedule",
		},
		form: {
			title: "Enrollment Details",
			customer: "Customer",
			selectCustomer: "Select Customer",
			customerPlan: "Customer Plan",
			selectCustomerPlan: "Select Customer Plan",
			schedule: "Schedule(s)",
			selectSchedule: "Select Schedule(s)",
			selectCustomerPlanFirst: "Select a customer plan first",
			startDate: "Start Date",
			startDateCannotBeChanged:
				"Start date cannot be changed after enrollment creation",
			endDate: "End Date",
			endDateAutoCalculated:
				"End date automatically calculated based on plan billing cycle",
			pausedAt: "Paused At",
			pausedDays: "Paused Days",
			lastResumedAt: "Last Resumed At",
			pausedDaysValue: "{{count}} day(s)",
			status: "Status",
			statusTerminal:
				"This enrollment is in a terminal state and cannot be changed.",
			notes: "Notes",
			notesPlaceholder: "Add any additional notes about this enrollment...",
			weeklyLimitHelper:
				"Your plan allows up to {{limit}} weekly sessions. Selected schedules total {{count}} per week.",
			weeklyLimitExceeded:
				"Selected schedules exceed the weekly limit of {{limit}} sessions.",
		},
		inlineSchedule: {
			title: "Create New Schedule",
			addSchedule: "Add Schedule",
			optionalFields: "Optional Settings",
			sections: {
				location: {
					title: "Location & Instructor",
					description: "Select where and who will teach the class",
				},
				schedule: {
					title: "Schedule",
					description: "Define when the class will occur",
				},
				recurrence: {
					title: "Days of Week",
					description: "Select which days this class repeats",
				},
			},
			validation: {
				title: "Schedule Validation",
				validate: "Validate Schedule",
				hasConflicts: "Conflicts found",
				noConflicts: "No conflicts",
				conflictsFound: "Schedule conflicts detected:",
				conflictTypes: {
					time_overlap: "Time overlap detected",
					same_time_slot: "Same time slot conflict",
					capacity_exceeded: "Capacity exceeded",
					schedule_inactive: "Schedule is inactive",
				},
			},
			scheduleSelector: {
				tabs: {
					existing: "Select Existing",
					create: "Create New",
				},
			},
		},
		customerSelection: {
			title: "Select Customer",
			description: "Search and select a customer to enroll",
			search: "Search Customer",
			searchPlaceholder: "Search by name, email, or ID number...",
			searchHint: "Type at least 2 characters to search",
			startTyping: "Start typing to search for customers",
			noCustomersFound: "No customers found for your search",
		},
		validation: {
			customerRequired: "Customer is required",
			customerPlanRequired: "Customer plan is required",
			scheduleRequired: "Schedule is required",
			scheduleValidationRequired:
				"Schedule must be validated before submission",
			startDateRequired: "Start date is required",
			endDateMustBeAfterStartDate: "End date must be after start date",
			statusRequired: "Status is required",
			formIncomplete:
				"Please fill in all required fields before submitting the form",
			formIncompleteWithFields:
				"Please fill in the following required fields: {{fields}}",
			overlappingSchedules: "Selected schedules have overlapping time periods",
			overlappingSchedulesTitle: "Schedule Time Conflicts Detected",
			overlappingSchedulesDescription:
				"The following schedules have overlapping time periods on the same days. Please adjust your selection to avoid conflicts.",
			weeklySessionsLimitExceeded:
				"Selected schedules exceed weekly sessions limit ({{total}}/{{limit}})",
			weeklySessionsLimitTitle: "Weekly Sessions Limit Exceeded",
			weeklySessionsLimitDescription:
				"You have selected {{total}} weekly sessions, but the '{{planName}}' plan allows only {{limit}} sessions per week. Please remove some schedules to continue.",
			weeklySessionsMismatchTitle: "Weekly Sessions Must Remain the Same",
			weeklySessionsMismatchDescription:
				"You have selected {{current}} weekly sessions, but this enrollment requires {{required}} sessions per week. Please adjust your schedule selection to match the original number of weekly sessions.",
			fullScheduleTitle: "Schedule at Full Capacity",
			fullScheduleDescription:
				"The following selected schedules are already at full capacity but you may still enroll.",
			weeklySessionsBreakdown: "Sessions breakdown:",
			sessionsPerWeek: "{{count}} session per week",
			sessionsPerWeek_other: "{{count}} sessions per week",
		},
		toasts: {
			creating: "Creating enrollment...",
			createSuccess: "Enrollment created successfully!",
			createError: "Failed to create enrollment. Please try again.",
			createErrorDuplicate:
				"This customer is already enrolled in the selected schedule.",
			updating: "Updating enrollment...",
			updateSuccess: "Enrollment updated successfully!",
			updateError: "Failed to update enrollment. Please try again.",
			migrating: "Migrating enrollments...",
			migrateSuccess: "Enrollments migrated successfully!",
			migrateError: "Failed to migrate enrollments. Please try again.",
			deleting: "Deleting enrollment...",
			deleteSuccess: "Enrollment deleted successfully!",
			deleteError: "Failed to delete enrollment. Please try again.",
			pausing: "Pausing enrollment...",
			pauseSuccess: "Enrollment paused successfully!",
			pauseError: "Failed to pause enrollment. Please try again.",
			unpausing: "Resuming enrollment...",
			unpauseSuccess: "Enrollment resumed successfully!",
			unpauseError: "Failed to resume enrollment. Please try again.",
			extending: "Extending enrollment...",
			extendSuccess: "Enrollment extended successfully!",
			extendError: "Failed to extend enrollment. Please try again.",
		},

		sections: {
			customerAndPlan: "Customer & Plan",
			customerAndPlanDescription:
				"Select the customer and their plan for this enrollment",
			customerSelection: "Customer Selection",
			customerSelectionDescription: "Select the customer for this enrollment",
			customerPlan: "Customer Plan",
			customerPlanDescription: "Select the customer plan for this enrollment",
			customerPlanDescriptionReadOnly:
				"Current customer plan (cannot be changed)",
			scheduleSelection: "Schedule Selection",
			scheduleSelectionDescription: "Choose the schedules for this enrollment",
			scheduleCreation: "Schedule Creation",
			scheduleCreationDescription: "Create a new schedule for this enrollment",
			schedules: "Selected Schedules",
			dateAndDetails: "Date & Details",
			dateAndDetailsDescription:
				"Set the enrollment period and additional information",
			dateRange: "Date Range",
			selectedSchedules: "Selected schedules",
			scheduleDescriptionCreate:
				"Pick one or more schedules. You will see the selection and a summary below.",
			scheduleDescriptionEdit: "Update the schedule for this enrollment.",
			sessionsResume: "Total sessions in period: {{total}}",
			sessionsResumeDescription: "Based on selected schedules and date range",
			weeklySummary: "Weekly Schedule Summary",
			noSessions: "No sessions",
		},
		helper: {
			selectCustomerFirst: "Select a customer first",
			selectCustomerFirstDescription:
				"You need to choose a customer before selecting a plan.",
			selectCustomerPlanFirst: "Select a customer plan first",
			selectCustomerPlanFirstDescription:
				"You need to select a customer plan before you can choose schedules",
			planCannotBeChanged:
				"The customer plan cannot be changed after enrollment creation.",
		},
		noSchedulesFound: "No schedules found matching your search",
		noSchedulesAvailable: "No schedules available for the selected plan",
		noSchedulesForPlanEstablishments: {
			title: "No Schedules for Plan Establishments",
			description:
				"There are no schedules available for the establishments associated with the '{{planName}}' plan.",
		},
		scheduleNotAvailableForPlan:
			"This schedule is not available for the selected plan's establishments",
	},
	permissions: {
		categories: {
			organization: "Organization Settings",
			staff: "Staff Management",
			establishments: "Establishments",
			customers: "Customer Management",
			customerPlans: "Customer Plans",
			medical: "Medical Records",
			finance: "Finance & Billing",
			reports: "Reports",
			schedules: "Schedules",
			enrollments: "Enrollments",
			attendance: "Attendance",
			other: "Other Permissions",
		},
	},
	dashboard: {
		title: "Dashboard",
		welcome: "Welcome to {{organization}}",
		home: {
			eyebrow: "Business overview · {{date}}",
			headline: "Here's your studio today",
			newEnrollment: "Enrollment",
			newSale: "Sale",
			newCustomer: "Customer",
			widgetError: "Couldn't load this section",
			metrics: {
				activeCustomers: "Active customers",
				activeEnrollments: "Active enrollments",
				expiringSoon: "Expiring soon",
				expired: "Expired",
				customersChange_one: "▲ {{count}} this week",
				customersChange_other: "▲ {{count}} this week",
				totalEnrolled: "Total enrolled",
				currentlySubscribed: "Currently subscribed",
				next7DaysActNow: "Next 7 days · act now",
				allClear: "All clear",
				last30Days: "Last 30 days",
			},
			schedule: {
				title: "Today's schedule",
				now: "now {{time}}",
				time: "Time",
				session: "Session",
				count: "Attendance",
				status: "Status",
				checkIn: "Check in",
				done: "Done",
				inSession: "In session",
				live: "Now",
				canceled: "Canceled",
				mySchedules: "My schedules",
				empty: "No sessions scheduled today",
			},
			quickActions: {
				title: "Quick actions",
				createEnrollment: {
					title: "Enroll customer",
					subtitle: "Enroll a customer in a plan",
				},
				createInvoice: {
					title: "New sale",
					subtitle: "Bill a customer",
				},
				addCustomer: {
					title: "Add customer",
					subtitle: "Register a new client",
				},
			},
			needsAttention: {
				title: "Needs attention",
				groupEnrollments: "Expiring plans",
				groupInvoices: "Overdue invoices",
				groupCustomerRisk: "At-risk customers",
				renew: "Renew",
				collect: "Collect",
				review: "Review",
				invoiceOverdue: "Invoice #{{number}} overdue",
				expiresInDays_one: "Expires in {{count}} day",
				expiresInDays_other: "Expires in {{count}} days",
				expiresSoon: "Expiring soon",
				atRiskDetail_one: "{{count}} cancellation · {{rate}}% attendance",
				atRiskDetail_other: "{{count}} cancellations · {{rate}}% attendance",
				allCaughtUp: "All caught up",
			},
			birthdays: {
				title: "Upcoming birthdays",
				today: "Today",
				tomorrow: "Tomorrow",
				inDays_one: "In {{count}} day",
				inDays_other: "In {{count}} days",
				empty: "No birthdays in the next 7 days",
			},
			greeting: {
				morning: "Good morning",
				afternoon: "Good afternoon",
				evening: "Good evening",
				now: "now {{time}}",
			},
			topBar: {
				notifications: "Notifications",
				notificationsUnread: "Notifications — you have alerts",
			},
			quickCreate: {
				title: "Create",
				fabLabel: "Create new",
			},
		},
		organization: {
			title: "Organization",
			description: "Current organization information",
		},
		establishment: {
			title: "Establishment",
			description: "Current establishment information",
		},
		roles: {
			title: "Your Roles",
			description: "Your roles in this establishment",
		},
		quickActions: {
			customers: "Manage customer profiles and information",
			schedules: "View and manage class schedules",
			attendance: "Track class attendance",
			enrollment: "Manage customer enrollments",
			mySchedules: {
				title: "My Schedules",
				description: "View your assigned sessions and classes",
			},
			createEnrollment: {
				title: "Create Enrollment",
				description: "Enroll a customer in a schedule with a plan",
			},
			createInvoice: {
				title: "Create Invoice",
				description:
					"Create a new invoice and optionally record payments for a customer",
			},
		},
		myOverview: {
			title: "My Overview",
			myCustomers: {
				title: "My Customers",
				subtitle: "In my classes",
			},
			myEnrollments: {
				title: "My Enrollments",
				subtitle: "Active in my classes",
			},
			myAttendance: {
				title: "My Attendance",
				subtitle: "Total confirmed",
			},
			myExpiringEnrollments: {
				title: "Expiring Soon",
				subtitle: "Next 7 days",
			},
			myExpiredEnrollments: {
				title: "Expired",
				subtitle: "In my classes",
			},
		},
		businessOverview: {
			title: "Business Overview",
			activeCustomers: {
				title: "Active Customers",
				subtitle: "Total enrolled",
			},
			activePlans: {
				title: "Active Enrollments",
				subtitle: "Currently subscribed",
			},
		},
		todayActivity: {
			title: "Today's Activity",
			todaysClasses: {
				title: "Classes Today",
				subtitle: "Scheduled sessions",
			},
			weeklyClasses: {
				title: "Weekly Classes",
				subtitle: "Total scheduled sessions",
			},
		},
		upcomingEvents: {
			title: "Upcoming Events",
			upcomingBirthdays: {
				title: "Upcoming Birthdays",
				subtitle: "Next 7 days",
			},
			plansExpiringSoon: {
				title: "Plans Expiring Soon",
				subtitle: "Next 30 days",
			},
			plansExpiringIn7Days: {
				title: "Expiring Enrollments",
				subtitle: "Next 7 days",
			},
			plansExpiringIn15Days: {
				title: "Plans Expiring (15 Days)",
				subtitle: "Next 15 days",
			},
			plansExpiredLast30Days: {
				title: "Expired Enrollments",
				subtitle: "Last 30 days",
			},
		},
		birthdaysTable: {
			title: "Upcoming Birthdays Details",
			columns: {
				customerName: "Customer Name",
				email: "Email",
				phone: "Phone",
				date: "Date",
			},
		},
		birthdayModal: {
			title: "Birthday Details",
			contactInfo: "Contact Information",
			noContactInfo: "No contact information available",
		},
		birthday: {
			today: "Today!",
			celebratingToday: "Celebrating today!",
		},
	},
	selectOrganization: {
		title: "Your studios",
		subtitle: "Pick a studio to open, or set up a new one.",
		ownedTitle: "You own",
		invitedTitle: "You're invited to",
		emptyOwned: "You don't own any studios yet.",
		emptyInvited:
			"When an owner invites you into their studio, it'll show up here.",
		noOrganizations: "No organizations found",
		noOrganizationsDescription:
			"You don't have access to any organizations yet.",
		loading: "Loading organizations...",
		error: "Failed to load organizations",
		retry: "Retry",
		role: "Role",
		roles: "Roles",
		selectButton: "Select",
		deleteButton: "Delete organization",
		countLabel_one: "{{count}} studio",
		countLabel_other: "{{count}} studios",
		explainer: {
			title: "What is an organization?",
			definition:
				"Think of an organization as your studio business inside PilatesTime. It holds everything that belongs to it: schedules, clients, staff, and billing.",
			rule: "If you run one location or several under the same business, they should all live inside the same organization and share the same plan.",
			newOrg:
				"Only create a new organization when they're separate businesses, with distinct teams, records, and billing.",
			hide: "Hide",
		},
		action: {
			open: "Open",
			choosePlan: "Choose a plan",
			updatePayment: "Update payment",
			reactivate: "Reactivate",
		},
		status: {
			checking: "Checking plan…",
			active: "Active",
			trialing: "Trial",
			trialingWithDays_one: "Trial · {{count}} day left",
			trialingWithDays_other: "Trial · {{count}} days left",
			setupRequired: "Setup required",
			paymentRequired: "Payment required",
			pastDue: "Payment overdue",
			inactive: "Inactive",
			unknown: "Plan unavailable",
		},
		deleteDialog: {
			title: "Delete organization",
			description:
				'Are you sure you want to delete the organization "{{organizationName}}"?',
			irreversibleWarning:
				"This operation is not reversible. Once deleted, this organization cannot be recovered.",
			dataLossWarning:
				"All data related to this organization (clients, schedules, enrollments, payments and more) will be permanently deleted.",
			confirmLabel:
				'To confirm, type the name of the organization "{{organizationName}}" below.',
			confirmButton: "Delete organization",
			deleting: "Deleting organization...",
		},
	},
	landing: {
		hero: {
			badge: "Built for Pilates Studios",
			titlePart1: "Less spreadsheets,",
			titleHighlight: "more Pilates",
			titlePart2: "in your day",
			subtitle:
				"Stop tracking attendance on paper, chasing payments over messages, and losing hours to spreadsheets. PilatesTime brings schedules, clients, billing, and reports into one streamlined platform.",
			startTrial: "Try Free for 14 Days",
			watchDemo: "See How It Works",
			trustItem1: "14-day free trial",
			trustItem2: "Cancel anytime",
			retention: "Client Retention",
			studios: "Active Studios",
			efficiency: "Efficiency",
			efficiencyDescription: "Hours saved per week",
			retentionDescription: "Increase retention rate",
		},
		stats: {
			studios: "Active Studios",
			clients: "Clients Managed",
			retention: "Avg. Retention",
			rating: "Customer Rating",
		},
		features: {
			badge: "Built for Your Studio",
			title: "Everything in one place. No workarounds.",
			subtitle:
				"Stop juggling spreadsheets, messaging apps, and notebooks. PilatesTime gives you the tools to run your studio with more control and less manual work.",
			clientProfiles: {
				title: "Client Profiles & Attendance",
				description:
					"Complete client records with attendance history, plans, and notes. No more notebooks or guesswork.",
			},
			calendar: {
				title: "Smart Scheduling",
				description:
					"Set up group classes and private sessions with ease. See available slots and avoid scheduling conflicts.",
			},
			payments: {
				title: "Billing & Invoicing",
				description:
					"Generate invoices, track payments, and manage overdue accounts from one dashboard.",
			},
			analytics: {
				title: "Reports & Insights",
				description:
					"See how much your studio earned, how many clients are active, and which time slots are in demand.",
			},
			mobile: {
				title: "Access Anywhere",
				description:
					"Use it on your phone, tablet, or computer. Check your studio schedule even outside business hours.",
			},
			security: {
				title: "Data Protection",
				description:
					"Client and financial data is stored with encryption and modern security practices.",
			},
		},
		howItWorks: {
			badge: "Quick Setup",
			title: "From signup to your first class in minutes",
			subtitle:
				"No installation, no lengthy training. Here's how to get started:",
			steps: {
				signup: {
					title: "Create Your Account",
					description:
						"Quick signup with your email. Start your free trial instantly.",
				},
				configure: {
					title: "Set Up Your Schedule",
					description:
						"Add your time slots, classes, and plans to match your studio's routine.",
				},
				manage: {
					title: "Add Your Clients",
					description:
						"Import your client list or add them manually. Organized from day one.",
				},
				grow: {
					title: "Manage with Confidence",
					description:
						"Track attendance, billing, and studio performance day by day.",
				},
			},
		},
		aiFeatures: {
			title: "AI-Powered Features",
			segmentation: {
				title: "Client Segmentation & Profiling",
				description:
					"Automatically group clients based on attendance patterns, preferences, and goals to create targeted marketing campaigns.",
			},
			churnRisk: {
				title: "Churn-Risk Scoring",
				description:
					"Identify clients at risk of dropping out before they leave, enabling proactive retention strategies.",
			},
			communication: {
				title: "Personalized Communication",
				description:
					"Generate custom messages and feedback based on client history and preferences.",
			},
			workoutRec: {
				title: "AI-Driven Workout Recommendations",
				description:
					"Suggest personalized exercise programs based on client progress, goals, and limitations.",
			},
		},
		testimonials: {
			title: "What Studio Owners Say",
			quote: "",
			author: "",
			position: "",
		},
		pricing: {
			title: "Simple, Transparent Pricing",
			starter: {
				name: "Starter",
				price: "$49",
				features: [
					"Client Management",
					"Basic Scheduling",
					"Payment Processing",
					"Email Support",
				],
			},
			professional: {
				name: "Professional",
				price: "$99",
				features: [
					"Everything in Starter",
					"AI Client Segmentation",
					"Churn Prediction",
					"Personalized Communication",
					"Priority Support",
				],
			},
			studioPro: {
				name: "Studio Pro",
				price: "$149",
				features: [
					"Everything in Professional",
					"Multi-Instructor Support",
					"Advanced Analytics",
					"Custom Branding",
					"Dedicated Account Manager",
				],
			},
			selectPlan: "Select Plan",
			perMonth: "/month",
		},
		faq: {
			title: "Frequently Asked Questions",
			subtitle:
				"Everything you need to know about getting started with Pilates Time",
			questions: [
				{
					question: "How does AI data stay private?",
					answer:
						"Your data is encrypted both in transit and at rest. We use industry-standard security practices and never share your client data with third parties.",
				},
				{
					question: "Can I import my existing client list?",
					answer:
						"Yes! Pilates Time supports importing client data from CSV files, Excel, and several popular management systems.",
				},
				{
					question: "What integrations are supported?",
					answer:
						"We integrate with Stripe for payments, Zoom for virtual classes, Google Calendar for scheduling, and many more popular services.",
				},
			],
		},
		cta: {
			title: "Your studio deserves better management",
			subtitle:
				"Try PilatesTime free for 14 days. Setup takes less than 5 minutes.",
			button: "Start Free Trial",
			trustText: "14-day free trial • Cancel anytime",
		},
		footerSections: {
			about: {
				title: "Pilates Time",
				description:
					"Complete management for Pilates studios. Schedules, attendance, billing, and reports — all in one place.",
			},
			product: {
				title: "Product",
				pricing: "Pricing",
			},
			company: {
				title: "Company",
				aboutUs: "About Us",
				contact: "Contact",
			},
			contact: {
				title: "Contact",
				whatsappNumber: "5500000000000",
			},
			why: {
				title: "Why PilatesTime",
				clientManagement: "Client management",
				scheduling: "Smart scheduling",
				reports: "Reports & insights",
			},
			trust: {
				ssl: "SSL Encrypted",
				lgpd: "LGPD Compliant",
				uptime: "99.9% Uptime",
			},
		},
		socialMedia: {
			instagram: "Instagram",
			facebook: "Facebook",
			linkedin: "LinkedIn",
		},
	},
	about: {
		meta: {
			title: "About PilatesTime",
		},
		hero: {
			badge: "About PilatesTime",
			title: "Studio management built for Pilates professionals",
			subtitle:
				"We exist to solve a simple problem: studio owners shouldn't spend more time on spreadsheets than with their clients.",
		},
		problem: {
			badge: "The Challenge",
			title: "Running a studio is harder than it looks",
			subtitle:
				"From the outside, it looks like setting up the Reformer and teaching class. In practice, the daily reality involves much more.",
			points: {
				fragmented: {
					title: "Schedules scattered everywhere",
					description:
						"Notebooks, WhatsApp, spreadsheets, and sticky notes all at once. Information gets spread thin and easy to lose.",
				},
				billing: {
					title: "Manual billing",
					description:
						"Remembering who paid, who's late, and who needs a reminder. The same routine every week.",
				},
				attendance: {
					title: "Paper-based attendance",
					description:
						"No way to know how many clients missed, dropped out, or need attention. The data gets lost.",
				},
				noData: {
					title: "Decisions in the dark",
					description:
						"No real data on revenue, retention, or peak time slots. Just guesswork.",
				},
			},
			closing:
				"The result? Hours of admin work that could be spent on teaching, client care, and growth.",
		},
		solution: {
			badge: "The Solution",
			title: "What is PilatesTime",
			subtitle:
				"A complete management platform built for the real routines of Pilates studios. Not a generic gym tool adapted to fit. A purpose-built system for people who live and breathe Pilates.",
			capabilities: {
				centralized: {
					title: "Centralized organization",
					description:
						"Schedules, classes, private sessions, and time slots in a single dashboard.",
				},
				attendance: {
					title: "Paperless attendance",
					description:
						"Digital attendance tracking with a complete history per client.",
				},
				billing: {
					title: "Frictionless billing",
					description:
						"Invoice generation, payment tracking, and overdue account management.",
				},
				insights: {
					title: "Clear business visibility",
					description:
						"Revenue reports, retention metrics, occupancy rates, and demand by time slot.",
				},
				anywhere: {
					title: "Access from anywhere",
					description:
						"Works on phone, tablet, or computer — inside or outside the studio.",
				},
			},
		},
		differentiation: {
			badge: "Why PilatesTime",
			title: "What makes us different",
			blocks: {
				pilatesSpecific: {
					title: "Built for Pilates, not for gyms",
					description:
						"Generic fitness software doesn't understand Pilates studio dynamics — private sessions, small groups, equipment-specific classes. PilatesTime was built for this context.",
				},
				timeSavings: {
					title: "Less admin, more time to teach",
					description:
						"Chasing payments by message, checking attendance in a notebook, and building reports in a spreadsheet eats hours every week. With PilatesTime, these tasks take a few clicks.",
				},
				dataDriven: {
					title: "Real data for real decisions",
					description:
						"How many active clients? Which time slots have the most demand? How much did the studio earn this month? Instead of guessing, you check. Clear reports that help you grow based on facts.",
				},
			},
		},
		values: {
			badge: "Our Values",
			title: "What we believe in",
			mission: {
				label: "Mission",
				text: "Simplify Pilates studio management so professionals can focus on what they do best: taking care of their clients.",
			},
			vision: {
				label: "Vision",
				text: "To be the go-to management platform for Pilates studios in Brazil — recognized for its practicality, reliability, and real-world impact.",
			},
			items: {
				simplicity: {
					title: "Practical simplicity",
					description:
						"If it doesn't make the studio's routine easier, it doesn't go in the product.",
				},
				reliability: {
					title: "Reliability",
					description:
						"Your data and your clients' data are treated with care.",
				},
				closeness: {
					title: "Closeness",
					description: "Dedicated, personal support — not a generic chatbot.",
				},
				evolution: {
					title: "Continuous evolution",
					description:
						"The product grows alongside the needs of the people who use it.",
				},
			},
		},
		audience: {
			badge: "Who It's For",
			title: "Who is PilatesTime for",
			personas: {
				owners: {
					title: "Studio owners",
					description:
						"Who need financial and operational visibility without relying on spreadsheets.",
				},
				instructors: {
					title: "Instructors who also manage",
					description:
						"Who do it all — teach, bill, schedule — and need to move fast.",
				},
				frontDesk: {
					title: "Receptionists and assistants",
					description:
						"Who handle enrollments, attendance, and payments every day.",
				},
				growing: {
					title: "Growing studios",
					description:
						"That feel their manual processes can no longer keep up with the pace of the business.",
				},
			},
		},
		cta: {
			title: "Start managing your studio with more control",
			subtitle:
				"Try PilatesTime free for 14 days. Setup takes less than 5 minutes.",
			button: "Start Free Trial",
			trustText: "14-day free trial • Cancel anytime",
		},
	},
	help: {
		title: "Help & Support",
		description:
			"Find answers to your questions and learn how to use Pilates Time effectively",
		gettingStarted: "Getting Started",
		userGuide: "User Guide",
		faq: "Frequently Asked Questions",
		submitTicket: "Submit a Ticket",
		myTickets: "My Tickets",
		support: "Contact Support",
		supportNav: "Contact Support",
		tutorials: "Video Tutorials",
		gettingStartedTitle: "Getting Started",
		gettingStartedDescription: "Learn the basics of using Pilates Time",
		welcome: "Welcome to Pilates Time",
		welcomeDescription:
			"Your comprehensive guide to managing your Pilates studio efficiently",
		userGuideTitle: "User Guide",
		userGuideDescription: "Detailed instructions for all features",
		faqTitle: "Frequently Asked Questions",
		faqDescription: "Common questions and answers",
		tutorialsTitle: "Video Tutorials",
		tutorialsDescription: "Step-by-step video guides",
		quickStartGuide: "Quick Start Guide",
		quickStartDescription:
			"Get started with these essential features to set up your Pilates studio management system.",
		gettingStartedSteps: "Getting Started Steps",
		reportsAnalyticsQuickStart: "Reports & Analytics",
		customersDescription: "Learn how to add and manage customer profiles",
		schedulesDescription: "Set up classes and manage your studio schedule",
		attendanceDescription: "Track attendance and manage class sessions",
		paymentsDescription: "Handle billing and payment processing",
		settingsDescription: "Configure your organization and establishments",
		reportsDescription: "View insights and generate reports",
		step1Title: "Register new Establishments",
		step1Description:
			"Create establishments for your organization's studio locations. Go to Registration > Establishments in the side menu, click 'Add Establishment', and fill in the location details including name, address, and contact information.",
		step2Title: "Add staff members",
		step2Description:
			"Invite instructors and staff to join your organization. Navigate to Registration > Staff, click 'Invite New Staff Member', enter their email and name, select their role (Administrator, Manager, Instructor, etc.), and send the invitation.",
		step3Title: "Create customer plans",
		step3Description:
			"Set up pricing plans and packages for your classes. Go to Customer Plans in the main navigation, click 'Create New Plan', configure pricing, billing cycle, features, and establishment access to define what customers can purchase.",
		step4Title: "Create schedules",
		step4Description:
			"Set up your class schedules with instructors, times, and capacity. Navigate to Schedules, click 'Create New Schedule', select the establishment, assign staff members, set class times, and configure recurrence patterns.",
		step5Title: "Add customers",
		step5Description:
			"Add customer profiles to your system. Go to Customers in the main navigation, click 'Add Customer', and fill in their personal information, contact details, address, and any additional notes or emergency contacts.",
		step6Title: "Enroll customers",
		step6Description:
			"Enroll customers in schedules using their purchased plans. Navigate to Enrollments, click 'Create Enrollment', select the customer, choose their plan, pick the schedules, and set the enrollment period to start tracking attendance.",
		userGuideOverview: "User Guide Overview",
		userGuideOverviewDescription:
			"Complete documentation for all Pilates Time features",
		organizationSetup: "Organization Setup",
		organizationSetupDescription:
			"Configure your organization and establishments",
		staffManagement: "Staff Management",
		staffManagementDescription: "Manage instructors and staff members",

		// Staff Management Guide
		staffGuideOverviewTitle: "Overview",
		staffGuideOverviewText:
			"Staff management is essential for organizing your team and controlling access to your Pilates studio operations. This system allows you to invite team members, assign roles with specific permissions, and manage their access to different establishments within your organization.",
		staffGuideKeyFeatures: "Key Features",
		staffGuideKeyFeature1:
			"Role-based access control with organization-wide permissions",
		staffGuideKeyFeature2:
			"Email-based invitation system with expiration dates",
		staffGuideKeyFeature3: "Establishment-level access management",
		staffGuideKeyFeature4: "Real-time staff status tracking (Active/Pending)",

		staffGuideAccessingTitle: "Accessing Staff Management",
		staffGuideAccessingText: "To access the staff management section:",
		staffGuideAccessingStep1: "Navigate to your organization dashboard",
		staffGuideAccessingStep2:
			'Click on "Staff" in the Registration section of the side menu',
		staffGuideAccessingStep3:
			"You'll see the staff list with active members and pending invitations",
		staffGuidePermissionTitle: "Permission Requirements",
		staffGuidePermissionText:
			'You need either "MANAGE_STAFF" or "INVITE_STAFF" permissions to access staff management features. Contact your organization administrator if you don\'t see these options.',
		staffGuideAccessingImagePlaceholder:
			"Image placeholder: Screenshot of the organization dashboard showing the Staff menu item in the side navigation",

		staffGuideRolesTitle: "Understanding Roles and Permissions",
		staffGuideRolesText:
			"The system uses organization-level roles that determine what features staff members can access:",
		staffGuideRolesAvailableTitle: "Available Organization Roles",
		staffGuideRoleOwnerTitle: "Owner",
		staffGuideRoleOwnerText:
			"Full access to all organization features and settings. Cannot be removed or have role changed.",
		staffGuideRoleAdministratorTitle: "Administrator",
		staffGuideRoleAdministratorText:
			"Manage organization settings, staff, and all features. Nearly full access.",
		staffGuideRoleManagerTitle: "Manager",
		staffGuideRoleManagerText:
			"Manage daily operations, staff, and most features. Limited administrative access.",
		staffGuideRoleInstructorTitle: "Instructor",
		staffGuideRoleInstructorText:
			"Access to medical records and related features. Can manage customer health information.",
		staffGuideRoleAccountantTitle: "Accountant",
		staffGuideRoleAccountantText:
			"Access to financial data and payment management. Limited to billing features.",
		staffGuideRoleViewerTitle: "Viewer",
		staffGuideRoleViewerText:
			"View-only access to organization data. Cannot make changes or manage other staff.",
		staffGuideRolePermissionsMatrixTitle: "Role Permissions Matrix",
		staffGuideRolePermissionsMatrixText:
			'Click "View Permissions" in the staff invitation dialog to see a detailed matrix of what each role can access and manage within the organization.',
		staffGuideRolesImagePlaceholder:
			"Image placeholder: Screenshot of the role permissions matrix showing different roles and their capabilities",

		staffGuideListTitle: "Staff List Overview",
		staffGuideListText:
			"The staff list displays all team members and pending invitations in a comprehensive table:",
		staffGuideListColumnsTitle: "Table Columns",
		staffGuideListColumn1Title: "Staff Member",
		staffGuideListColumn1Text: "Shows profile picture, name, and email address",
		staffGuideListColumn2Title: "Role",
		staffGuideListColumn2Text: "Organization-level role with icon and label",
		staffGuideListColumn3Title: "Status",
		staffGuideListColumn3Text:
			"Active (green) for joined members, Pending (yellow) for invitations",
		staffGuideListColumn4Title: "Joined At / Expires",
		staffGuideListColumn4Text:
			"Join date for active members, expiration date for pending invitations",
		staffGuideListIndicatorsTitle: "Visual Indicators",
		staffGuideListIndicator1: "Green dot: Active staff members who have joined",
		staffGuideListIndicator2:
			"Yellow clock icon: Pending invitations awaiting acceptance",
		staffGuideListIndicator3:
			"Highlighted rows: Pending invitations have a subtle yellow background",
		staffGuideListIndicator4:
			"Profile pictures: Show member avatars or default user icons",
		staffGuideListImagePlaceholder:
			"Image placeholder: Screenshot of the staff list showing active members and pending invitations",

		staffGuideInvitingTitle: "Inviting New Staff Members",
		staffGuideInvitingText:
			"Adding new team members is done through an email invitation system:",
		staffGuideInvitingStep1Title: "Step 1: Open the Invitation Dialog",
		staffGuideInvitingStep1Text1:
			'Click the "Invite New Staff Member" button (+ icon) in the staff management page',
		staffGuideInvitingStep1Text2:
			"The invitation dialog will open with two main sections",
		staffGuideInvitingStep2Title: "Step 2: Fill Contact Information",
		staffGuideInvitingRequiredFieldsTitle: "Required Fields",
		staffGuideInvitingRequiredField1:
			"Email Address: The person's work email (required)",
		staffGuideInvitingRequiredField2:
			"Name: Full name of the person (optional but recommended)",
		staffGuideInvitingStep3Title: "Step 3: Select Role and Permissions",
		staffGuideInvitingRoleSelectionTitle: "Organization Role Selection",
		staffGuideInvitingRoleSelection1:
			"Choose from available organization roles (Administrator, Manager, Instructor, etc.)",
		staffGuideInvitingRoleSelection2:
			"Each role shows a description of its permissions",
		staffGuideInvitingRoleSelection3:
			'Click "View Permissions" to see the detailed permissions matrix',
		staffGuideInvitingRoleSelection4: 'Default role is "Viewer" for security',
		staffGuideInvitingStep4Title: "Step 4: Send the Invitation",
		staffGuideInvitingStep4Text1: "Review all information for accuracy",
		staffGuideInvitingStep4Text2:
			'Click "Send Invite" to send the email invitation',
		staffGuideInvitingStep4Text3:
			"The person will receive an email with instructions to join",
		staffGuideInvitingStep4Text4:
			'The invitation will appear in the staff list with "Pending" status',
		staffGuideInvitingDetailsTitle: "Invitation Details",
		staffGuideInvitingDetail1:
			"Invitations expire after a set period (check expiration date)",
		staffGuideInvitingDetail2: "Recipients must have a valid email address",
		staffGuideInvitingDetail3:
			"They'll need to create an account if they don't have one",
		staffGuideInvitingDetail4:
			'Once accepted, they\'ll appear as "Active" in the staff list',
		staffGuideInvitingImagePlaceholder:
			"Image placeholder: Screenshot of the staff invitation dialog showing all form fields and role selection",

		staffGuideManagingTitle: "Managing Existing Staff",
		staffGuideManagingText:
			"Once staff members are active, you can manage their roles and establishment access:",
		staffGuideManagingEditingTitle: "Editing Staff Information",
		staffGuideManagingEditingStep1:
			"Click the edit button (pencil icon) next to any staff member",
		staffGuideManagingEditingStep2:
			"You'll be taken to the staff member's detailed edit page",
		staffGuideManagingEditingStep3:
			"The page shows three main sections: Information, Organization Role, and Establishment Access",
		staffGuideManagingActionsTitle: "Available Actions",
		staffGuideManagingAction1Title: "Change Organization Role",
		staffGuideManagingAction1Text:
			"Update the staff member's organization-wide permissions and access level",
		staffGuideManagingAction2Title: "Manage Establishment Access",
		staffGuideManagingAction2Text:
			"Assign or remove access to specific establishments within the organization",
		staffGuideManagingAction3Title: "View Staff Information",
		staffGuideManagingAction3Text:
			"See profile details, join date, and current role assignments",
		staffGuideManagingAction4Title: "Remove Staff Member",
		staffGuideManagingAction4Text:
			"Permanently remove the staff member from the organization",
		staffGuideManagingNotesTitle: "Important Notes",
		staffGuideManagingNote1: "Organization Owners cannot be edited or removed",
		staffGuideManagingNote2: "Role changes take effect immediately",
		staffGuideManagingNote3: "Removing staff is permanent and cannot be undone",
		staffGuideManagingNote4:
			"Staff members will lose access to all organization data when removed",
		staffGuideManagingImagePlaceholder:
			"Image placeholder: Screenshot of the staff edit page showing role management and establishment assignments",

		staffGuidePendingTitle: "Managing Pending Invitations",
		staffGuidePendingText:
			"Pending invitations appear in the staff list and can be managed until they expire or are accepted:",
		staffGuidePendingStatusTitle: "Invitation Status",
		staffGuidePendingStatus1:
			"Pending invitations show with a yellow clock icon and highlighted background",
		staffGuidePendingStatus2:
			'Expiration date is displayed in the "Joined At" column',
		staffGuidePendingStatus3:
			"Invitee name or email is shown in the Staff Member column",
		staffGuidePendingStatus4:
			"Assigned role displays what role they'll have when they accept",
		staffGuidePendingActionsTitle: "Available Actions",
		staffGuidePendingActionTitle: "Revoke Invitation",
		staffGuidePendingActionText:
			"Cancel a pending invitation before it's accepted. Click the X button in the Actions column.",
		staffGuidePendingAcceptanceTitle:
			"What Happens When Invitations Are Accepted",
		staffGuidePendingAcceptanceStep1:
			"The person creates an account or logs in with their existing account",
		staffGuidePendingAcceptanceStep2:
			"They're automatically added to the organization with the assigned role",
		staffGuidePendingAcceptanceStep3:
			'Their status changes from "Pending" to "Active" in the staff list',
		staffGuidePendingAcceptanceStep4:
			"They gain access to features based on their assigned role",
		staffGuidePendingAcceptanceStep5:
			"The invitation is removed from the pending list",
		staffGuidePendingExpirationTitle: "Invitation Expiration",
		staffGuidePendingExpirationText:
			"Invitations automatically expire after a set period. Expired invitations are automatically removed from the system and will need to be resent if the person still needs access.",
		staffGuidePendingImagePlaceholder:
			"Image placeholder: Screenshot showing pending invitations in the staff list with expiration dates and revoke options",

		staffGuideEstablishmentTitle: "Establishment Access Management",
		staffGuideEstablishmentText:
			"In addition to organization-level roles, staff members can be assigned to specific establishments for data access:",
		staffGuideEstablishmentUnderstandingTitle:
			"Understanding Establishment Access",
		staffGuideEstablishmentUnderstanding1:
			"Organization roles determine what features staff can access",
		staffGuideEstablishmentUnderstanding2:
			"Establishment assignments determine which establishment's data they can see",
		staffGuideEstablishmentUnderstanding3:
			"Staff can be assigned to multiple establishments",
		staffGuideEstablishmentUnderstanding4:
			"Without establishment access, staff can't see customer or schedule data",
		staffGuideEstablishmentAssigningTitle: "Assigning Establishments",
		staffGuideEstablishmentAssigningStep1: "Go to the staff member's edit page",
		staffGuideEstablishmentAssigningStep2:
			'Scroll to the "Establishment Access" section',
		staffGuideEstablishmentAssigningStep3:
			'Select establishments from the "Available Establishments" dropdown',
		staffGuideEstablishmentAssigningStep4:
			'Click "Assign Selected" to grant access',
		staffGuideEstablishmentAssigningStep5:
			'The establishments will appear in the "Currently Assigned To" list',
		staffGuideEstablishmentRemovingTitle: "Removing Establishment Access",
		staffGuideEstablishmentRemoving1:
			'Click the "Remove assignment" button next to any assigned establishment',
		staffGuideEstablishmentRemoving2:
			"The staff member will immediately lose access to that establishment's data",
		staffGuideEstablishmentRemoving3:
			"This action is reversible - you can reassign them later",
		staffGuideEstablishmentBestPracticeTitle: "Best Practice",
		staffGuideEstablishmentBestPracticeText:
			"Assign staff members only to establishments where they actually work or need access. This follows the principle of least privilege and helps maintain data security.",
		staffGuideEstablishmentImagePlaceholder:
			"Image placeholder: Screenshot of establishment access management showing assignment and removal options",

		customerManagement: "Customer Management",
		customerManagementDescription: "Handle customer profiles and relationships",
		customerPlans: "Customer Plans",
		customerPlansDescription: "Create and manage pricing plans",
		scheduleManagement: "Schedule Management",
		scheduleManagementDescription: "Set up classes and recurring schedules",

		// Schedule Management Guide
		scheduleGuideOverviewTitle: "Overview",
		scheduleGuideOverviewText:
			"Schedule management is the core of your Pilates studio operations. It allows you to create and manage class schedules, set up recurring sessions, control capacity, and assign instructors. The system supports both group classes and individual sessions with flexible timing and recurrence patterns.",
		scheduleGuideKeyFeatures: "Key Features",
		scheduleGuideKeyFeature1:
			"Two schedule types: Group sessions with capacity limits and Individual sessions",
		scheduleGuideKeyFeature2:
			"Flexible recurrence: Single sessions, Weekly recurring, or Monthly recurring",
		scheduleGuideKeyFeature3:
			"Staff assignment and establishment-specific scheduling",
		scheduleGuideKeyFeature4:
			"Comprehensive time management with validation and conflict prevention",

		scheduleGuideAccessingTitle: "Accessing Schedule Management",
		scheduleGuideAccessingText: "To access the schedule management section:",
		scheduleGuideAccessingStep1: "Navigate to your organization dashboard",
		scheduleGuideAccessingStep2:
			'Click on "Schedules" in the main navigation menu',
		scheduleGuideAccessingStep3:
			"You'll see a comprehensive list of all schedules with their details",
		scheduleGuidePermissionTitle: "Permission Requirements",
		scheduleGuidePermissionText:
			'You need "VIEW_SCHEDULES" permission to see schedules and "MANAGE_SCHEDULES" permission to create, edit, or delete schedules. These permissions are establishment-specific, so you\'ll only see schedules for establishments you have access to.',
		scheduleGuideImagePlaceholder:
			"Image placeholder: Screenshot of the schedule management page showing the navigation and schedule list",

		scheduleGuideTypesTitle: "Understanding Schedule Types",
		scheduleGuideTypesText:
			"The system supports two distinct types of schedules, each designed for different teaching scenarios:",
		scheduleGuideTypesOptionsTitle: "Schedule Type Options",
		scheduleGuideGroupTitle: "Group Sessions",
		scheduleGuideGroupFeature1:
			"Capacity Control: Set maximum number of participants (1-50)",
		scheduleGuideGroupFeature2:
			"Class Management: Perfect for group classes and workshops",
		scheduleGuideGroupFeature3:
			"Enrollment Tracking: Monitor how many spots are filled",
		scheduleGuideGroupFeature4:
			"Waitlist Support: Handle overflow when classes are full",
		scheduleGuideIndividualTitle: "Individual Sessions",
		scheduleGuideIndividualFeature1:
			"One-on-One: Designed for personal training sessions",
		scheduleGuideIndividualFeature2:
			"No Capacity Limit: Always available for single customer",
		scheduleGuideIndividualFeature3:
			"Personalized Service: Focused attention and customized programs",
		scheduleGuideIndividualFeature4:
			"Flexible Scheduling: Easier to reschedule or modify",
		scheduleGuideTypesImportantNote: "Important Note",
		scheduleGuideTypesImportantText:
			"Schedule type cannot be changed after creation. Choose carefully based on how you plan to use the schedule. If you need to change the type, you'll need to create a new schedule and migrate existing enrollments.",
		scheduleGuideTypesImagePlaceholder:
			"Image placeholder: Comparison diagram showing group vs individual schedule types with their features",

		scheduleGuideRecurrenceTitle: "Recurrence Patterns",
		scheduleGuideRecurrenceText:
			"The system offers flexible recurrence options to accommodate different scheduling needs:",
		scheduleGuideRecurrenceTypesTitle: "Available Recurrence Types",
		scheduleGuideSingleTitle: "Single Session",
		scheduleGuideSingleFeature1:
			"One-time Event: Perfect for workshops, special events, or trial classes",
		scheduleGuideSingleFeature2:
			"Specific Date: Occurs only on the selected start date",
		scheduleGuideSingleFeature3: "No End Date: End date field is not required",
		scheduleGuideSingleFeature4:
			"Flexible Timing: Can be scheduled at any time",
		scheduleGuideWeeklyTitle: "Weekly Recurring",
		scheduleGuideWeeklyFeature1:
			"Regular Classes: Ideal for ongoing class schedules",
		scheduleGuideWeeklyFeature2:
			"Day Selection: Choose specific days of the week (Monday, Tuesday, etc.)",
		scheduleGuideWeeklyFeature3:
			"Date Range: Set start and end dates for the recurring period",
		scheduleGuideWeeklyFeature4:
			"Multiple Days: Can occur on multiple days per week",
		scheduleGuideDaySelectionTitle: "Day of Week Selection",
		scheduleGuideDaySelectionText:
			"For weekly recurring schedules, you can select multiple days of the week. The system will create sessions for each selected day within the specified date range.",
		scheduleGuideDaySelectionExample:
			"Example: A schedule set for Monday, Wednesday, and Friday from January 1st to March 31st will create sessions every Monday, Wednesday, and Friday during that period.",
		scheduleGuideEditingRestrictionsTitle: "Editing Restrictions",
		scheduleGuideEditingRestrictionsText:
			"Recurrence type cannot be changed after schedule creation. When editing schedules with existing enrollments, the number of selected days must remain the same to preserve enrollment limits and prevent conflicts.",
		scheduleGuideRecurrenceImagePlaceholder:
			"Image placeholder: Calendar view showing different recurrence patterns with example schedules",

		scheduleGuideCreatingTitle: "Creating New Schedules",
		scheduleGuideCreatingText:
			"Creating a new schedule involves configuring multiple sections to ensure all details are properly set up:",
		scheduleGuideCreatingStep1Title: "Step 1: Access the Creation Form",
		scheduleGuideCreatingStep1Text1:
			'Click the "Create New Schedule" button (+ icon) in the schedule management page',
		scheduleGuideCreatingStep1Text2:
			"You'll be taken to a comprehensive form with four main sections",
		scheduleGuideCreatingStep1Text3:
			"Each section is clearly labeled with icons and descriptions",
		scheduleGuideCreatingSection1Title: "Section 1: Basic Information",
		scheduleGuideCreatingSection1Subtitle:
			"Configure the basic details for your schedule",
		scheduleGuideCreatingSection1Feature1:
			'Schedule Name: Clear, descriptive name (e.g., "Morning Pilates", "Advanced Mat Class")',
		scheduleGuideCreatingSection1Feature2:
			"Description: Optional detailed description of the class content and level",
		scheduleGuideCreatingSection1Feature3:
			"Schedule Type: Choose between Group Session or Individual Session",
		scheduleGuideCreatingSection2Title: "Section 2: Location & Staff",
		scheduleGuideCreatingSection2Subtitle:
			"Select the establishment and staff member for this schedule",
		scheduleGuideCreatingSection2Feature1:
			"Establishment: Choose which location will host this schedule",
		scheduleGuideCreatingSection2Feature2:
			"Staff Member: Assign the instructor or staff member responsible",
		scheduleGuideCreatingSection2Feature3:
			"Note: Both fields are required and cannot be changed after creation",
		scheduleGuideCreatingSection3Title: "Section 3: Schedule Settings",
		scheduleGuideCreatingSection3Subtitle:
			"Configure timing, capacity, and date settings",
		scheduleGuideCreatingSection3Feature1:
			"Capacity: For group sessions, set maximum participants (1-50)",
		scheduleGuideCreatingSection3Feature2:
			"Start Time: Session start time in HH:MM format (e.g., 09:00)",
		scheduleGuideCreatingSection3Feature3:
			"End Time: Session end time in HH:MM format (e.g., 10:00)",
		scheduleGuideCreatingSection3Feature4:
			"Start Date: When the schedule begins (cannot be changed after creation)",
		scheduleGuideCreatingSection3Feature5:
			"End Date: For recurring schedules, when the pattern ends",
		scheduleGuideCreatingSection4Title: "Section 4: Recurrency & Configuration",
		scheduleGuideCreatingSection4Subtitle:
			"Set up recurrence pattern and additional notes",
		scheduleGuideCreatingSection4Feature1:
			"Recurrency Type: Single Session or Weekly (cannot be changed after creation)",
		scheduleGuideCreatingSection4Feature2:
			"Days of Week: For weekly schedules, select which days (Monday, Tuesday, etc.)",
		scheduleGuideCreatingSection4Feature3:
			"Notes: Optional additional information about the schedule",
		scheduleGuideValidationTitle: "Form Validation",
		scheduleGuideValidationSubtitle: "Validation Rules",
		scheduleGuideValidationRule1: "End time must be after start time",
		scheduleGuideValidationRule2:
			"End date must be after start date (for recurring schedules)",
		scheduleGuideValidationRule3:
			"At least one day must be selected for weekly recurring schedules",
		scheduleGuideValidationRule4: "Capacity is required for group sessions",
		scheduleGuideValidationRule5:
			"All time fields must be in valid HH:MM format",
		scheduleGuideCreatingImagePlaceholder:
			"Image placeholder: Screenshot of the schedule creation form showing all four sections",

		scheduleGuideListTitle: "Schedule List and Management",
		scheduleGuideListText:
			"The schedule list provides a comprehensive overview of all your schedules with detailed information and management options:",
		scheduleGuideListColumnsTitle: "Table Columns Overview",
		scheduleGuideListColumn1Title: "Name & Description",
		scheduleGuideListColumn1Text:
			"Schedule name with optional description displayed below",
		scheduleGuideListColumn2Title: "Type",
		scheduleGuideListColumn2Text:
			'Badge showing "Group Session" or "Individual Session"',
		scheduleGuideListColumn3Title: "Establishment",
		scheduleGuideListColumn3Text: "Location where the schedule takes place",
		scheduleGuideListColumn4Title: "Staff Member",
		scheduleGuideListColumn4Text: "Assigned instructor or staff member name",
		scheduleGuideListColumn5Title: "Time",
		scheduleGuideListColumn5Text:
			'Formatted time range (e.g., "09:00 - 10:00")',
		scheduleGuideListColumn6Title: "Recurrency",
		scheduleGuideListColumn6Text:
			"Recurrence type with selected days of week displayed below",
		scheduleGuideListColumn7Title: "Capacity",
		scheduleGuideListColumn7Text:
			'Maximum participants for group sessions or "Individual" for personal sessions',
		scheduleGuideListColumn8Title: "Status",
		scheduleGuideListColumn8Text:
			"Active (green) or Inactive (gray) status badge",
		scheduleGuideListActionsTitle: "Available Actions",
		scheduleGuideListEditTitle: "Edit Schedule",
		scheduleGuideListEditText:
			"Click the edit button (pencil icon) to modify schedule details. Note that some fields like type, establishment, and recurrence type cannot be changed after creation.",
		scheduleGuideListDeleteTitle: "Delete Schedule",
		scheduleGuideListDeleteText:
			"Click the delete button (trash icon) to permanently remove the schedule. A confirmation dialog will show potential impacts before deletion.",
		scheduleGuideListEmptyTitle: "Empty State",
		scheduleGuideListEmptyText:
			'When no schedules exist, the system displays a helpful empty state with a "Create Your First Schedule" button to get you started quickly.',
		scheduleGuideListImagePlaceholder:
			"Image placeholder: Screenshot of the schedule list showing different types of schedules and their information",

		scheduleGuideEditingTitle: "Editing Schedules",
		scheduleGuideEditingText:
			"Schedule editing provides flexibility while maintaining data integrity for existing enrollments:",
		scheduleGuideEditingAccessTitle: "Accessing Edit Mode",
		scheduleGuideEditingAccessStep1:
			"Click the edit button (pencil icon) next to any schedule in the list",
		scheduleGuideEditingAccessStep2:
			"You'll be taken to the schedule details page with edit as the default tab",
		scheduleGuideEditingAccessStep3:
			"The form is pre-filled with current schedule information",
		scheduleGuideEditingAccessStep4:
			"Some fields may be disabled to protect existing enrollments",
		scheduleGuideEditingFieldsTitle: "Editable vs. Protected Fields",
		scheduleGuideEditingEditableTitle: "Editable Fields",
		scheduleGuideEditingEditableField1: "Schedule name and description",
		scheduleGuideEditingEditableField2: "Staff member assignment",
		scheduleGuideEditingEditableField3: "Capacity (for group sessions)",
		scheduleGuideEditingEditableField4: "Start and end times",
		scheduleGuideEditingEditableField5:
			"End date (can be reduced with confirmation)",
		scheduleGuideEditingEditableField6: "Days of week (with restrictions)",
		scheduleGuideEditingEditableField7: "Notes and additional information",
		scheduleGuideEditingProtectedTitle: "Protected Fields",
		scheduleGuideEditingProtectedField1: "Schedule type (Group/Individual)",
		scheduleGuideEditingProtectedField2: "Establishment location",
		scheduleGuideEditingProtectedField3: "Start date",
		scheduleGuideEditingProtectedField4: "Recurrence type (Single/Weekly)",
		scheduleGuideEditingProtectedText:
			"These fields cannot be changed after schedule creation to maintain data consistency.",
		scheduleGuideEditingConfirmationTitle: "Change Confirmation System",
		scheduleGuideEditingConfirmationText:
			"When editing schedules with existing enrollments, certain changes require confirmation:",
		scheduleGuideEditingTimeChangesTitle: "Time and Day Changes",
		scheduleGuideEditingTimeChangesText:
			"Changing start/end times or days of week when customers are enrolled triggers a confirmation modal explaining the impact on existing enrollments.",
		scheduleGuideEditingEndDateTitle: "End Date Reduction",
		scheduleGuideEditingEndDateText:
			"Reducing the end date shows a warning that future sessions will be deleted while preserving existing session data and attendance records.",
		scheduleGuideEditingDayCountTitle: "Day Count Preservation",
		scheduleGuideEditingDayCountText:
			"For schedules with enrollments, the number of selected days must remain the same to preserve enrollment limits and prevent conflicts.",
		scheduleGuideEditingImagePlaceholder:
			"Image placeholder: Screenshot of the schedule edit form showing protected fields and confirmation dialogs",

		scheduleGuideDeletionTitle: "Schedule Deletion",
		scheduleGuideDeletionText:
			"Schedule deletion is a permanent action that requires careful consideration of its impact:",
		scheduleGuideDeletionProcessTitle: "Deletion Process",
		scheduleGuideDeletionProcessStep1:
			"Click the delete button (trash icon) next to the schedule you want to remove",
		scheduleGuideDeletionProcessStep2:
			"A confirmation modal will appear showing the schedule details",
		scheduleGuideDeletionProcessStep3:
			"The modal displays potential impacts and warnings",
		scheduleGuideDeletionProcessStep4:
			"Confirm the deletion to permanently remove the schedule",
		scheduleGuideDeletionImpactTitle: "Impact Assessment",
		scheduleGuideDeletionImpactText:
			"The deletion confirmation modal provides detailed information about what will be affected:",
		scheduleGuideDeletionImpact1:
			"Number of existing enrollments that will be removed",
		scheduleGuideDeletionImpact2:
			"Number of future sessions that will be canceled",
		scheduleGuideDeletionImpact3: "Attendance records that will be preserved",
		scheduleGuideDeletionImpact4: "Payment implications for affected customers",
		scheduleGuideDeletionImportantTitle: "Important Considerations",
		scheduleGuideDeletionImportant1:
			"Schedule deletion is permanent and cannot be undone",
		scheduleGuideDeletionImportant2:
			"All associated enrollments will be removed",
		scheduleGuideDeletionImportant3: "Future sessions will be canceled",
		scheduleGuideDeletionImportant4: "Historical attendance data is preserved",
		scheduleGuideDeletionImportant5:
			"Consider deactivating instead of deleting for temporary changes",
		scheduleGuideDeletionImagePlaceholder:
			"Image placeholder: Screenshot of the schedule deletion confirmation modal showing impact details",

		scheduleGuideDetailsTitle: "Schedule Details and Tabs",
		scheduleGuideDetailsText:
			"When you click the edit button on any schedule, you're taken to the schedule details page with comprehensive tabs for managing all aspects of the schedule:",
		scheduleGuideDetailsTabsTitle: "Tab Navigation Overview",
		scheduleGuideDetailsTabsText:
			"The schedule details page features a tabbed interface that provides access to different aspects of schedule management:",
		scheduleGuideDetailsEditTabTitle: "Edit Tab (Default)",
		scheduleGuideDetailsEditTabFeature1: "Modify schedule details and settings",
		scheduleGuideDetailsEditTabFeature2:
			"Update timing, capacity, and staff assignments",
		scheduleGuideDetailsEditTabFeature3: "Change descriptions and notes",
		scheduleGuideDetailsEditTabFeature4: "Protected fields are clearly marked",
		scheduleGuideDetailsSessionsTabTitle: "Sessions Tab",
		scheduleGuideDetailsSessionsTabFeature1:
			"View all generated sessions for the schedule",
		scheduleGuideDetailsSessionsTabFeature2:
			"See session dates, times, and attendance",
		scheduleGuideDetailsSessionsTabFeature3:
			"Access attendance management for each session",
		scheduleGuideDetailsSessionsTabFeature4:
			"Monitor session status and capacity",
		scheduleGuideDetailsEnrollmentsTabTitle: "Enrollments Tab",
		scheduleGuideDetailsEnrollmentsTabFeature1:
			"View all customers enrolled in this schedule",
		scheduleGuideDetailsEnrollmentsTabFeature2:
			"See enrollment details and status",
		scheduleGuideDetailsEnrollmentsTabFeature3:
			"Monitor enrollment capacity and availability",
		scheduleGuideDetailsEnrollmentsTabFeature4:
			"Access customer information and history",
		scheduleGuideDetailsMigrateTabTitle: "Migrate Enrollments Tab",
		scheduleGuideDetailsMigrateTabFeature1:
			"Move enrolled customers to other schedules",
		scheduleGuideDetailsMigrateTabFeature2: "Validate migration compatibility",
		scheduleGuideDetailsMigrateTabFeature3:
			"Handle schedule changes and closures",
		scheduleGuideDetailsMigrateTabFeature4:
			"Preserve customer enrollment history",
		scheduleGuideDetailsSessionsTitle: "Sessions Management",
		scheduleGuideDetailsSessionsText:
			"The Sessions tab provides a comprehensive view of all individual sessions generated from your schedule:",
		scheduleGuideDetailsSessionsInfoTitle: "Session Information Displayed",
		scheduleGuideDetailsSessionsInfo1:
			"Date & Time: Session date with start and end times",
		scheduleGuideDetailsSessionsInfo2:
			"Session Name: Inherited from schedule with optional description",
		scheduleGuideDetailsSessionsInfo3:
			"Type: Group or Individual session indicator with capacity info",
		scheduleGuideDetailsSessionsInfo4:
			"Status: Active, Inactive, or Canceled status badges",
		scheduleGuideDetailsSessionsInfo5:
			"Attendance: Current enrollment count vs. capacity",
		scheduleGuideDetailsSessionsInfo6:
			"Actions: Direct link to attendance management for each session",
		scheduleGuideDetailsEnrollmentsTitle: "Enrollments Overview",
		scheduleGuideDetailsEnrollmentsText:
			"The Enrollments tab shows all customers currently enrolled in the schedule:",
		scheduleGuideDetailsEnrollmentsDetailsTitle: "Enrollment Details",
		scheduleGuideDetailsEnrollmentsDetail1:
			"Customer Information: Names, contact details, and enrollment status",
		scheduleGuideDetailsEnrollmentsDetail2:
			"Enrollment Dates: Start and end dates for each enrollment",
		scheduleGuideDetailsEnrollmentsDetail3:
			"Plan Information: Associated customer plans and billing details",
		scheduleGuideDetailsEnrollmentsDetail4:
			"Attendance History: Links to individual customer attendance records",
		scheduleGuideDetailsImagePlaceholder:
			"Image placeholder: Screenshot of the schedule details page showing all four tabs and their content",

		scheduleGuideMigrationTitle: "Enrollment Migration System",
		scheduleGuideMigrationText:
			"The migration system allows you to move enrolled customers from one schedule to another, essential for handling schedule changes, closures, or reorganization:",
		scheduleGuideMigrationWhenTitle: "When to Use Migration",
		scheduleGuideMigrationWhen1:
			"Schedule Closure: Moving customers before deleting a schedule",
		scheduleGuideMigrationWhen2:
			"Instructor Changes: Transferring customers to a new instructor's schedule",
		scheduleGuideMigrationWhen3:
			"Time Changes: Moving customers when schedule times conflict with their availability",
		scheduleGuideMigrationWhen4:
			"Capacity Issues: Redistributing customers when reducing schedule capacity",
		scheduleGuideMigrationWhen5:
			"Location Changes: Moving customers to different establishment locations",
		scheduleGuideMigrationProcessTitle: "Migration Process Overview",
		scheduleGuideMigrationProcessStep1:
			'Access Migration: Click the "Migrate Enrollments" tab in schedule details',
		scheduleGuideMigrationProcessStep2:
			"Review Source: See current schedule information and enrolled customers",
		scheduleGuideMigrationProcessStep3:
			"Set Default Target: Choose a default destination schedule for all customers",
		scheduleGuideMigrationProcessStep4:
			"Customize Individual Targets: Optionally select different schedules for specific customers",
		scheduleGuideMigrationProcessStep5:
			"Validate Migrations: Run validation to check for conflicts and compatibility",
		scheduleGuideMigrationProcessStep6:
			"Review Results: Address any errors or warnings before proceeding",
		scheduleGuideMigrationProcessStep7:
			"Execute Migration: Complete the transfer of all enrollments",
		scheduleGuideMigrationFeaturesTitle: "Migration Features",
		scheduleGuideMigrationFeature1Title: "Default Target Selection",
		scheduleGuideMigrationFeature1Text:
			"Set a default destination schedule that applies to all customers, with the option to customize individual assignments.",
		scheduleGuideMigrationFeature2Title: "Individual Customization",
		scheduleGuideMigrationFeature2Text:
			"Each customer can be assigned to a different target schedule based on their specific needs or preferences.",
		scheduleGuideMigrationFeature3Title: "Validation System",
		scheduleGuideMigrationFeature3Text:
			"Comprehensive validation checks for schedule conflicts, capacity limits, and compatibility issues.",
		scheduleGuideMigrationFeature4Title: "Batch Processing",
		scheduleGuideMigrationFeature4Text:
			"All migrations are processed together to ensure consistency and prevent partial failures.",
		scheduleGuideMigrationValidationTitle: "Validation and Error Handling",
		scheduleGuideMigrationErrorTitle: "Error Conditions (Must Fix)",
		scheduleGuideMigrationError1: "Target schedule capacity would be exceeded",
		scheduleGuideMigrationError2:
			"Customer plan restrictions don't allow target schedule",
		scheduleGuideMigrationError3:
			"Schedule timing conflicts with other customer enrollments",
		scheduleGuideMigrationError4: "Target schedule is inactive or deleted",
		scheduleGuideMigrationWarningTitle: "Warning Conditions (Can Proceed)",
		scheduleGuideMigrationWarning1:
			"Different instructor than original schedule",
		scheduleGuideMigrationWarning2: "Different establishment location",
		scheduleGuideMigrationWarning3: "Different number of weekly sessions",
		scheduleGuideMigrationWarning4:
			"Time changes that might affect customer availability",
		scheduleGuideMigrationWorkflowTitle: "Migration Workflow",
		scheduleGuideMigrationWorkflowSubtitle: "Step-by-Step Process",
		scheduleGuideMigrationWorkflowStep1:
			"Source Review: View current schedule details and enrolled customers",
		scheduleGuideMigrationWorkflowStep2:
			"Target Selection: Choose destination schedules with detailed information display",
		scheduleGuideMigrationWorkflowStep3:
			"Validation: Run comprehensive checks for all proposed migrations",
		scheduleGuideMigrationWorkflowStep4:
			"Error Resolution: Fix any blocking errors before proceeding",
		scheduleGuideMigrationWorkflowStep5:
			"Confirmation: Review all changes and warnings",
		scheduleGuideMigrationWorkflowStep6:
			"Execution: Complete the migration with automatic rollback on failure",
		scheduleGuideMigrationImagePlaceholder:
			"Image placeholder: Screenshot of the migration interface showing source schedule, target selection, and validation results",

		enrollmentProcess: "Enrollment Process",
		enrollmentProcessDescription: "Enroll customers in classes and plans",
		attendanceTracking: "Attendance Tracking",
		attendanceTrackingDescription: "Monitor and manage class attendance",
		paymentProcessing: "Payment Processing",
		paymentProcessingDescription: "Handle billing and payment collection",
		reportsAnalytics: "Reports & Analytics",
		reportsAnalyticsDescription: "Generate insights and business reports",
		systemSettings: "System Settings",
		systemSettingsDescription: "Configure application preferences",
		supportTitle: "Contact Support",
		supportDescription:
			"Get help from our support team by submitting a support request",
		supportFormTitle: "Support Request Form",
		supportFieldTitle: "Subject",
		supportFieldDescription: "Description",
		supportPlaceholderTitle: "Brief description of your issue or question",
		supportPlaceholderDescription:
			"Please provide detailed information about your issue, including steps to reproduce if applicable",
		supportHintTitle:
			"Provide a clear, concise subject for your support request",
		supportHintDescription:
			"Include as much detail as possible to help us assist you quickly",
		supportCharacterCountTitle: "Subject",
		supportCharacterCountDescription: "Description",
		supportSubmit: "Send Support Request",
		supportSubmitting: "Sending...",
		supportSubmitSuccess:
			"Support request sent successfully! We'll get back to you soon.",
		supportSubmitError: "Failed to send support request. Please try again.",
		supportInfo: "Our support team will respond as soon as possible.",

		// Support form type field
		supportFieldType: "Type",
		supportPlaceholderType: "Select the type of your request",
		supportHintType: "Choose the category that best describes your request",
		supportTypeRequest: "Request",
		supportTypeSuggestion: "Suggestion",
		supportTypeComplaint: "Complaint",

		// Support ticket management
		commentSubmitting: "Adding comment...",
		commentSubmitSuccess: "Comment added successfully!",
		commentSubmitError: "Failed to add comment. Please try again.",

		// Support ticket statuses
		statusOpen: "Open",
		statusWaitingForUser: "Waiting for User",
		statusWaitingForStaff: "Waiting for Staff",
		statusResolved: "Resolved",
		statusClosed: "Closed",

		// Support tickets list
		myTicketsDescription: "You have {{count}} support tickets",
		noTickets: "No Support Tickets",
		noTicketsDescription:
			"You haven't submitted any support tickets yet. Create your first ticket to get help from our support team.",

		// Support ticket details
		ticketDetails: "Ticket Details",
		ticketInformation: "Ticket Information",
		comments: "Comments",
		noComments: "No comments yet",
		addComment: "Add Comment",
		commentPlaceholder: "Write your comment here...",
		you: "You",
		supportTeam: "Support Team",
		staff: "Staff",
		ticketDeleting: "Deleting support ticket...",
		ticketDeleteSuccess: "Support ticket deleted successfully!",
		ticketDeleteError: "Failed to delete support ticket. Please try again.",

		// Ticket status actions
		ticketCanceling: "Canceling ticket...",
		ticketCancelSuccess: "Ticket canceled successfully!",
		ticketCancelError: "Failed to cancel ticket. Please try again.",
		ticketResolving: "Resolving ticket...",
		ticketResolveSuccess: "Ticket resolved successfully!",
		ticketResolveError: "Failed to resolve ticket. Please try again.",
		ticketReopening: "Reopening ticket...",
		ticketReopenSuccess: "Ticket reopened successfully!",
		ticketReopenError: "Failed to reopen ticket. Please try again.",
		cancelTicket: "Cancel Ticket",
		resolveTicket: "Mark as Resolved",
		reopenTicket: "Reopen Ticket",
		cancelTicketConfirmTitle: "Cancel Support Ticket",
		cancelTicketConfirmDescription:
			"Are you sure you want to cancel this ticket? This will close the ticket without resolution.",
		resolveTicketConfirmTitle: "Resolve Support Ticket",
		resolveTicketConfirmDescription:
			"Are you sure you want to mark this ticket as resolved? This indicates your issue has been addressed.",

		// Attendance Tracking Page
		attendanceOverview: "Overview",
		attendanceOverviewDescription:
			"Attendance tracking is the central hub for monitoring and managing session attendance across your studio. It provides both calendar and list views of all sessions, comprehensive filtering options, and detailed session management capabilities. The system allows you to track customer attendance, manage session capacity, and maintain accurate records for reporting and billing.",
		attendanceKeyFeatures: "Key Features",
		attendanceKeyFeature1:
			"Dual view modes: Interactive calendar and detailed list views",
		attendanceKeyFeature2:
			"Advanced filtering by instructor, establishment, date range, and status",
		attendanceKeyFeature3:
			"Real-time attendance management with multiple status options",
		attendanceKeyFeature4:
			"Session capacity monitoring and enrollment tracking",
		attendanceKeyFeature5:
			"Customer addition for trial classes and repositions",

		attendanceAccessing: "Accessing Attendance Tracking",
		attendanceAccessingDescription:
			"To access the attendance tracking section:",
		attendanceAccessingStep1: "Navigate to your organization dashboard",
		attendanceAccessingStep2:
			'Click on "Attendance" in the main navigation menu',
		attendanceAccessingStep3:
			"You'll see the attendance overview with calendar view as default",
		attendanceAccessingStep4:
			"Use the view toggle to switch between calendar and list modes",
		attendancePermissionRequirements: "Permission Requirements",
		attendancePermissionDescription:
			'You need "VIEW_ATTENDANCE" permission to see attendance data and "MANAGE_ATTENDANCE" permission to modify attendance records. These permissions are establishment-specific, so you\'ll only see sessions for establishments you have access to.',
		attendanceImagePlaceholder1:
			"Image placeholder: Screenshot of the attendance tracking main page showing calendar and list view options",

		attendanceViewModes: "View Modes",
		attendanceViewModesDescription:
			"The attendance tracking system offers two distinct view modes, each optimized for different use cases:",
		attendanceCalendarView: "Calendar View",
		attendanceCalendarViewTitle: "Interactive Calendar Interface",
		attendanceCalendarFeature1:
			"Week View: Detailed weekly schedule with time slots and session details",
		attendanceCalendarFeature2:
			"Month View: Monthly overview showing all sessions at a glance",
		attendanceCalendarFeature3:
			"Color-coded Sessions: Each instructor has a unique color for easy identification",
		attendanceCalendarFeature4:
			"Session Information: Hover or click to see session details, capacity, and attendance",
		attendanceCalendarFeature5:
			"Navigation Controls: Easy navigation between weeks/months with today button",

		attendanceListView: "List View",
		attendanceListViewTitle: "Detailed Session Listings",
		attendanceListFeature1:
			"Table Format: Comprehensive table with sortable columns",
		attendanceListFeature2:
			"Card Format: Visual card layout with session highlights",
		attendanceListFeature3:
			"Detailed Information: Date, time, instructor, location, capacity, and status",
		attendanceListFeature4:
			"Sorting Options: Sort by date, session name, instructor, or attendance",
		attendanceListFeature5:
			"Pagination: Efficient handling of large session lists",

		attendanceViewModeSelection: "View Mode Selection",
		attendanceViewModeFeature1:
			"Toggle Buttons: Easy switching between calendar and list views",
		attendanceViewModeFeature2:
			"Persistent Selection: Your preferred view mode is remembered",
		attendanceViewModeFeature3:
			"Context-Appropriate: Calendar for scheduling overview, list for detailed management",
		attendanceViewModeFeature4:
			"Responsive Design: Both views adapt to different screen sizes",
		attendanceImagePlaceholder2:
			"Image placeholder: Side-by-side comparison of calendar view and list view interfaces",

		attendanceFiltering: "Filtering and Search",
		attendanceFilteringDescription:
			"Powerful filtering options help you find specific sessions and focus on relevant data:",
		attendanceInstructorFilter: "Instructor Filter",
		attendanceInstructorFilterTitle: "Multi-Select Instructor Filtering",
		attendanceInstructorFeature1:
			"Multi-Selection: Select multiple instructors simultaneously",
		attendanceInstructorFeature2:
			"Color Indicators: Each instructor has a unique color for visual identification",
		attendanceInstructorFeature3:
			"Select All/Deselect All: Quick options for bulk selection",
		attendanceInstructorFeature4:
			"Selected Count Display: Shows how many instructors are currently selected",
		attendanceInstructorFeature5:
			"Real-time Filtering: Sessions update immediately as you change selections",

		attendanceAdvancedFilters: "Advanced Filters",
		attendanceAdvancedFiltersTitle: "Comprehensive Filter Options",
		attendanceAdvancedFeature1:
			"Date Range: Filter sessions by start and end dates",
		attendanceAdvancedFeature2:
			"Establishment: Show sessions from specific locations only",
		attendanceAdvancedFeature3:
			"Schedule Type: Filter by group sessions or individual sessions",
		attendanceAdvancedFeature4:
			"Session Status: Active, canceled, or all sessions",
		attendanceAdvancedFeature5:
			"Staff Member: Filter by specific instructor assignments",

		attendanceFilterManagement: "Filter Management",
		attendanceFilterFeature1:
			"Filter Dialog: Dedicated modal for setting multiple filters",
		attendanceFilterFeature2:
			"Active Filter Count: Visual indicator showing number of active filters",
		attendanceFilterFeature3:
			"Reset Filters: Quick option to clear all filters and return to defaults",
		attendanceFilterFeature4:
			"Apply/Cancel: Preview filter changes before applying them",
		attendanceImagePlaceholder3:
			"Image placeholder: Screenshot of the filter dialog showing all available filter options",

		attendanceSessionDetails: "Session Details and Management",
		attendanceSessionDetailsDescription:
			"Clicking on any session opens the detailed session management interface where you can view comprehensive session information and manage attendance:",
		attendanceSessionInformation: "Session Information Display",
		attendanceSessionInformationTitle: "Comprehensive Session Details",
		attendanceSessionInfoFeature1:
			"Date and Time: Session date with formatted start and end times",
		attendanceSessionInfoFeature2:
			"Instructor Information: Staff member name with color-coded indicator",
		attendanceSessionInfoFeature3:
			"Location Details: Establishment name and location information",
		attendanceSessionInfoFeature4:
			"Capacity Information: Current enrollment vs. maximum capacity",
		attendanceSessionInfoFeature5:
			"Session Description: Additional details about the session content",
		attendanceSessionInfoFeature6:
			"Notes: Special instructions or requirements for the session",

		attendanceListManagement: "Attendance List Management",
		attendanceListManagementTitle: "Real-time Attendance Tracking",
		attendanceListManagementFeature1:
			"Customer List: All enrolled customers with their attendance status",
		attendanceListManagementFeature2:
			"Status Management: Change attendance status with dropdown selectors",
		attendanceListManagementFeature3:
			"Real-time Updates: Changes are saved immediately and reflected across the system",
		attendanceListManagementFeature4:
			"Visual Indicators: Color-coded status icons for quick identification",
		attendanceListManagementFeature5:
			"Customer Information: Full names and identification details",

		attendanceAddingCustomers: "Adding Customers to Sessions",
		attendanceAddingCustomersTitle: "Customer Addition for Special Cases",
		attendanceAddingFeature1:
			"Add Customer Button: Quick access to add customers to the session",
		attendanceAddingFeature2:
			"Customer Search: Search by name or document number to find customers",
		attendanceAddingFeature3:
			"Multiple Selection: Add multiple customers simultaneously",
		attendanceAddingFeature4:
			"Status Assignment: Set initial attendance status for each added customer",
		attendanceAddingFeature5:
			"Reason Documentation: Record why customers were added (trial, reposition, etc.)",

		attendanceStatusIndicators: "Session Status Indicators",
		attendanceCapacityStatus: "Capacity Status",
		attendanceCapacityAvailable: "Available: Session has open spots",
		attendanceCapacityAlmostFull: "Almost Full: Near capacity (80%+ filled)",
		attendanceCapacityFull: "Full: At maximum capacity",
		attendanceSessionStatus: "Session Status",
		attendanceSessionActive: "Active: Session is running normally",
		attendanceSessionCanceled: "Canceled: Session has been canceled",
		attendanceSessionInactive: "Inactive: Session is temporarily disabled",
		attendanceImagePlaceholder4:
			"Image placeholder: Screenshot of the session details page showing session information and attendance list",

		attendanceStatusManagement: "Attendance Status Management",
		attendanceStatusManagementDescription:
			"The system provides multiple attendance status options to accurately track different types of customer participation:",
		attendanceAvailableStatuses: "Available Attendance Statuses",
		attendanceStatusConfirmed: "Confirmed",
		attendanceStatusConfirmedDescription:
			"Customer attended the session as planned. This is the standard status for regular attendance.",
		attendanceStatusTrial: "Trial",
		attendanceStatusTrialDescription:
			"Customer attended as a trial session. Used for prospective customers trying out the studio before enrollment.",
		attendanceStatusReposition: "Reposition",
		attendanceStatusRepositionDescription:
			"Customer attended this session as a makeup for a missed session. Used for schedule changes and make-up classes.",
		attendanceStatusCanceled: "Canceled",
		attendanceStatusCanceledDescription:
			"Customer did not attend the session. Used for no-shows, cancellations, or absences.",

		attendanceStatusChangeProcess: "Status Change Process",
		attendanceStatusChangeStep1: "Navigate to the session details page",
		attendanceStatusChangeStep2: "Locate the customer in the attendance list",
		attendanceStatusChangeStep3:
			"Click on the status dropdown next to their name",
		attendanceStatusChangeStep4: "Select the appropriate new status",
		attendanceStatusChangeStep5:
			"The change is saved automatically and immediately reflected",

		attendanceStatusChangeImplications: "Status Change Implications",
		attendanceStatusImplication1:
			"Billing Impact: Different statuses may affect billing and payment processing",
		attendanceStatusImplication2:
			"Reporting: Status changes are reflected in attendance reports and analytics",
		attendanceStatusImplication3:
			"Capacity Management: Canceled attendance may free up spots for other customers",
		attendanceStatusImplication4:
			"Customer History: All status changes are tracked in customer attendance history",

		attendanceBulkStatusManagement: "Bulk Status Management",
		attendanceBulkStatusTitle: "Efficient Status Updates",
		attendanceBulkFeature1:
			"Individual Updates: Change status for each customer individually",
		attendanceBulkFeature2:
			"Real-time Saving: Changes are saved immediately without form submission",
		attendanceBulkFeature3:
			"Visual Feedback: Loading indicators during status updates",
		attendanceBulkFeature4:
			"Error Handling: Clear error messages if status changes fail",
		attendanceImagePlaceholder5:
			"Image placeholder: Screenshot showing the attendance status dropdown options and color-coded status indicators",

		// Customer Management Page
		customerOverview: "Overview",
		customerOverviewDescription:
			"Customer management is the foundation of your Pilates studio operations. This comprehensive system allows you to maintain detailed customer profiles, track their progress, manage medical records, and handle enrollments efficiently.",
		customerKeyBenefits: "Key Benefits",
		customerBenefit1: "Centralized customer information management",
		customerBenefit2: "Comprehensive medical history tracking",
		customerBenefit3: "Streamlined enrollment processes",
		customerBenefit4: "Advanced search and filtering capabilities",

		customerAccessing: "Accessing Customer Management",
		customerAccessingDescription: "To access the customer management section:",
		customerAccessingStep1: "Navigate to your organization dashboard",
		customerAccessingStep2: 'Click on "Customers" in the main navigation menu',
		customerAccessingStep3:
			"You'll see the customer list with search and filtering options",
		customerImagePlaceholder1:
			"Image placeholder: Screenshot of the main navigation showing the Customers menu item",

		customerListOverview: "Customer List Overview",
		customerListDescription:
			"The customer list provides a comprehensive view of all your customers with the following features:",
		customerSearchFilter: "Search & Filter",
		customerSearchFeature1: "Real-time search by name, email, or phone",
		customerSearchFeature2: "Debounced search (500ms delay) for performance",
		customerSearchFeature3: "Search results update automatically",
		customerPagination: "Pagination",
		customerPaginationFeature1: "Configurable page sizes (10, 25, 50, 100)",
		customerPaginationFeature2: "Navigation between pages",
		customerPaginationFeature3: "Total count display",
		customerImagePlaceholder2:
			"Image placeholder: Screenshot of the customer list showing search bar, pagination, and customer table",

		customerAddingNew: "Adding New Customers",
		customerAddingDescription:
			"Creating a new customer profile is straightforward and comprehensive:",
		customerStep1: "Step 1: Access the Creation Form",
		customerStep1Detail1:
			'Click the "Add Customer" button (+ icon) in the customer list',
		customerStep1Detail2:
			"You'll be redirected to the customer registration form",
		customerStep2: "Step 2: Fill Required Information",
		customerBasicInfo: "Basic Information",
		customerBasicInfo1: "First Name (required)",
		customerBasicInfo2: "Last Name (required)",
		customerBasicInfo3: "Email address",
		customerBasicInfo4: "Phone number",
		customerBasicInfo5: "Date of birth",
		customerBasicInfo6: "Gender",
		customerIdentification: "Identification",
		customerIdentification1: "ID Type (CPF, RG, Passport, etc.)",
		customerIdentification2: "ID Number",
		customerIdentification3: "CPF validation (Brazilian tax ID)",
		customerStep3: "Step 3: Address Information",
		customerSmartAddressLookup: "Smart Address Lookup",
		customerSmartAddressDescription:
			"Enter a valid Brazilian postal code (CEP) and the system will automatically fill in the address details including street, neighborhood, city, and state.",
		customerAddressField1: "Postal Code (CEP) - triggers automatic lookup",
		customerAddressField2: "Street Address",
		customerAddressField3: "Address Number",
		customerAddressField4: "Complement (apartment, suite, etc.)",
		customerAddressField5: "Neighborhood",
		customerAddressField6: "City and State (auto-filled)",
		customerStep4: "Step 4: Additional Information",
		customerAdditionalInfo1: "Emergency contact name and phone",
		customerAdditionalInfo2: "Notes (any additional information)",
		customerAdditionalInfo3: "Customer status (Active/Inactive)",
		customerImagePlaceholder3:
			"Image placeholder: Screenshot of the customer registration form showing all sections",

		customerSearching: "Searching and Finding Customers",
		customerSearchingDescription:
			"The search functionality is designed to help you quickly find customers:",
		customerSearchCapabilities: "Search Capabilities",
		customerSearchCapability1:
			"Name Search: Search by first name, last name, or full name",
		customerSearchCapability2:
			"Email Search: Find customers by their email address",
		customerSearchCapability3: "Phone Search: Search using phone numbers",
		customerSearchCapability4: "Partial Matching: Results appear as you type",
		customerSearchCapability5:
			"Case Insensitive: Search works regardless of capitalization",
		customerSearchTips: "Search Tips",
		customerProTips: "Pro Tips",
		customerSearchTip1: "Use partial names for broader results",
		customerSearchTip2: "Search resets pagination to page 1",
		customerSearchTip3: "Clear search to see all customers",
		customerSearchTip4: "Search has a 500ms delay to improve performance",
		customerImagePlaceholder4:
			"Image placeholder: Screenshot showing the search bar with example search results",

		customerEditing: "Editing Customer Information",
		customerEditingDescription:
			"Customer information can be updated at any time through the edit interface:",
		customerAccessingEditMode: "Accessing Edit Mode",
		customerEditStep1: "Click on any customer row in the customer list",
		customerEditStep2: "You'll be taken to the customer details page",
		customerEditStep3: "The page opens in edit mode by default",
		customerEditStep4:
			"All fields are editable and follow the same validation rules as creation",
		customerEditFeatures: "Edit Features",
		customerEditFeature1: "All customer information can be modified",
		customerEditFeature2:
			"Address lookup still works when changing postal codes",
		customerEditFeature3: "Form validation ensures data integrity",
		customerEditFeature4: "Changes are saved immediately upon submission",
		customerEditFeature5: "Success/error messages provide feedback",
		customerPermissionRequirements: "Permission Requirements",
		customerPermissionDescription:
			'You need the "MANAGE_CUSTOMERS" permission to edit customer information. Users with view-only access can see customer details but cannot make changes.',
		customerImagePlaceholder5:
			"Image placeholder: Screenshot of the customer edit form with highlighted editable fields",

		customerDetailsNavigation: "Customer Details and Navigation",
		customerDetailsDescription:
			"The customer details page provides comprehensive information organized in tabs:",
		customerAvailableTabs: "Available Tabs",
		customerProfileTab: "Profile Tab (Default)",
		customerProfileTabDescription:
			"Edit customer's personal information, contact details, and address",
		customerMedicalRecordsTab: "Medical Records Tab",
		customerMedicalRecordsTabDescription:
			"View and manage comprehensive medical history and health records",
		customerEnrollmentsTab: "Enrollments Tab",
		customerEnrollmentsTabDescription:
			"View current and past enrollments in classes and programs",
		customerPaymentsTab: "Payments Tab",
		customerPaymentsTabDescription:
			"Track payment history and manage billing information",
		customerImagePlaceholder6:
			"Image placeholder: Screenshot of customer details page showing tab navigation",

		customerMedicalRecordsManagement: "Medical Records Management",
		customerMedicalRecordsDescription:
			"Comprehensive medical record management helps you maintain detailed health information for each customer:",
		customerRecordTypesAvailable: "Record Types Available",
		customerAnamnesis: "Anamnesis",
		customerAnamnesisDescription:
			"Comprehensive patient history including medical background, medications, and lifestyle factors",
		customerPhysicalEvaluation: "Physical Evaluation",
		customerPhysicalEvaluationDescription:
			"Initial physical assessments and baseline measurements",
		customerPeriodicEvaluation: "Periodic Evaluation",
		customerPeriodicEvaluationDescription:
			"Regular progress assessments and updates",
		customerTreatmentPlans: "Treatment Plans",
		customerTreatmentPlansDescription:
			"Detailed treatment protocols and intervention strategies",
		customerAddingMedicalRecords: "Adding Medical Records",
		customerMedicalStep1: "Navigate to the customer's Medical Records tab",
		customerMedicalStep2: 'Click "Add Record" button',
		customerMedicalStep3: "Select the appropriate record type",
		customerMedicalStep4:
			"Fill in the record details including title and description",
		customerMedicalStep5:
			"Add specific medical information based on the record type",
		customerMedicalStep6: "Save the record",
		customerViewingManagingRecords: "Viewing and Managing Records",
		customerMedicalFeature1:
			"View detailed record information in modal dialogs",
		customerMedicalFeature2: "Edit existing records to update information",
		customerMedicalFeature3: "Delete records when no longer needed",
		customerMedicalFeature4: "Records are organized chronologically",
		customerMedicalFeature5:
			"Search and filter capabilities for large record sets",
		customerImagePlaceholder7:
			"Image placeholder: Screenshot of medical records tab showing record list and add record modal",

		customerDeletion: "Customer Deletion",
		customerDeletionDescription:
			"Customer deletion is a sensitive operation that requires proper permissions and confirmation:",
		customerDeletionProcess: "Deletion Process",
		customerDeletionStep1: "Locate the customer in the customer list",
		customerDeletionStep2:
			"Click the delete button (trash icon) in the Actions column",
		customerDeletionStep3: "Confirm the deletion in the confirmation dialog",
		customerDeletionStep4:
			"The customer will be permanently removed from the system",
		customerImportantConsiderations: "Important Considerations",
		customerDeletionWarning1:
			"Customer deletion is permanent and cannot be undone",
		customerDeletionWarning2:
			"All associated data (medical records, enrollments) will be removed",
		customerDeletionWarning3: 'Requires "MANAGE_CUSTOMERS" permission',
		customerDeletionWarning4:
			"Consider deactivating instead of deleting for data retention",

		// Customer Plans Page
		customerPlansOverview: "Overview",
		customerPlansOverviewDescription:
			"Customer plans are the foundation of your pricing strategy. They define what services you offer, how much you charge, and what features customers get access to. Plans can be customized with different billing cycles, session limits, and establishment restrictions.",
		customerPlansKeyFeatures: "Key Features",
		customerPlansFeature1:
			"Flexible pricing with multiple billing cycles (Monthly, Quarterly, Semi-Annual, Annual)",
		customerPlansFeature2:
			"Session limits to control usage and manage capacity",
		customerPlansFeature3:
			"Establishment-specific plans for multi-location businesses",
		customerPlansFeature4:
			"Rich feature descriptions to communicate value to customers",

		customerPlansAccessing: "Accessing Customer Plans",
		customerPlansAccessingDescription:
			"To access the customer plans management section:",
		customerPlansAccessingStep1: "Navigate to your organization dashboard",
		customerPlansAccessingStep2:
			'Click on "Customer Plans" in the main navigation menu',
		customerPlansAccessingStep3:
			"You'll see a list of all your existing plans or an empty state if none exist",
		customerPlansPermissionRequirements: "Permission Requirements",
		customerPlansPermissionDescription:
			'You need "VIEW_CUSTOMER_PLANS" permission to see plans and "MANAGE_CUSTOMER_PLANS" permission to create, edit, or delete plans. Contact your organization administrator if you don\'t see these options.',
		customerPlansImagePlaceholder1:
			"Image placeholder: Screenshot of the customer plans page showing the navigation and plan list",

		customerPlanStructure: "Plan Structure and Components",
		customerPlanStructureDescription:
			"Each customer plan consists of several key components that define its value and restrictions:",
		customerPlanBasicInfo: "Basic Information",
		customerPlanName: "Plan Name",
		customerPlanNameDescription:
			'Clear, descriptive name that customers will see (e.g., "Premium Monthly", "Student Plan")',
		customerPlanDescription: "Description",
		customerPlanDescriptionText:
			"Detailed explanation of what the plan includes and who it's designed for",
		customerPlanStatus: "Status",
		customerPlanStatusDescription:
			"Active plans are available for new enrollments; inactive plans are hidden",
		customerPlanServicesOffered: "Services Offered",
		customerPlanServicesDescription:
			"List of features and benefits included in the plan",
		customerPlanPricingBilling: "Pricing and Billing",
		customerPlanPriceCurrency: "Price and Currency",
		customerPlanPriceCurrencyDescription:
			"Set the price in Brazilian Real (BRL) or US Dollar (USD)",
		customerPlanBillingCycle: "Billing Cycle",
		customerPlanBillingCycleDescription:
			"Choose from Monthly, Quarterly, Semi-Annual, or Annual billing",
		customerPlanMonthlyAverage: "Monthly Average Display",
		customerPlanMonthlyAverageDescription:
			"For non-monthly plans, the system automatically shows the monthly equivalent",
		customerPlanSessionLimits: "Session Limits",
		customerPlanSessionLimitsDescription:
			"Optional weekly session limit (1-20 sessions) to control usage",
		customerPlanEstablishmentAccess: "Establishment Access",
		customerPlanAllEstablishments:
			"All Establishments: Plan can be used at any establishment in your organization",
		customerPlanSpecificEstablishments:
			"Specific Establishments: Restrict plan usage to selected locations",
		customerPlanMultiLocationSupport:
			"Multi-location Support: Perfect for businesses with multiple studios",
		customerPlansImagePlaceholder2:
			"Image placeholder: Diagram showing the different components of a customer plan",

		customerPlansCreating: "Creating New Customer Plans",
		customerPlansCreatingDescription:
			"Creating a new customer plan involves several steps to ensure all details are properly configured:",
		customerPlansStep1: "Step 1: Open the Creation Dialog",
		customerPlansStep1Detail1:
			'Click the "Create New Plan" button (+ icon) in the customer plans page',
		customerPlansStep1Detail2:
			"A comprehensive form dialog will open with multiple sections",
		customerPlansStep1Detail3:
			"The form is organized into logical sections for easy completion",
		customerPlansStep2: "Step 2: Basic Information Section",
		customerPlansRequiredFields: "Required Fields",
		customerPlansNameField:
			'Plan Name: Choose a clear, descriptive name (e.g., "Premium Monthly", "Student Discount")',
		customerPlansDescriptionField:
			"Description: Provide detailed information about what the plan includes",
		customerPlansTip:
			"Tip: Use descriptive names that clearly communicate the plan's value and target audience.",
		customerPlansStep3: "Step 3: Pricing & Billing Section",
		customerPlansPricingConfiguration: "Pricing Configuration",
		customerPlansPriceField:
			"Price: Enter the plan price (supports decimal values for precise pricing)",
		customerPlansCurrencyField:
			"Currency: Choose between Brazilian Real (BRL) or US Dollar (USD)",
		customerPlansBillingCycleField:
			"Billing Cycle: Select Monthly, Quarterly, Semi-Annual, or Annual",
		customerPlansSessionsLimitField:
			"Weekly Sessions Limit: Optional limit between 1-20 sessions per week",
		customerPlansMonthlyAverageNote:
			"Monthly Average: For non-monthly plans, the system automatically calculates and displays the monthly equivalent to help customers understand the value.",
		customerPlansStep4: "Step 4: Services Offered Section",
		customerPlansFeatureManagement: "Feature Management",
		customerPlansAddFeatures:
			'Add Features: Click "Add Feature" to include new services or benefits',
		customerPlansRemoveFeatures:
			"Remove Features: Use the X button to remove unwanted features",
		customerPlansMinimumRequirement:
			"Minimum Requirement: At least one feature is required",
		customerPlansExamples:
			'Examples: "Personal trainer consultation", "Premium equipment access", "Nutrition guidance"',
		customerPlansStep5: "Step 5: Establishments Section",
		customerPlansLocationAccess: "Location Access Control",
		customerPlansAllEstablishmentsOption:
			"All Establishments: Leave empty to allow usage at all locations",
		customerPlansSpecificEstablishmentsOption:
			"Specific Establishments: Select particular locations where the plan can be used",
		customerPlansMultiSelect:
			"Multi-select: Choose multiple establishments using checkboxes",
		customerPlansClearSelection:
			'Clear Selection: Use "Clear Establishments" to remove all selections',
		customerPlansStep6: "Step 6: Plan Status Section",
		customerPlansActivationControl: "Activation Control",
		customerPlansActivePlans:
			"Active Plans: Available for new customer enrollments",
		customerPlansInactivePlans:
			"Inactive Plans: Hidden from customers but existing enrollments continue",
		customerPlansDefault: "Default: New plans are active by default",
		customerPlansStep7: "Step 7: Save the Plan",
		customerPlansSaveStep1: "Review all information for accuracy",
		customerPlansSaveStep2: "Ensure all required fields are completed",
		customerPlansSaveStep3: 'Click "Create" to save the plan',
		customerPlansSaveStep4:
			"The plan will appear in your plans list immediately",
		customerPlansImagePlaceholder3:
			"Image placeholder: Screenshot of the customer plan creation dialog showing all form sections",

		customerPlansManaging: "Managing Existing Plans",
		customerPlansManagingDescription:
			"The customer plans list provides a comprehensive view of all your plans with management capabilities:",
		customerPlanListOverview: "Plan List Overview",
		customerPlanTableColumns: "Table Columns",
		customerPlanNameColumn: "Name: Plan name with credit card icon",
		customerPlanDescriptionColumn: "Description: Full plan description",
		customerPlanPriceColumn:
			"Price: Formatted price with monthly average for non-monthly plans",
		customerPlanBillingCycleColumn:
			"Billing Cycle: Monthly, Quarterly, Semi-Annual, or Annual",
		customerPlanAdditionalInfo: "Additional Information",
		customerPlanServicesColumn:
			"Services Offered: Feature badges with star icons",
		customerPlanEstablishmentsColumn:
			'Establishments: Location badges or "All Establishments"',
		customerPlanSessionsColumn:
			'Max Weekly Sessions: Session limit or "—" if unlimited',
		customerPlanStatusColumn: "Status: Active (green) or Inactive (gray) badge",
		customerPlanAvailableActions: "Available Actions",
		customerPlanEditAction: "Edit Plan",
		customerPlanEditDescription:
			"Click the edit button (pencil icon) to modify any aspect of the plan. The same form used for creation opens with current values pre-filled.",
		customerPlanDeleteAction: "Delete Plan",
		customerPlanDeleteDescription:
			"Click the delete button (trash icon) to permanently remove the plan. A confirmation dialog ensures you don't accidentally delete plans.",
		customerPlanDeletionRestrictions: "Deletion Restrictions",
		customerPlanDeletionRestrictionsDescription:
			"Customer plans with active enrollments cannot be deleted until all related enrollments are removed. Consider deactivating the plan instead to prevent new enrollments while preserving existing ones.",
		customerPlansImagePlaceholder4:
			"Image placeholder: Screenshot of the customer plans list showing different plan types and their information",

		customerPlansBillingCycles: "Billing Cycles and Pricing Strategy",
		customerPlansBillingCyclesDescription:
			"Understanding billing cycles helps you create effective pricing strategies that appeal to different customer segments:",
		customerPlansAvailableBillingCycles: "Available Billing Cycles",
		customerPlansMonthlyBilling: "Monthly",
		customerPlansMonthlyDescription:
			"Most flexible option for customers. Lower commitment, easier to budget monthly.",
		customerPlansQuarterlyBilling: "Quarterly (3 months)",
		customerPlansQuarterlyDescription:
			"Good balance between commitment and flexibility. Often used with small discounts.",
		customerPlansSemiAnnualBilling: "Semi-Annual (6 months)",
		customerPlansSemiAnnualDescription:
			"Medium-term commitment. Suitable for dedicated customers with moderate discounts.",
		customerPlansAnnualBilling: "Annual (12 months)",
		customerPlansAnnualDescription:
			"Highest commitment level. Best for loyal customers with significant discounts.",
		customerPlansMonthlyAverageDisplay: "Monthly Average Display",
		customerPlansMonthlyAverageFeature1:
			"For non-monthly plans, the system automatically calculates the monthly equivalent",
		customerPlansMonthlyAverageFeature2:
			"Helps customers understand the true monthly cost of longer-term plans",
		customerPlansMonthlyAverageFeature3:
			"Displayed in both the creation form and the plans list",
		customerPlansMonthlyAverageFeature4:
			"Makes it easier to compare plans with different billing cycles",
		customerPlansPricingStrategyTips: "Pricing Strategy Tips",
		customerPlansPricingTip1:
			"Offer discounts for longer billing cycles to encourage commitment",
		customerPlansPricingTip2:
			"Use monthly plans to attract price-sensitive customers",
		customerPlansPricingTip3: "Consider seasonal promotions with annual plans",
		customerPlansPricingTip4:
			"Test different price points to find optimal conversion rates",
		customerPlansImagePlaceholder5:
			"Image placeholder: Chart showing different billing cycles and their monthly equivalents",

		customerPlansSessionLimits: "Session Limits and Capacity Management",
		customerPlansSessionLimitsDescription:
			"Weekly session limits help you manage studio capacity and create tiered service offerings:",
		customerPlansUnderstandingSessionLimits: "Understanding Session Limits",
		customerPlansOptionalFeature:
			"Optional Feature: Session limits are not required for all plans",
		customerPlansRange: "Range: Set limits between 1-20 sessions per week",
		customerPlansEnforcement:
			"Enforcement: System prevents customers from booking beyond their limit",
		customerPlansFlexibility:
			"Flexibility: Limits reset weekly, allowing consistent usage patterns",
		customerPlansStrategicUses: "Strategic Uses for Session Limits",
		customerPlansCapacityManagement: "Capacity Management",
		customerPlansCapacityDescription:
			"Control studio utilization by limiting high-frequency users during peak times",
		customerPlansTieredPricing: "Tiered Pricing",
		customerPlansTieredDescription:
			"Create different service levels (Basic: 2 sessions, Premium: 5 sessions, Elite: unlimited)",
		customerPlansRevenueOptimization: "Revenue Optimization",
		customerPlansRevenueDescription:
			"Encourage customers to upgrade to higher-tier plans for more sessions",
		customerPlansFairAccess: "Fair Access",
		customerPlansFairAccessDescription:
			"Ensure all customers have reasonable access to popular class times",
		customerPlansCommonStrategies: "Common Session Limit Strategies",
		customerPlansExampleStructure: "Example Plan Structure",
		customerPlansStarterPlan:
			"Starter Plan: 2 sessions/week - Perfect for beginners",
		customerPlansRegularPlan:
			"Regular Plan: 4 sessions/week - Most popular option",
		customerPlansPremiumPlan:
			"Premium Plan: 8 sessions/week - For dedicated practitioners",
		customerPlansUnlimitedPlan:
			"Unlimited Plan: No limit - Premium pricing for unlimited access",
		customerPlansImplementationConsiderations: "Implementation Considerations",
		customerPlansMonitorUsage:
			"Monitor actual usage patterns to set realistic limits",
		customerPlansPeakHours: "Consider peak vs. off-peak hour policies",
		customerPlansCommunicateLimits:
			"Communicate limits clearly to customers during enrollment",
		customerPlansReviewAdjust:
			"Review and adjust limits based on studio capacity and demand",
		customerPlansImagePlaceholder6:
			"Image placeholder: Graph showing session usage patterns across different plan types",

		customerPlansMultiEstablishment: "Multi-Establishment Plans",
		customerPlansMultiEstablishmentDescription:
			"For organizations with multiple locations, establishment-specific plans provide flexible access control:",
		customerPlansEstablishmentAccessOptions: "Establishment Access Options",
		customerPlansAllEstablishmentsDefault: "All Establishments (Default)",
		customerPlansAllEstablishmentsFeature1:
			"Plan can be used at any establishment in your organization",
		customerPlansAllEstablishmentsFeature2:
			"Simplest option for most businesses",
		customerPlansAllEstablishmentsFeature3:
			"Customers have maximum flexibility",
		customerPlansAllEstablishmentsFeature4:
			"No additional configuration required",
		customerPlansSpecificEstablishmentsTitle: "Specific Establishments",
		customerPlansSpecificFeature1: "Restrict plan usage to selected locations",
		customerPlansSpecificFeature2:
			"Perfect for location-specific pricing strategies",
		customerPlansSpecificFeature3:
			"Useful for premium vs. standard location tiers",
		customerPlansSpecificFeature4: "Allows for targeted marketing campaigns",
		customerPlansUseCases: "Use Cases for Establishment Restrictions",
		customerPlansPremiumLocations: "Premium Locations",
		customerPlansPremiumDescription:
			"Create higher-priced plans for premium locations with better amenities",
		customerPlansGeographicPricing: "Geographic Pricing",
		customerPlansGeographicDescription:
			"Adjust pricing based on local market conditions and competition",
		customerPlansCapacityManagementMulti: "Capacity Management",
		customerPlansCapacityMultiDescription:
			"Direct traffic to less busy locations with location-specific discounts",
		customerPlansSpecializedServices: "Specialized Services",
		customerPlansSpecializedDescription:
			"Offer specialized equipment or services only at certain locations",
		customerPlansManagingAssignments: "Managing Establishment Assignments",
		customerPlansCheckboxInterface:
			"Use the checkbox interface to select multiple establishments",
		customerPlansBadgesDisplay:
			"Selected establishments appear as badges below the selector",
		customerPlansRemoveIndividual:
			"Remove individual establishments by clicking the X on their badge",
		customerPlansClearAll:
			'Use "Clear Establishments" to remove all selections and allow all locations',
		customerPlansBestPractices: "Best Practices",
		customerPlansStartSimple:
			"Start with all-establishment plans for simplicity",
		customerPlansAddRestrictions:
			"Add restrictions only when there's a clear business need",
		customerPlansCommunicateRestrictions:
			"Communicate location restrictions clearly to customers",
		customerPlansOfferBoth:
			"Consider offering both restricted and unrestricted plan options",
		customerPlansImagePlaceholder7:
			"Image placeholder: Map showing different establishments with plan access indicators",

		// Enrollment Process Page
		enrollmentProcessOverview: "Overview",
		enrollmentProcessOverviewDescription:
			"The enrollment process is the core workflow for connecting customers with your studio's services. It involves selecting a customer, choosing an appropriate plan, selecting schedules, and setting enrollment dates. The system provides comprehensive validation, conflict detection, and confirmation workflows to ensure smooth enrollments.",
		enrollmentProcessKeyFeatures: "Key Features",
		enrollmentProcessFeature1:
			"Multi-schedule enrollment support with bulk creation",
		enrollmentProcessFeature2:
			"Automatic plan compatibility validation and establishment filtering",
		enrollmentProcessFeature3:
			"Schedule overlap detection and weekly session limit enforcement",
		enrollmentProcessFeature4:
			"Automatic end date calculation based on billing cycles",
		enrollmentProcessFeature5:
			"Comprehensive confirmation workflow with detailed summaries",

		enrollmentProcessAccessing: "Accessing Enrollment Management",
		enrollmentProcessAccessingDescription:
			"To access the enrollment management section:",
		enrollmentProcessAccessingStep1: "Navigate to your organization dashboard",
		enrollmentProcessAccessingStep2:
			'Click on "Enrollments" in the main navigation menu',
		enrollmentProcessAccessingStep3:
			"You'll see a comprehensive list of all enrollments with search and filtering capabilities",
		enrollmentProcessAccessingStep4:
			'Use the "Create Enrollment" button to start new enrollments',
		enrollmentProcessPermissionRequirements: "Permission Requirements",
		enrollmentProcessPermissionDescription:
			'You need "MANAGE_ENROLLMENTS" permission to create, edit, or delete enrollments. This permission is organization-wide and allows you to manage enrollments across all establishments you have access to.',
		enrollmentProcessImagePlaceholder1:
			"Image placeholder: Screenshot of the enrollment management page showing the list and create button",

		enrollmentListManagement: "Enrollment List Management",
		enrollmentListManagementDescription:
			"The enrollment list provides a comprehensive overview of all customer enrollments with powerful search and management capabilities:",
		enrollmentListSearchFiltering: "Search and Filtering",
		enrollmentListRealTimeSearch:
			"Real-time Search: Search by customer name, email, or ID number",
		enrollmentListDebouncedInput:
			"Debounced Input: 300ms delay prevents excessive API calls",
		enrollmentListAutoPagination:
			"Auto-pagination Reset: Returns to first page when search changes",
		enrollmentListLoadingIndicators:
			"Loading Indicators: Visual feedback during search operations",
		enrollmentListTableInfo: "Table Information Display",
		enrollmentListCustomerInfo: "Customer Information",
		enrollmentListCustomerInfoDescription:
			"Full name, ID type, and ID number for easy identification",
		enrollmentListPlanDetails: "Plan Details",
		enrollmentListPlanDetailsDescription:
			"Plan name, pricing, billing cycle, and monthly averages",
		enrollmentListScheduleInfo: "Schedule Information",
		enrollmentListScheduleInfoDescription:
			"Schedule names, times, and recurrence patterns",
		enrollmentListEnrollmentStatus: "Enrollment Status",
		enrollmentListEnrollmentStatusDescription:
			"Active, Paused, Canceled, or Completed status with dates",
		enrollmentListAvailableActions: "Available Actions",
		enrollmentListEditAction: "Edit Enrollment",
		enrollmentListEditDescription:
			"Modify enrollment details, change plans, update schedules, or adjust dates",
		enrollmentListDeleteAction: "Delete Enrollment",
		enrollmentListDeleteDescription:
			"Remove enrollment with confirmation dialog showing impact on schedule sessions",
		enrollmentListPaginationPerformance: "Pagination and Performance",
		enrollmentListConfigurablePageSize:
			"Configurable Page Size: Adjust number of enrollments per page",
		enrollmentListPaginationControls:
			"Pagination Controls: Navigate through large enrollment lists",
		enrollmentListTotalCountDisplay:
			"Total Count Display: See total enrollments and current page info",
		enrollmentListOptimizedLoading:
			"Optimized Loading: Efficient data fetching with caching",
		enrollmentProcessImagePlaceholder2:
			"Image placeholder: Screenshot of the enrollment list showing search, table columns, and action buttons",

		enrollmentCreating: "Creating New Enrollments",
		enrollmentCreatingDescription:
			"The enrollment creation process is divided into four main sections, each with specific validation and features to ensure accurate and conflict-free enrollments:",
		enrollmentStep1: "Step 1: Customer Selection",
		enrollmentStep1Title: "Select the customer for this enrollment",
		enrollmentStep1Feature1:
			"Customer Search Modal: Advanced search by name, email, or ID number",
		enrollmentStep1Feature2:
			"Real-time Results: Instant search results with comprehensive customer details",
		enrollmentStep1Feature3:
			"Customer Information Display: Full name, contact details, and identification",
		enrollmentStep1Feature4:
			"Selection Confirmation: Clear display of selected customer with change option",
		enrollmentStep2: "Step 2: Customer Plan Selection",
		enrollmentStep2Title: "Choose the appropriate plan for this enrollment",
		enrollmentStep2Feature1:
			"Plan Information Display: Name, description, pricing, and billing cycle",
		enrollmentStep2Feature2:
			"Monthly Average Calculation: Automatic calculation for non-monthly plans",
		enrollmentStep2Feature3:
			"Weekly Session Limits: Display of session limits when applicable",
		enrollmentStep2Feature4:
			"Establishment Filtering: Plans filter available schedules based on establishment restrictions",
		enrollmentStep3: "Step 3: Schedule Selection",
		enrollmentStep3Title: "Select one or multiple schedules for the enrollment",
		enrollmentStep3Feature1:
			"Multi-Schedule Support: Select multiple schedules in create mode",
		enrollmentStep3Feature2:
			"Plan-Based Filtering: Only shows schedules allowed by selected plan",
		enrollmentStep3Feature3:
			"Schedule Information: Name, time, instructor, establishment, and capacity",
		enrollmentStep3Feature4:
			"Overlap Detection: Real-time validation for schedule time conflicts",
		enrollmentStep3Feature5:
			"Weekly Limit Validation: Ensures total sessions don't exceed plan limits",
		enrollmentStep4: "Step 4: Date and Details",
		enrollmentStep4Title: "Set enrollment period and additional information",
		enrollmentStep4Feature1:
			"Start Date: When the enrollment begins (required)",
		enrollmentStep4Feature2:
			"Auto-calculated End Date: Based on plan billing cycle and start date",
		enrollmentStep4Feature3:
			"Manual End Date Override: Option to manually set different end date",
		enrollmentStep4Feature4:
			"Status Selection: Active, Paused, Canceled, or Completed",
		enrollmentStep4Feature5:
			"Notes Field: Additional information about the enrollment",
		enrollmentProcessImagePlaceholder3:
			"Image placeholder: Screenshot of the enrollment creation form showing all four sections",

		enrollmentValidation: "Validation and Conflict Detection",
		enrollmentValidationDescription:
			"The system provides comprehensive validation to prevent conflicts and ensure enrollment integrity:",
		enrollmentScheduleOverlap: "Schedule Overlap Detection",
		enrollmentTimeConflictPrevention: "Time Conflict Prevention",
		enrollmentValidationFeature1:
			"Real-time Validation: Checks for overlapping schedule times as you select",
		enrollmentValidationFeature2:
			"Day-specific Conflicts: Detects conflicts on specific days of the week",
		enrollmentValidationFeature3:
			"Visual Indicators: Clear warnings when conflicts are detected",
		enrollmentValidationFeature4:
			"Submit Prevention: Blocks enrollment creation when conflicts exist",
		enrollmentWeeklyLimits: "Weekly Session Limits",
		enrollmentPlanLimitEnforcement: "Plan Limit Enforcement",
		enrollmentLimitFeature1:
			"Automatic Calculation: Counts total weekly sessions from selected schedules",
		enrollmentLimitFeature2:
			"Plan Limit Checking: Compares against customer plan's weekly session limit",
		enrollmentLimitFeature3:
			"Real-time Feedback: Shows current count vs. limit as you select schedules",
		enrollmentLimitFeature4:
			"Limit Exceeded Prevention: Prevents enrollment when limits are exceeded",
		enrollmentPlanCompatibility: "Plan Compatibility Validation",
		enrollmentEstablishmentFiltering: "Establishment Filtering",
		enrollmentCompatibilityFeature1:
			"Automatic Filtering: Only shows schedules from plan-allowed establishments",
		enrollmentCompatibilityFeature2:
			"All-Establishment Plans: Plans with no restrictions show all schedules",
		enrollmentCompatibilityFeature3:
			"Restricted Plans: Plans with establishment limits filter schedule options",
		enrollmentCompatibilityFeature4:
			"Dynamic Updates: Schedule list updates when plan selection changes",
		enrollmentFormValidation: "Form Validation Rules",
		enrollmentFormRule1:
			"Required Fields: Customer, plan, at least one schedule, and start date",
		enrollmentFormRule2:
			"Date Validation: End date must be after start date when manually set",
		enrollmentFormRule3:
			"Status Validation: Appropriate status selection for enrollment state",
		enrollmentFormRule4:
			"Notes Length: Optional notes field with reasonable character limits",
		enrollmentProcessImagePlaceholder4:
			"Image placeholder: Screenshot showing validation errors and conflict warnings in the enrollment form",

		enrollmentConfirmation: "Confirmation and Submission",
		enrollmentConfirmationDescription:
			"Before finalizing enrollments, the system provides a comprehensive confirmation workflow:",
		enrollmentConfirmationModal: "Enrollment Confirmation Modal",
		enrollmentConfirmationModalDescription:
			"For new enrollments, a detailed confirmation modal appears before final submission:",
		enrollmentConfirmationDetails: "Confirmation Details",
		enrollmentConfirmationFeature1:
			"Customer Summary: Full name, contact information, and identification",
		enrollmentConfirmationFeature2:
			"Plan Information: Selected plan with pricing and billing cycle details",
		enrollmentConfirmationFeature3:
			"Schedule Summary: All selected schedules with times and establishments",
		enrollmentConfirmationFeature4:
			"Date Range: Start and end dates with duration calculation",
		enrollmentConfirmationFeature5:
			"Total Weekly Sessions: Summary of weekly session count",
		enrollmentBulkCreation: "Bulk Enrollment Creation",
		enrollmentBulkCreationDescription:
			"When multiple schedules are selected, the system creates enrollments efficiently:",
		enrollmentBulkFeature1:
			"Single API Call: All enrollments created in one bulk operation",
		enrollmentBulkFeature2:
			"Atomic Operation: Either all enrollments succeed or none are created",
		enrollmentBulkFeature3:
			"Consistent Data: Same customer, plan, and date range for all schedules",
		enrollmentBulkFeature4:
			"Error Handling: Clear error messages if any enrollment fails",
		enrollmentSuccessError: "Success and Error Handling",
		enrollmentSuccessFlow: "Success Flow",
		enrollmentSuccessFlowDescription:
			"Success toast notification, automatic redirect to enrollment list, and cache invalidation for fresh data",
		enrollmentErrorHandling: "Error Handling",
		enrollmentErrorHandlingDescription:
			"Detailed error messages, form state preservation, and guidance for resolving issues",
		enrollmentSubmitButton: "Submit Button States",
		enrollmentDynamicButtonBehavior: "Dynamic Button Behavior",
		enrollmentButtonFeature1:
			"Disabled States: When validation errors exist or during submission",
		enrollmentButtonFeature2:
			"Loading Indicator: Spinner animation during API calls",
		enrollmentButtonFeature3:
			'Text Changes: "Create Enrollment" vs "Save" for create vs edit modes',
		enrollmentButtonFeature4:
			"Conflict Prevention: Disabled when schedule overlaps or limits exceeded",
		enrollmentProcessImagePlaceholder5:
			"Image placeholder: Screenshot of the enrollment confirmation modal showing all enrollment details",

		enrollmentEditing: "Editing Enrollments",
		enrollmentEditingDescription:
			"Enrollment editing provides flexibility while maintaining data integrity and preventing conflicts:",
		enrollmentEditModeDifferences: "Edit Mode Differences",
		enrollmentEditableFields: "Editable Fields",
		enrollmentEditableField1: "Customer plan selection",
		enrollmentEditableField2: "Schedule assignment (single selection)",
		enrollmentEditableField3: "Start and end dates",
		enrollmentEditableField4: "Enrollment status",
		enrollmentEditableField5: "Notes and additional information",
		enrollmentEditLimitations: "Edit Mode Limitations",
		enrollmentEditLimitation1: "Customer cannot be changed",
		enrollmentEditLimitation2: "Single schedule selection only",
		enrollmentEditLimitation3: "No confirmation modal required",
		enrollmentEditLimitation4: "Direct submission after validation",
		enrollmentStatusManagement: "Status Management",
		enrollmentAvailableStatusOptions: "Available Status Options",
		enrollmentStatusActive:
			"Active: Customer is actively enrolled and attending",
		enrollmentStatusPaused: "Paused: Temporary suspension of enrollment",
		enrollmentStatusCanceled:
			"Canceled: Enrollment terminated before completion",
		enrollmentStatusCompleted: "Completed: Enrollment finished successfully",
		enrollmentDataPreservation: "Data Preservation",
		enrollmentDataFeature1:
			"Form Pre-population: All current values loaded automatically",
		enrollmentDataFeature2:
			"Relationship Integrity: Maintains connections to schedules and plans",
		enrollmentDataFeature3:
			"History Preservation: Previous enrollment data remains intact",
		enrollmentDataFeature4:
			"Validation Consistency: Same validation rules as creation",
		enrollmentProcessImagePlaceholder6:
			"Image placeholder: Screenshot of the enrollment edit form showing pre-populated fields and status options",
	},
	import: {
		steps: {
			upload: "Upload",
			mapping: "Mapping",
			preview: "Preview",
			import: "Import",
		},
		customers: {
			title: "Import Customers",
			description:
				"Import customer data from a CSV file into your organization.",
		},
		upload: {
			title: "Upload CSV File",
			description: "Select a CSV file containing customer data to import.",
			dragDrop: "Drag and drop your CSV file here",
			supportedFormats: "Supported formats: CSV files up to 10MB",
			selectFile: "Select File",
			sampleTemplate: "Need a template?",
			sampleTemplateDescription:
				"Download our sample CSV template to see the expected format.",
			downloadTemplate: "Download Template",
			requirements: "File Requirements",
			requirement1: "First row must contain column headers",
			requirement2: "Required fields: First Name, Last Name",
			requirement3: "Maximum file size: 10MB",
			requirement4: "Supported format: CSV (.csv)",
			success: "File uploaded successfully",
			fileUploaded: "{{fileName}} ({{fileSize}} KB) uploaded successfully",
			uploadAnother: "Upload Another",
			processing: "Processing file...",
			processingDescription: "Please wait while we parse your CSV file.",
			errorTitle: "Upload Error",
			errors: {
				invalidFileType: "Please select a valid CSV file",
				fileTooLarge: "File size exceeds {{maxSize}}MB limit",
				parseError: "Failed to parse CSV: {{error}}",
				emptyFile: "The CSV file is empty or contains no data",
				noHeaders: "The CSV file must contain column headers",
				unknownError: "Unknown error",
				failedToParse: "Failed to parse CSV",
			},
		},
		template: {
			requiredFields: "Required fields",
			optionalFields: "Optional fields",
		},
		mapping: {
			title: "Map Columns",
			description: "Map the columns from your CSV file to customer fields.",
			instructions: "Column Mapping Instructions",
			instructionsDescription:
				"Match each column from your CSV file to the corresponding customer field. Required fields must be mapped to proceed.",
			requiredFieldsMissing: "Required Fields Missing",
			requiredFieldsDescription:
				"The following required fields must be mapped before you can continue:",
			missingFields: "Missing fields",
			columnMapping: "Column Mapping",
			csvColumn: "CSV Column",
			mapTo: "Map to Field",
			selectField: "Select a field...",
			skipColumn: "Skip this column",
			fieldDescription: "Description",
			noFieldSelected: "No field selected",
			sampleData: "Sample Data Preview",
			required: "Required",
			optional: "Optional",
			used: "(used)",
		},
		preview: {
			title: "Preview Import",
			description: "Review the data before importing to ensure accuracy.",
			startImport: "Start Import",
			totalRows: "Total Rows",
			validRows: "Valid Rows",
			invalidRows: "Invalid Rows",
			warningRows: "Warnings",
			invalidRowsFound: "Invalid Rows Found",
			skipInvalidRows: "Skip invalid rows during import",
			skipInvalidDescription:
				"Only valid rows will be imported. Invalid rows will be skipped.",
			includeInvalidDescription:
				"Import will fail if any invalid rows are found.",
			dataPreview: "Data Preview",
			showLess: "Show Less",
			showAll: "Show All ({{count}} rows)",
			row: "Row",
			status: "Status",
			issues: "Issues",
			noIssues: "No issues",
			confirmImport: {
				title: "Confirm Import",
				description: "Please review the import details before proceeding.",
				summary: "Import Summary",
				options: "Import Options",
				warning: "Import will fail with invalid rows",
				warningDescription:
					"You have chosen to include invalid rows. The import will fail if any errors are encountered.",
				confirm: "Start Import",
			},
		},
		validation: {
			required: "This field is required",
			invalidEmail: "Invalid email format",
			invalidPhone: "Invalid phone number format",
			invalidDate: "Invalid date format (use YYYY-MM-DD)",
			invalidEnum: "Invalid value. Valid options: {{validValues}}",
			invalidCPF: "Invalid CPF format",
		},
		processing: {
			title: "Importing Data",
			description: "Please wait while we import your customer data.",
			failed: "Import Failed",
			tryAgain: "Try Again",
			success: "Import Completed Successfully",
			partialSuccess: "Import Completed with Issues",
			totalProcessed: "Total Processed",
			imported: "Successfully Imported",
			errors: "Errors",
			skipped: "Skipped/Duplicates",
			issues: "Import Issues",
			copyErrors: "Copy Errors",
			downloadReport: "Download Report",
			errorsList: "Errors ({{count}})",
			duplicatesList: "Duplicates ({{count}})",
			row: "Row",
			errorMessage: "Error",
			field: "Field",
			value: "Value",
			existingCustomer: "Existing Customer",
			importAnother: "Import Another File",
			viewCustomers: "View Customers",
			reportHeaders: {
				type: "Type",
				row: "Row",
				issue: "Issue",
				data: "Data",
			},
			reportTypes: {
				error: "Error",
				duplicate: "Duplicate",
			},
			reportTitle: "Import Errors Report",
			reportSeparator: "===================",
			errorTemplate: "Error {{index}}: Row {{row}} - {{error}}",
		},
	},
	platformBilling: {
		title: "Subscription",
		description: "Manage your organization's subscription plan and billing",
		currentPlan: "Current Plan",
		changePlanButton: "Change Plan",
		selectPlan: "Select Plan",
		availablePlans: "Available Plans",
		usage: "Usage",
		history: "Billing History",
		noSubscription: "No active subscription",
		noSubscriptionDescription:
			"Choose a plan to unlock all features for your organization",
		billingCycle: {
			monthly: "Monthly",
			yearly: "Yearly",
			label: "Billing Cycle",
		},
		perMonth: "/month",
		perYear: "/year",
		yearlyDiscount: "Save {{percent}}%",
		features: "Features",
		entitlements: {
			max_establishments: "Establishments",
			max_staff_members: "Staff Members",
			max_customers: "Customers",
			max_schedules_per_month: "Schedules per Month",
			monthly_sms_limit: "SMS per Month",
			medical_records: "Medical Records",
			email_notifications: "Email Notifications",
			sms_notifications: "SMS Notifications",
			customer_import: "Customer Import",
			analytics_dashboard: "Analytics Dashboard",
			api_access: "API Access",
			custom_branding: "Custom Branding",
			priority_support: "Priority Support",
			unlimited: "Unlimited",
			included: "Included",
			notIncluded: "Not included",
		},
		status: {
			active: "Active",
			trialing: "Trial",
			pastDue: "Past Due",
			canceled: "Canceled",
			paused: "Paused",
			unpaid: "Unpaid",
			incomplete: "Incomplete",
			expired: "Expired",
		},
		subscription: {
			currentPeriod: "Current Period",
			endsOn: "Ends On",
			renewsOn: "Renews On",
			daysRemaining: "Days Remaining",
			days: "days",
			trialEndsOn: "Trial ends on {{date}}",
			canceledAt: "Canceled on {{date}}",
			willCancelOn: "Will cancel on {{date}}",
		},
		checkout: {
			loading: "Preparing checkout...",
			success: "Redirecting to checkout...",
			error: "Failed to start checkout. Please try again.",
			upgradeNow: "Upgrade Now",
			startTrial: "Start Free Trial",
			subscribe: "Subscribe",
		},
		portal: {
			loading: "Opening billing portal...",
			success: "Opening billing portal...",
			error: "Failed to open billing portal. Please try again.",
			manage: "Manage Billing",
			updatePayment: "Update Payment Method",
			viewInvoices: "View Invoices",
		},
		usageCard: {
			title: "Usage",
			description: "Track your current usage across plan features",
			of: "of",
			used: "used",
		},
		llmUsage: {
			title: "AI Usage",
			description: "Token usage from {{periodStart}} to {{periodEnd}}",
			tokensUsed: "Tokens Used",
			tokens: "tokens",
			byTaskType: "By Task Type",
			byProvider: "By Provider",
			noUsage: "No AI usage this billing period",
			taskTypes: {
				ANAMNESIS_SUMMARY: "Anamnesis Summary",
				SESSION_PLAN_SUGGESTION: "Session Plan Suggestion",
				CUSTOMER_WORKOUT_RECOMMENDATION: "Workout Recommendation",
			},
			providers: {
				openai: "OpenAI",
				anthropic: "Anthropic",
				bedrock: "AWS Bedrock",
			},
		},
		historyTable: {
			event: "Event",
			date: "Date",
			details: "Details",
			noHistory: "No billing history yet",
			events: {
				created: "Subscription Created",
				upgraded: "Plan Upgraded",
				downgraded: "Plan Downgraded",
				canceled: "Subscription Canceled",
				renewed: "Subscription Renewed",
				payment_failed: "Payment Failed",
				payment_succeeded: "Payment Succeeded",
				trial_started: "Trial Started",
				trial_ended: "Trial Ended",
				reactivated: "Subscription Reactivated",
			},
		},
		planCard: {
			current: "Current Plan",
			recommended: "Recommended",
			mostPopular: "Most Popular",
			trialAvailable: "{{days}} days free trial",
		},
		free: {
			name: "Free",
			description: "For individuals just getting started",
		},
		starter: {
			name: "Starter",
			description: "For small studios getting started",
		},
		professional: {
			name: "Professional",
			description: "For growing studios with more needs",
		},
		enterprise: {
			name: "Enterprise",
			description: "For large studios with custom needs",
		},
	},

	browserCompatibility: {
		title: "Outdated Browser Detected",
		message:
			"Your browser may not support all features of this application. Please update your browser for the best experience.",
	},
};

export default translations;
